webpackJsonp([1],{

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    allCheckboxesCompleted: function allCheckboxesCompleted() {
      // Check if all checkboxes are true
      return this.messageReadCheckboxes.every(function (checkbox) {
        return checkbox;
      });
    },
    isLastMessage: function isLastMessage() {
      // Check if the current message is the last one in the collection
      return this.messageIndex === this.messages.length - 1;
    }
  },
  filters: {
    formatDate: function formatDate(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD/MM/YYYY HH:mm');
    }
  },
  props: {
    showDialog: Boolean,
    message: String
  },
  data: function data() {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dialogVisible: false,
      messages: [],
      messageIndex: 0,
      messageReadCheckboxes: [],
      showGlobalMessage: false
    };
  },

  watch: {
    showDialog: {
      handler: function handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          // Get the messages from the database
          this.getGlobalMessages();
        }
      },

      immediate: true
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    },
    getGlobalMessages: function getGlobalMessages() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/getGlobalMessage.ajax.php', {
        company: this.company,
        empID: this.user.empID
      }).then(function (result) {
        if (result.data && Array.isArray(result.data) && result.data.length > 0) {
          _this.showGlobalMessage = true;
          _this.messages = result.data.map(function (message) {
            return {
              id: message.id,
              content: message.Message_Content,
              createdOn: message.Created_On,
              title: message.Message_Title
            };
          });
          _this.messageReadCheckboxes = Array(_this.messages.length).fill(false);
        } else {
          _this.showGlobalMessage = false;
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    nextMessage: function nextMessage() {
      if (this.messageIndex < this.messages.length - 1) {
        this.messageIndex++;
      } else {
        this.closeDialog();
      }
    },
    submitMessages: function submitMessages() {
      // Loop through messages and checkboxes to submit to the database
      for (var i = 0; i < this.messages.length; i++) {
        var message = this.messages[i];
        var checkbox = this.messageReadCheckboxes[i];

        if (checkbox === true) {
          this.markMessageAsSeen(message.id);
        }
      }

      // Close the dialog
      this.closeDialog();
    },
    markMessageAsSeen: function markMessageAsSeen(messageID) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/markMessageAsSeen.ajax.php', {
        empID: this.user.empID,
        company: this.company,
        globalMessageID: messageID
      }).then(function (result) {}).catch(function (error) {
        console.error('Error marking message as seen:', error);
      });
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dbPromise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_materialdesignicons_min_css__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_materialdesignicons_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['shiftID'],
  data: function data() {
    var _this = this;

    return {
      currentCurrency: this.$store.getters.currency,
      url: this.$store.getters.url,
      isLoading: false,
      emp: this.$store.getters.user.empID,
      company: this.$store.getters.company,
      errorDialog: false,
      errorText: '',
      unauthorisedDialog: false,
      sending: 0,
      snackbar: false,
      submitDialog: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000,
      newClaim: true,
      currentClaim: [],
      linkedShift: null,
      hideExpenseDropdown: false,
      currentItem: {
        cost: '',
        desc: '',
        type: '',
        photo: ''
      },
      expenseTypes: [],
      detailsDialog: false,
      detailsStepper: 1,
      detailsValid: false,
      locationsRules: [function (v) {
        return _this.taSettings && _this.taSettings.parking_location_provider && _this.taSettings.parking_location_provider.value === '2' ? !!v || 'Location is required' : true;
      }, function (v) {
        return !v || v.length <= 50 || 'Location must be less than 50 characters';
      }],
      providerRules: [function (v) {
        return _this.taSettings && _this.taSettings.parking_location_provider && _this.taSettings.parking_location_provider.value === '2' ? !!v || 'Provider is required' : true;
      }, function (v) {
        return !v || v.length <= 50 || 'Provider must be less than 50 characters';
      }],
      descRules: [function (v) {
        return !!v || 'Description is required';
      }, function (v) {
        return v && v.length <= 50 || 'Description must be less than 50 characters';
      }],
      currencyRules: [function (v) {
        return !!v || 'Cost is required';
      }],
      typeRules: [function (v) {
        return !!v || 'Expense Type is required';
      }],
      currencyDialog: false,
      currencies: {
        gbp: {
          desc: 'British Pound',
          text: '£',
          show: true
        },
        eur: {
          desc: 'Euro',
          text: '€',
          show: true
          // miles: {
          //   desc: 'Miles',
          //   text: 'M',
          //   show: true
          // }
          // pln: {
          //   desc: 'Polish Zloty',
          //   text: 'zł',
          //   show: true
          // },
          // all: {
          //   desc: 'Albanian Lek',
          //   text: 'L',
          //   show: true
          // },
          // azn: {
          //   desc: 'Azerbaijani manat',
          //   text: '₼'
          //  show: true
          // },
          // byn: {
          //   desc: 'Belarusian ruble',
          //   text: 'Br',
          //   show: true
          // },
        } },
      canEditExpense: true
    };
  },
  created: function created() {
    var _this2 = this;

    Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
      var tx = db.transaction('current-expenses');
      var currentExpenses = tx.objectStore('current-expenses');
      return currentExpenses.get(_this2.emp);
    }).then(function (val) {
      if (val !== undefined) {
        _this2.currentClaim = val;
      }
    });
    this.linkedShift = this.shiftID !== undefined ? this.shiftID : null;

    this.getExpenseTypes();

    if (this.company.toLowerCase() === 'lfp' || this.company.toLowerCase() === 'aquahaulage') {
      // this.expenseTypes.push('Mileage')
      this.currencies.miles = {
        desc: 'Miles',
        text: 'M',
        show: false
      };
    }

    if (this.currentCurrency.text === null || this.currentCurrency.text === undefined || this.currentCurrency.currency === null || this.currentCurrency.currency === undefined) {
      this.currentCurrency = {
        currency: 'gbp',
        text: '£'
      };
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('checkLoginTime');
  },

  computed: {
    taSettings: function taSettings() {
      return this.$store.getters.taSettings;
    },
    computedExpenseTypes: function computedExpenseTypes() {
      var output = [];
      for (var expense in this.expenseTypes) {
        var currentExpense = this.expenseTypes[expense];
        if (currentExpense.expense_name === 'Mileage' && !this.currentClaim.some(function (claim) {
          return claim.type === 'Mileage';
        }) && this.currentClaim.length > 0) {
          // LFP LOGIC - Mileage cannot be combined with other expense types, so if there is already an existing expense, hide the mileage option
          currentExpense.hidden = 1;
        }
        if (currentExpense.hidden === 0) {
          output.push(currentExpense);
        }
      }
      return output;
    },
    total: function total() {
      var total = 0;
      for (var claim in this.currentClaim) {
        total += this.currentClaim[claim].cost * 1;
      }
      return total;
    },
    hasClaim: function hasClaim() {
      return this.currentClaim.length > 0;
    },
    shiftArray: function shiftArray() {
      var shiftArray = [];
      this.$store.getters.timesheet.forEach(function (shift) {
        // if (shift.end !== undefined) {
        var text = __WEBPACK_IMPORTED_MODULE_4_moment___default()(shift.start).format('DD/MM/YYYY HH:mm') + ' - ' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(shift.end).format('DD/MM/YYYY HH:mm');
        var value = shift.id;
        shiftArray.push({ key: value, text: text });
        // }
      });
      shiftArray = shiftArray.reverse();
      return shiftArray;
    },
    claimContainsMileage: function claimContainsMileage() {
      var containsMileage = this.currentClaim.some(function (claim) {
        return claim.type === 'Mileage';
      });
      if (containsMileage) {
        this.setCurrency('miles');
      }
      return containsMileage;
    }
  },
  filters: {
    currency: function currency(value) {
      if (!value) return '0.00';
      value = value.toString();
      return parseFloat(value).toFixed(2);
    }
  },
  methods: {
    getExpenseTypes: function getExpenseTypes() {
      var _this3 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/getExpenseTypes.ajax.php', { company: this.company }).then(function (result) {
        _this3.isLoading = false;
        _this3.expenseTypes = result.data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    addClaim: function addClaim() {
      this.detailsDialog = true;
      this.currentItem.type = '';
    },
    setCurrency: function setCurrency(chosenCurrency) {
      this.currentCurrency.currency = chosenCurrency;
      this.currentCurrency.text = this.currencies[chosenCurrency]['text'];
      this.$store.dispatch('setCurrencyData', this.currentCurrency);
      this.currencyDialog = false;
    },
    checkDescription: function checkDescription() {
      var _this4 = this;

      if (this.currentItem.type !== 'Other') {
        this.currentItem.desc = '';
      }
      if (this.currentItem.type === 'Mileage') {
        this.setCurrency('miles');
      }

      // Find the matching expense type in computedExpenseTypes
      var matchedType = this.computedExpenseTypes.find(function (expense) {
        return expense.expense_name === _this4.currentItem.type;
      });
      console.log(matchedType.can_edit);
      if (matchedType && matchedType.default_value !== undefined) {
        this.currentItem.cost = matchedType.default_value;
      } else {
        this.currentItem.cost = '';
      }

      if (matchedType && (matchedType.can_edit === 1 || matchedType.can_edit === null)) {
        this.canEditExpense = true;
      } else {
        this.canEditExpense = false;
      }
    },
    gotoStep2: function gotoStep2() {
      if (this.$refs.form.validate()) {
        console.log(this.currentItem.type);
        var nonImageExpenses = ['Mileage', 'Nightout (Free)', 'Nightout (International)', 'Night Out Allownace', 'Meal Allowance A', 'Meal Allownace B', 'Overtime Meal Allowance'];
        if (!nonImageExpenses.includes(this.currentItem.type)) {
          this.detailsStepper = 2;
        } else {
          this.detailsStepper = 3;
        }
      }
    },
    triggerPick: function triggerPick() {
      document.getElementById('imagePicker').click();
    },
    saveImages: function saveImages(e) {
      var _this5 = this;

      var file = e.target.files[0];
      // let filename = Date.now() + '.jpg'
      var reader = new FileReader();
      if (file) {
        reader.readAsArrayBuffer(file);
        reader.onload = function (event) {
          var exif = _this5.getExifData(event.target.result);
          var c = document.getElementById('imageCanvas');
          var ctx = c.getContext('2d');
          var img = new Image();
          img.src = URL.createObjectURL(e.target.files[0]);
          img.onload = function () {
            if (exif > 4) {
              c.width = img.height;
              c.height = img.width;
              ctx.clearRect(0, 0, c.width, c.height);
              ctx.translate(img.height / 2, img.width / 2);
              if (exif > 6) {
                ctx.rotate(270 * Math.PI / 180);
              } else {
                ctx.rotate(90 * Math.PI / 180);
              }
              ctx.drawImage(img, -img.width / 2, -img.height / 2);
            } else {
              c.width = img.width;
              c.height = img.height;
              if (exif === 3 || exif === 4) {
                ctx.clearRect(0, 0, c.width, c.height);
                ctx.translate(img.width, img.height);
                ctx.rotate(180 * Math.PI / 180);
              }
              ctx.drawImage(img, 0, 0);
            }
            var cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50;
            cameraQuality = cameraQuality / 100;
            var base64data = c.toDataURL('image/jpeg', cameraQuality);
            _this5.currentItem.photo = base64data;
            _this5.detailsStepper = 3;
          };
        };
      }
    },
    addCurrentItem: function addCurrentItem() {
      var _this6 = this;

      this.isLoading = true;
      var filename = Date.now() + '.jpg';
      Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('image-store', 'readwrite');
        var imageStore = tx.objectStore('image-store');
        imageStore.put(_this6.currentItem.photo, filename);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
        _this6.isLoading = false;
        _this6.currentClaim.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          cost: _this6.currentItem.cost,
          desc: _this6.currentItem.desc,
          type: _this6.currentItem.type
        }, _this6.currentItem.type === 'Parking' ? {
          location: _this6.currentItem.location,
          provider: _this6.currentItem.provider
        } : {}, {
          photo: filename
        }));
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('current-expenses', 'readwrite');
          var currentExpenses = tx.objectStore('current-expenses');
          currentExpenses.put(_this6.currentClaim, _this6.emp);
          return tx.complete;
        }).then(function () {
          console.log('current expense saved');
        });

        _this6.currentItem = {
          cost: '',
          desc: '',
          type: '',
          photo: '',
          location: '',
          provider: '',
          currency: ''
        };
        _this6.detailsStepper = 1;
        _this6.detailsDialog = false;
      });
    },
    getExifData: function getExifData(image) {
      var view = new DataView(image);
      if (view.getUint16(0, false) !== 0xFFD8) return -2;
      var length = view.byteLength;
      var offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return -1;
          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) === 0x0112) {
              return view.getUint16(offset + i * 12 + 8, little);
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }
      return -1;
    },
    submitClaim: function submitClaim() {
      var _this7 = this;

      this.isLoading = true;
      var imagesToDelete = [];

      var _loop = function _loop(item) {
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('image-store');
          var imageStore = tx.objectStore('image-store');
          return imageStore.get(_this7.currentClaim[item].photo);
        }).then(function (val) {
          imagesToDelete.push(_this7.currentClaim[item].photo);
          if (!val) {
            val = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJVAA//Z';
            _this7.currentClaim[item].photo = 'no-image.jpg';
          }
          var imageData = val;
          var ref = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* storage */].ref(_this7.company + '/' + _this7.emp + '/' + _this7.currentClaim[item].photo);
          _this7.sending++;
          ref.putString(imageData, 'data_url').then(function (snap) {
            return snap.ref.getDownloadURL();
          }).then(function (downloadURL) {
            _this7.sending--;
            if (_this7.currentClaim[item].photo === 'no-image.jpg') {
              _this7.currentClaim[item].photo = '';
            } else {
              _this7.currentClaim[item].photo = downloadURL;
            }
            if (_this7.sending === 0) {
              var shiftStartTime = -1;
              if (_this7.linkedShift) {
                var shiftIndex = _this7.shiftArray.findIndex(function (shift) {
                  return shift.key === _this7.linkedShift;
                });
                var shiftArr = _this7.shiftArray[shiftIndex]['text'].split(' - ');
                shiftStartTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(shiftArr[0], 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss');
              }
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this7.url + '/tanda-service/saveExpenses.ajax.php', {
                company: _this7.company,
                emp: _this7.emp,
                data: _this7.currentClaim,
                shiftID: _this7.linkedShift,
                currency: _this7.currentCurrency.currency,
                shiftStartTime: shiftStartTime
              }).then(function (response) {
                Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
                  var tx = db.transaction('current-expenses', 'readwrite');
                  var currentExpenses = tx.objectStore('current-expenses');
                  return currentExpenses.delete(_this7.emp);
                }).then(function (val) {
                  imagesToDelete.forEach(function (image) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
                      var tx = db.transaction('image-store', 'readwrite');
                      var imageStore = tx.objectStore('image-store');
                      return imageStore.delete(image);
                    });
                  });
                  _this7.$router.push('/');
                });
              }).catch(function (error) {
                _this7.errorDialog = true;
                _this7.submitDialog = false;
                _this7.isLoading = false;
                _this7.errorText = error.message;
              });
            }
          }).catch(function (error) {
            if (error.code === 'storage/unauthorized') {
              _this7.unauthorisedDialog = true;
              _this7.submitDialog = false;
              _this7.isLoading = false;
            } else {
              _this7.errorText = error.message;
              _this7.errorDialog = true;
              _this7.submitDialog = false;
              _this7.isLoading = false;
            }
          });
        }).catch(function (error) {
          console.log(error);
          _this7.isLoading = false;
        });
      };

      for (var item in this.currentClaim) {
        _loop(item);
      }
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.push('/SignIn');
    }
  },
  watch: {
    'currentItem.type': function currentItemType(value, prevValue) {
      if (value !== 'Mileage' && this.currentCurrency.currency === 'miles' && value.length > 0) {
        this.currencyDialog = true;
      }
    }
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firedb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return storage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage__ = __webpack_require__(379);




// const app = initializeApp({
//   apiKey: 'AIzaSyCNeuJ4H9X6VHE_QCVeO7pFSX_ffHxXofs',
//   authDomain: 'project-bva.firebaseapp.com',
//   databaseURL: 'https://project-bva.firebaseio.com',
//   projectId: 'project-bva',
//   storageBucket: 'project-bva.appspot.com',
//   messagingSenderId: '318661371064'
// })

var app = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["initializeApp"]({
  apiKey: 'AIzaSyCYYQ4Kd8lESyw5f5HMetoDZWtE1PtqvwU',
  authDomain: 'project-ava-4acb7.firebaseapp.com',
  databaseURL: 'https://project-ava-4acb7.firebaseio.com',
  projectId: 'project-ava-4acb7',
  storageBucket: 'project-ava-4acb7.appspot.com',
  messagingSenderId: '987604944516'
});

var firedb = app.database();
var storage = app.storage();

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_materialdesignicons_min_css__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      company: this.$store.getters.company,
      currentCurrency: this.$store.getters.currency,
      url: this.$store.getters.url,
      expenses: [],
      filteredExpenses: [],
      filteredExpenseAudit: [],
      expensesAudit: [],
      selectedApproval: 'All',
      approvalStatuses: [{ text: 'All', value: 'All' }, { text: 'Accepted', value: 1 }, { text: 'Rejected', value: 0 }, { text: 'Not Actioned', value: null }]
    };
  },
  created: function created() {
    this.getExpenses();
  },

  computed: {
    taSettings: function taSettings() {
      return this.$store.getters.taSettings;
    }
  },
  methods: {
    currency: function currency(value, _currency) {
      if (!value) return '0.00';
      value = value.toString();
      if (_currency === 'miles') {
        return parseFloat(value / 100).toFixed(2);
      } else if (_currency === 'gbp') {
        return (parseFloat(value) / 100).toFixed(2);
      } else if (_currency === 'euro') {
        return (parseFloat(value) / 100).toFixed(2);
      } else {
        return value;
      }
    },
    getExpenses: function getExpenses() {
      var _this = this;

      var obj = { empID: this.$store.getters.user.empID, company: this.company };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/getExpenses.ajax.php', obj).then(function (response) {
        _this.expenses = response.data;
        _this.filteredExpenses = _this.expenses; // Initialize filtered expenses
        _this.getExpensesAudit();
      }).catch(function (e) {
        console.log(e);
      });
    },
    getExpensesAudit: function getExpensesAudit() {
      var _this2 = this;

      var obj = { empID: this.$store.getters.user.empID, company: this.company };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/getExpensesAudit.ajax.php', obj).then(function (response) {
        _this2.expensesAudit = response.data;
        _this2.filterAudit();
      }).catch(function (e) {
        console.log(e);
      });
    },
    formatDateTime: function formatDateTime(dateTime) {
      var date = new Date(dateTime);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      return day + '/' + month + '/' + year + ' - ' + hours + ':' + minutes;
    },
    viewImage: function viewImage(img) {
      window.open(img, '_blank');
    },
    getClassForCard: function getClassForCard(accepted) {
      if (accepted === 1) {
        return 'height:60px; border-bottom: solid 5px #008000; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;';
      } else if (accepted === 0) {
        return 'height:60px; border-bottom: solid 5px #B30000; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;';
      } else {
        return 'height:60px; border-bottom: solid 5px #808080; display: flex; flex-direction:column; justify-content: space-between; align-content: space-between;';
      }
    },
    actioned: function actioned(_actioned) {
      if (_actioned === 1) {
        return 'Accepted On';
      } else if (_actioned === 0) {
        return 'Rejected On';
      } else {
        return 'Not Actioned';
      }
    },
    colourForAction: function colourForAction(accepted) {
      if (accepted === 1) {
        return 'color: #008000;';
      } else if (accepted === 0) {
        return 'color: #B30000;';
      } else {
        return '';
      }
    },
    applyFilters: function applyFilters() {
      var _this3 = this;

      if (this.selectedApproval === 'All') {
        this.filteredExpenses = this.expenses;
      } else {
        this.filteredExpenses = this.expenses.filter(function (expense) {
          return expense.accepted === _this3.selectedApproval;
        });
      }
    },
    filterAudit: function filterAudit() {
      this.filteredExpenseAudit = [];
      var auditMap = {};
      this.expensesAudit.forEach(function (audit) {
        var claimId = audit.claim_id;
        if (!auditMap[claimId]) {
          auditMap[claimId] = {
            label: claimId,
            audits: []
          };
        }
        auditMap[claimId].audits.push(audit);
      });
      this.filteredExpenseAudit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(auditMap);
      console.log(this.filteredExpenseAudit);
    }
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dbPromise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['intent'],
  data: function data() {
    return {
      lastStart: '',
      shiftStarted: false,
      empID: this.$store.getters.user.empID,
      company: this.$store.getters.company,
      dialogText: '',
      dialog: false,
      dialogTitle: ''
    };
  },

  computed: {
    timeSheetData: function timeSheetData() {
      return this.$store.getters.timesheet;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    timeSheetData: function timeSheetData(val) {
      this.isShiftStarted(this.timeSheetData);
    }
  },
  created: function created() {
    this.isShiftStarted(this.timeSheetData);
  },
  mounted: function mounted() {
    this.$store.dispatch('checkLoginTime');
  },

  methods: {
    getLocalData: function getLocalData() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('timesheet-archive');
        var timesheetStore = tx.objectStore('timesheet-archive');
        return timesheetStore.get(_this.empID);
      }).then(function (val) {
        if (val !== undefined) {
          _this.isShiftStarted(val);
        }
      });
    },
    saveDataLocal: function saveDataLocal(data) {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('timesheet-archive', 'readwrite');
        var timesheetStore = tx.objectStore('timesheet-archive');
        timesheetStore.put(data, _this2.empID);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    isShiftStarted: function isShiftStarted(data) {
      for (var day in data) {
        this.shiftStarted = false;
        if (typeof data[day].end === 'undefined') {
          this.shiftStarted = true;
          this.lastStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(data[day].start).format('DD/MM/YYYY HH:mm');
          break;
        }
      }
      if (this.shiftStarted === true && this.intent === 'in') {
        this.dialog = true;
        this.dialogText = 'You have started a shift that has not been finished, you need to Clock Out first.';
        this.dialogTitle = 'Shift already started.';
      } else if (this.shiftStarted === false && this.intent === 'out') {
        this.dialog = true;
        this.dialogText = 'You haven\'t started a shift yet, you need to Clock In first.';
        this.dialogTitle = 'Shift not started.';
      } else {
        this.dialog = false;
      }
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['taID'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dateConfirmed: false,
      loading: 0, // 0 - loading, 1 - loaded, 2 - error
      jobData: [],
      startTime: '',
      endTime: ''
    };
  },
  mounted: function mounted() {
    this.getJobDetails();
  },

  computed: {
    anyJobInProgress: function anyJobInProgress() {
      return this.jobData.some(function (job) {
        return job.end_time == null;
      });
    }
  },
  methods: {
    getJobDetails: function getJobDetails() {
      var _this = this;

      this.loading = 0;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/getCurrentJobList.ajax.php', {
        company: this.company,
        type: 'all',
        ta_id: this.taID,
        currentJobID: -1
      }).then(function (response) {
        _this.startTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(response.data.shiftDetails.start_time).format('YYYY-MM-DD HH:mm');
        _this.endTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(response.data.shiftDetails.end_time).format('YYYY-MM-DD HH:mm');
        _this.jobData = response.data.jobDetails;
        for (var job in response.data.jobDetails) {
          var currentJob = response.data.jobDetails[job];
          currentJob.start_time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format();
          if (currentJob.end_time == null) {
            _this.jobStarted = true;
            _this.latestJobId = currentJob.job_id;
          } else {
            currentJob.end_time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().format();
          }
        }
        _this.jobData.sort(function (a, b) {
          return new Date(b.start_time) - new Date(a.start_time);
        });
        _this.loading = 1;
      }).catch(function (e) {
        _this.loading = 2;
        console.log(e);
      });
    }
  },
  filters: {
    formattedJobLength: function formattedJobLength(job) {
      if (job.end_time == null) {
        return '';
      }
      var hrs = __WEBPACK_IMPORTED_MODULE_1_moment___default()(job.end_time).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(job.start_time), 'hours');
      var mins = __WEBPACK_IMPORTED_MODULE_1_moment___default()(job.end_time).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(job.start_time), 'minutes') % 60;
      console.log(job);
      console.log(hrs);
      return hrs + 'h ' + mins + 'm';
    },
    formatDate: function formatDate(val) {
      return val !== undefined && val !== null ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD/MM/YYYY') : '';
    },
    formatDateTime: function formatDateTime(val) {
      return val !== undefined && val !== null ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('DD/MM/YYYY HH:mm') : '';
    },
    filterJobTime: function filterJobTime(val) {
      if (val == null) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format('HH:mm');
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idb__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idb__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }],
      snackbar: false,
      snackbarText: '',
      cameraQuality: 0,
      company: this.$store.getters.company,
      server: localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com',
      applicationMode: localStorage.getItem('applicationMode') !== null && localStorage.getItem('applicationMode') !== undefined ? localStorage.applicationMode : 'tanda',
      signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0,
      secureMenuCode: null,
      secureMenu: false,
      long: localStorage.getItem('long') || null,
      lat: localStorage.getItem('lat') || null
    };
  },

  watch: {
    cameraQuality: function cameraQuality(val) {
      localStorage.setItem('cameraQuality', val);
    },
    secureMenuCode: function secureMenuCode(val) {
      if (val === '767883!@') {
        this.secureMenu = true;
      }
    },
    company: function company(val) {
      this.$store.dispatch('checkCompany', val);
    },
    server: function server(val) {
      this.$store.dispatch('setURL', val);
      localStorage.setItem('remoteServer', val);
    },
    lat: function lat(val) {
      localStorage.setItem('lat', val);
    },
    long: function long(val) {
      localStorage.setItem('long', val);
    },
    applicationMode: function applicationMode(val) {
      this.$store.dispatch('setApplicationMode', val);
      localStorage.setItem('applicationMode', val);
    }
  },
  created: function created() {
    this.cameraQuality = localStorage.getItem('cameraQuality') !== null && localStorage.getItem('cameraQuality') !== undefined ? localStorage.cameraQuality : 50;
  },

  methods: {
    resetApp: function resetApp() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('tanda-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    },
    clearApp: function clearApp() {
      var _this = this;

      this.snackbar = true;
      this.snackbarText = 'Clearing Data';
      __WEBPACK_IMPORTED_MODULE_1_idb___default.a.delete('tanda-db').then(function () {
        _this.snackbar = true;
        _this.snackbarText = 'Data Cleared';
      });
    },
    setSignoutInterval: function setSignoutInterval() {
      this.$store.dispatch('setSignoutInterval', this.signoutInterval);
      localStorage.setItem('signoutInterval', this.signoutInterval);
    }
  },
  computed: {
    showAppMode: function showAppMode() {
      var disabledCompanies = ['freshlinc'];
      if (this.company && disabledCompanies.indexOf(this.company.toLowerCase()) > -1) {
        return false;
      } else {
        return true;
      }
    }
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(69);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['company', 'emp'],
  data: function data() {
    return {
      value: '',
      companyValue: '',
      companyDialog: false,
      pinVisible: false,
      unauthorised: false,
      unauthorisedMsg: '',
      companyCharcodes: '',
      pinCharcodes: '',
      recoveryModal: false,
      recoveryOptions: false,
      maintLang: 'English',
      signingIn: false,
      maintText: {
        English: {
          title: 'Maintenance Mode',
          para1: 'The server is currently undergoing maintenance and functionality is limited to clocking in/out. Please use the folllowing options to submit your request.',
          para2preIcon: 'You will be able to attach expenses to a shift using this icon',
          para2postIcon: 'once the server is reachable again.'
        },
        Polskie: {
          title: 'SERWER W TRYBIE KONSERWACJI',
          para1: 'Serwer jest obecnie poddawany konserwacji I jego funkcjonalnosc jest ograniczona przy logowaniu do/z. Prosze uzyc nastepujacych opcji aby zatwierdzic Twoja prosbe.',
          para2preIcon: 'Bedziesz mogl dodac wszystkie rachunki ( wydatki ) do swojej zmiany uzywajac tej ikony',
          para2postIcon: 'tak szybko jak serwer bedzie ponownie dostepny.'
        },
        Română: {
          title: 'Modul de mentenanta',
          para1: 'In acest moment serverul este in modul de mentenanta. Functionalitatea de inregistrare in/out este limitata. Va rugam folositi urmatoarele optiuni pentru a va inregistra cererile.',
          para2preIcon: 'Veti avea posibilitatea sa atasati chitantele cu cheltuielite avute folosind icoana',
          para2postIcon: 'de indata ca serverul va fi functional iarasi.'
        },
        Lietuvis: {
          title: 'Prieziuros Rezimas',
          para1: 'Serveriui laikinai atliekama technine apziura, todel naudojimas yra ribotas norint isiregistruoti/issiregistruoti. Prasome naudotis zemiau pateikta parinktimi  norint pateikti uzklausa.',
          para2preIcon: 'Galesite prideti islaidas pamainos metu pasirinke piktograma',
          para2postIcon: 'kai tik serveris bus pasiekamas.'
        }
      },
      pinLength: 4
    };
  },
  created: function created() {
    if (this.emp !== undefined && this.setCompany) {
      // console.log(atob(this.emp))
      // this.$store.dispatch('signUserIn', this.emp)
      // this.$store.dispatch('checkCompany', this.company)
      // localStorage.setItem('company', this.setCompany)
      // this.$router.push('/')
      var n = 0;
      while (n < this.company.length) {
        this.companyCharcodes = this.companyCharcodes + '#' + this.company.charCodeAt(n);
        n++;
      }
      n = 0;
      while (n < this.emp.length) {
        this.pinCharcodes = this.pinCharcodes + '#' + this.emp.charCodeAt(n);
        n++;
      }
      this.value = this.emp;
      // this.submitPin()
    } else if (this.company) {
      this.$store.dispatch('checkCompany', this.company);
      this.pinVisible = true;
      this.getPinLength();
    } else if (!this.setCompany || this.setCompany === 'undefined') {
      this.companyDialog = true;
      this.pinVisible = true;
    } else {
      this.getPinLength();
      this.pinVisible = true;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('checkLoginTime');
  },

  computed: {
    setCompany: function setCompany() {
      if (this.company !== undefined) {
        return this.company;
      } else {
        return this.$store.getters.company;
      }
    },
    url: function url() {
      return this.$store.getters.url;
    },
    autosignin: function autosignin() {
      if (this.company && this.emp) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value: function value(val) {
      if (val.length >= this.pinLength) {
        this.submitPin();
      }
    }
  },
  methods: {
    submitPin: function submitPin() {
      var _this = this;

      if (this.value.length >= this.pinLength) {
        this.unauthorised = false;
        this.signingIn = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/getEmpFromPin.ajax.php', {
          company: this.companyCharcodes ? this.companyCharcodes : this.setCompany,
          pin: this.emp ? this.pinCharcodes : this.value,
          autosignin: this.autosignin
        }).then(function (response) {
          _this.signingIn = false;
          if (response.data) {
            localStorage.setItem('clockInFlagLimit', response.data.clock_in_flag_limit ? response.data.clock_in_flag_limit : -1);
            localStorage.setItem('cancel_hours', response.data.cancel_hours ? response.data.cancel_hours : -1);
            _this.$store.dispatch('setClockInFlagLimit', response.data.clock_in_flag_limit ? response.data.clock_in_flag_limit : -1);
            localStorage.setItem('clockInLimit', response.data.clock_in_limit ? response.data.clock_in_limit : -1);
            _this.$store.dispatch('setClockInLimit', response.data.clock_in_limit ? response.data.clock_in_limit : -1);
            localStorage.setItem('clockOutLimit', response.data.clock_out_limit ? response.data.clock_out_limit : -1);
            localStorage.setItem('jobRecording', response.data.job_recording ? response.data.job_recording : -1);
            _this.$store.dispatch('setClockOutLimit', response.data.clock_out_limit ? response.data.clock_out_limit : -1);
            _this.$store.dispatch('setDisableTimeChangeIn', response.data.disable_time_change_in ? response.data.disable_time_change_in * 1 === 1 : false);
            _this.$store.dispatch('setDisableTimeChangeOut', response.data.disable_time_change_out ? response.data.disable_time_change_out * 1 === 1 : false);
            console.log(response.data.night_out_ref_type);
            localStorage.setItem('nightOutRefType', response.data.night_out_ref_type ? response.data.night_out_ref_type : 'number');
            _this.$store.dispatch('setNightOutRefType', response.data.night_out_ref_type ? response.data.night_out_ref_type : 'number');
            localStorage.setItem('company', response.data.company);
            _this.$store.dispatch('checkCompany', response.data.company);
            if (response.data.empID === -2) {
              _this.unauthorised = true;
              _this.unauthorisedMsg = 'You are not authorised to use T&A. Please contact your system administrator for assistance.';
              _this.value = '';
            } else if (response.data.empID !== undefined) {
              __WEBPACK_IMPORTED_MODULE_1_firebase_app__["auth"]().signInWithCustomToken(response.data.token).then(function () {
                _this.$store.dispatch('signUserIn', response.data);
                _this.$store.dispatch('fetchDisclaimerAccepted');
                _this.$store.dispatch('fetchDisclaimerText');
                _this.$router.push('/');
              }).catch(function (error) {
                console.log(error);
                _this.value = '';
                _this.$store.dispatch('logout');
                _this.$router.push('/');
              });
            } else {
              _this.failedConnection();
            }
          } else {
            _this.failedConnection();
          }
        }).catch(function () {
          _this.signingIn = false;
          __WEBPACK_IMPORTED_MODULE_1_firebase_app__["database"]().ref('appData/recoveryMode').once('value').then(function (data) {
            if (data.val() !== true) {
              _this.failedConnection();
            } else {
              _this.recoveryModal = true;
            }
          }).catch(function () {
            _this.failedConnection();
          });
        });
      }
    },
    failedConnection: function failedConnection() {
      this.value = '';
      this.unauthorised = true;
      this.unauthorisedMsg = 'There was a problem signing in. Please check your internet connection and try again.';
      this.pinVisible = true;
    },
    addDigit: function addDigit(digit) {
      this.value += digit;
    },
    removeDigit: function removeDigit() {
      this.value = this.value.slice(0, -1);
    },
    setCompanyValue: function setCompanyValue() {
      this.$store.dispatch('checkCompany', this.companyValue);
      this.companyDialog = false;
      this.getPinLength();
    },
    getPinLength: function getPinLength() {
      var _this2 = this;

      this.pinVisible = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/getPinLength.ajax.php', {
        company: this.companyCharcodes ? this.companyCharcodes : this.setCompany
      }).then(function (response) {
        if (response.data.pinLength) {
          _this2.pinLength = response.data.pinLength * 1;
          _this2.pinVisible = true;
        } else {
          _this2.pinVisible = true;
        }
      }).catch(function () {
        _this2.pinVisible = true;
      });
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'workerType'],
  components: { fullCalendar: __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar___default.a },
  data: function data() {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      newRequestDialog: false,
      editRequestDialog: false,
      requests: [],
      gettingExistingRequests: false,
      currentMonthYear: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM'),
      showPastRequests: false,
      selectedRequestObj: {},
      empDetails: {},
      holAllowance: {},
      currentLieuAllowance: 0,
      nextLieuAllowance: 0,
      nextPeriodReleaseDays: '-1'
    };
  },
  mounted: function mounted() {
    this.getExistingRequests();
    this.getEmpDetails();
    this.getNextPeriodReleaseDays();
  },

  filters: {
    formatDate: function formatDate(date, format) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format(format);
    },
    formatNextHolPrdDate: function formatNextHolPrdDate(date, format) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).add(1, 'year').format(format);
    },
    filterActionText: function filterActionText(val) {
      if (val === 0) {
        return 'Pending';
      } else if (val === 1) {
        return 'Approved';
      } else if (val === 2) {
        return 'Declined';
      } else if (val === 3) {
        return 'Cancellation Requested';
      } else if (val === 5) {
        return 'Holiday Deleted';
      }
    },
    formatTime: function formatTime(val) {
      var startTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + (val.hour * 1 < 10 ? '0' + val.hour : val.hour) + ':00').add(val.minute, 'minutes').format('h:mma');
      var endTime = val.hour + val.length > 24 ? val.hour + val.length - 24 : val.hour + val.length;
      var endTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + endTime + ':00').add(val.minute, 'minutes').format('h:mma');
      return startTimestamp + ' - ' + endTimestamp;
    }
  },
  computed: {
    filteredRequests: function filteredRequests() {
      var _this = this;

      var filteredRequests = [];
      var currentMonthYear = this.currentMonthYear;
      this.requests.forEach(function (request) {
        switch (request.actioned) {
          case 0:
            request.cssClass = 'pending';
            request.title = 'Pending';
            break;
          case 1:
            request.cssClass = 'approved';
            request.title = 'Approved';
            break;
          case 2:
            request.cssClass = 'rejected';
            request.title = 'Rejected';
            break;
          case 3:
            request.cssClass = 'cancellation';
            request.title = 'Cancellation Requested';
            break;
          case 5:
            request.cssClass = 'rejected';
            request.title = 'Holiday Deleted';
            break;
        }
        if (request.whitelisted_days === 0) {
          request.cssClass = 'rejected';
          request.title = 'Holiday Cancelled';
        }
        var startTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + request.hour + ':00').add(request.minute, 'minutes').format('h:mma');
        var endTime = request.hour + request.length > 24 ? request.hour + request.length - 24 : request.hour + request.length;
        var endTimestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + endTime + ':00').add(request.minute, 'minutes').format('h:mma');
        if (_this.company !== 'lfp') {
          request.title = request.title + ' ' + startTimestamp + ' - ' + endTimestamp;
        }
        var requestMonthYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()(request.start, 'YYYY-MM-DD').format('YYYY-MM');
        if (requestMonthYear === currentMonthYear) {
          filteredRequests.push(request);
        }
      });
      return filteredRequests;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    currentPeriodEnd: function currentPeriodEnd() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.holAllowance.period_end, 'YYYY-MM-DD');
    },
    currentPeriodStart: function currentPeriodStart() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.holAllowance.period_start, 'YYYY-MM-DD');
    },
    previousPeriodRequests: function previousPeriodRequests() {
      var _this2 = this;

      return this.requestsToDisplay.filter(function (r) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(r.start).isBefore(_this2.currentPeriodStart);
      }).sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.start).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.start));
      });
    },
    currentPeriodRequests: function currentPeriodRequests() {
      var _this3 = this;

      return this.requestsToDisplay.filter(function (r) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(r.start).isSameOrAfter(_this3.currentPeriodStart) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(r.start).isSameOrBefore(_this3.currentPeriodEnd);
      }).sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.start).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.start));
      });
    },
    nextPeriodRequests: function nextPeriodRequests() {
      var _this4 = this;

      return this.requestsToDisplay.filter(function (r) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(r.start).isAfter(_this4.currentPeriodEnd);
      }).sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.start).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.start));
      });
    },
    requestsToDisplay: function requestsToDisplay() {
      var _this5 = this;

      return this.requests.filter(function (r) {
        return !_this5.isPastDate(r.start) || _this5.showPastRequests;
      });
    }
  },
  methods: {
    getExistingRequests: function getExistingRequests() {
      var _this6 = this;

      this.gettingExistingRequests = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getEmpHolRequests.ajax.php', { empID: this.user.empID, company: this.company }).then(function (result) {
        if (result.data) {
          _this6.requests = result.data.requests;
          _this6.holAllowance = result.data.total_days;
          _this6.holAllowance.total_next_period_approved_days_left = _this6.calculatedAllowanceNextPeriod(_this6.holAllowance.hol_count, _this6.holAllowance.nextHolidayOverride, _this6.holAllowance.nextHolidayCarryover, _this6.holAllowance.next_bonus_to_be_awarded);
          _this6.currentLieuAllowance = result.data.total_days.currentLieuAllowance;
          _this6.nextLieuAllowance = result.data.total_days.nextLieuAllowance;
          _this6.orderAuditLog(result.data.audit);
          _this6.gettingExistingRequests = false;
        } else {
          _this6.gettingExistingRequests = false;
        }
      });
    },

    // calculate the Calcualted Allowance
    calculatedAllowanceNextPeriod: function calculatedAllowanceNextPeriod(basicAllowance, overrideValue, carryOverValue, bonusValue) {
      // calculated allowance will be basic allowance if no other factors apply
      var totalAllowance = basicAllowance;
      // if carryover value exists, and is from the previous year to current year
      if (carryOverValue) {
        totalAllowance = totalAllowance + carryOverValue;
      }

      // add any bonus values to allowance for years served
      if (bonusValue) {
        totalAllowance = totalAllowance + bonusValue;
      }

      if (overrideValue) {
        totalAllowance = overrideValue;
      }

      return totalAllowance;
    },
    orderAuditLog: function orderAuditLog(auditLog) {
      var _this7 = this;

      var _loop = function _loop(request) {
        var currentRequest = _this7.requests[request];
        var currentRequestAuditLogs = auditLog.filter(function (a) {
          return a.holID === currentRequest.ID;
        });
        for (var currentAuditLog in currentRequestAuditLogs) {
          var currentLog = currentRequestAuditLogs[currentAuditLog];
          var comment = currentLog.comment ? currentLog.comment.toString() : '';
          if (currentLog.original_count === 0 && currentLog.new_count === 0 && comment !== 'Unarchived') {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Cancel Request Rejected By ' + currentLog.modified_by + ' - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            });
          } else if (comment !== 'Unarchived') {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Request Modified By ' + currentLog.modified_by + ' - Request has been modified from ' + currentLog.original_count + ' day(s) to ' + currentLog.new_count + ' day(s) - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            });
          } else {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Request Modified By ' + currentLog.modified_by + ' - Request has been modified from ' + currentLog.original_count + ' day(s) to ' + currentLog.new_count + ' day(s) - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            });
          }
        }

        if (currentRequest.type == null) {
          currentRequest.auditlog.push({
            'date': currentRequest.date_requsted,
            'content': 'Request Submitted'
          });
          var action = '';
          switch (currentRequest.actioned) {
            case 1:
              action = 'Request Actioned By ';
              break;
            case 2:
              action = 'Request Rejected By ';
              break;
            case 3:
              action = 'Cancellation Requested ';
              break;
            case 5:
              action = 'Holiday Deleted By ';
              break;
          }
          if (currentRequest.actioned > 0 && currentRequest.actioned < 6) {
            var _comment = currentRequest.comment ? currentRequest.comment.toString() : '';
            currentRequest.auditlog.push({
              'date': currentRequest.date_authorized,
              'content': action + currentRequest.authorized_by + ' - ' + (_comment.length === 0 ? '(No Comment Provided)' : _comment)
            });
          }
        } else {
          var _comment2 = currentRequest.comment ? currentRequest.comment.toString() : '';
          currentRequest.auditlog.push({
            'date': currentRequest.date_requsted,
            'content': 'Request Created By ' + currentRequest.authorized_by + ' - ' + (_comment2.length === 0 ? '(No Comment Provided)' : _comment2)
          });
        }
        currentRequest.auditlog = currentRequest.auditlog.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(b.date).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date), 'minutes');
        });
      };

      for (var request in this.requests) {
        _loop(request);
      }
    },
    viewEventDetails: function viewEventDetails(event, jsEvent, pos) {
      if (event.whitelisted_days > 0) {
        this.selectedRequestObj = event;
        this.editRequestDialog = true;
      }
    },
    updateCurrentMonthYear: function updateCurrentMonthYear(start, end, current) {
      this.currentMonthYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()(current).format('YYYY-MM');
    },
    isPastDate: function isPastDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf('day'));
    },
    getEmpDetails: function getEmpDetails() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getEmpDetails.ajax.php', {
        company: this.company,
        empID: this.user.empID
      }).then(function (response) {
        _this8.empDetails = response.data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getNextPeriodReleaseDays: function getNextPeriodReleaseDays() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getNextPeriodReleaseDays.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this9.nextPeriodReleaseDays = response.data[0].value;
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['taID', 'shiftInProgress', 'jobID'],
  data: function data() {
    var _this = this;

    return {
      jobInfo: {},
      jobDetails: {
        farm: null,
        spray_bonus: 0,
        jobDescription: null,
        productSpec: null,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        gps: null,
        job_id: null,
        ta_id: null
      },
      startTimeRules: [function (v) {
        return v !== null || 'Start time is required';
      }, function (v) {
        return (_this.shiftInProgress !== '1' ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.jobDetails.startDate + ' ' + v).isBetween(_this.shiftStartTime, _this.shiftEndTime, null, '[]') : __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.jobDetails.startDate + ' ' + v, 'YYYY-MM-DD HH:mm').local().isSameOrAfter(_this.shiftStartTime, 'YYYY-MM-DD HH:mm')) || 'Check job start time is within shift times';
      }, function (v) {
        return _this.existingJobOverlap === false || 'Job times overlap with an existing job';
      }],
      endTimeRules: [function (v) {
        return v !== null || 'End time is required';
      }, function (v) {
        return _this.jobBackwards !== true || 'End time must be after start time';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.jobDetails.endDate + ' ' + v).isBetween(__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.shiftStartTime, 'YYYY-MM-DD HH:mm'), __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.shiftEndTime, 'YYYY-MM-DD HH:mm'), null, '[]') || _this.shiftEndTime == null || 'Check job end time is within shift times';
      }, function (v) {
        return _this.existingJobOverlap === false || 'Job times overlap with an existing job';
      }],
      endDateRules: [function (v) {
        return v !== null || 'End date is required';
      }, function (v) {
        return _this.jobBackwards !== true || 'End date must be after start date';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(v, 'DD/MM/YYYY').isBetween(__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.shiftStartTime, 'YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.shiftEndTime, 'YYYY-MM-DD'), null, '[]') || _this.shiftEndTime == null || 'Check job end date is within shift times';
      }, function (v) {
        return _this.existingJobOverlap === false || 'Job times overlap with an existing job';
      }],
      inputRules: [function (v) {
        return v !== null || 'Field is required';
      }],
      prodSpecRules: [function (v) {
        return v !== null && _this.hasProductSpec === 1 || 'Field is required';
      }],
      sprayBonusRules: [function (v) {
        return v > 0 && _this.jobDetails.jobDescription === 0 || 'Spray bonus must be set';
      }],
      startDateDialog: false,
      url: this.$store.getters.url,
      startTimeDialog: false,
      startTimeFormat: null,
      startDialog: false,
      endDateDialog: false,
      endTimeDialog: false,
      endTimeFormat: null,
      completeDialog: false,
      errorDialog: false,
      failedDialog: false,
      errorDateDialog: false,
      saveFailedDialog: false,
      deleteConfirmDialog: false,
      jobState: 0, // 0 - Not Start | 1 - Started | 2 - Ended
      empID: this.$store.getters.user.empID,
      company: this.$store.getters.company,
      loading: true,
      formValid: true,
      currentJobID: this.jobID === undefined ? -1 : this.jobID, // -1 if no job is selected
      endJobActive: false,
      shiftStartTime: null,
      shiftEndTime: null,
      jobStartTime: null,
      jobList: [],
      totalJobList: [],
      jobsLoaded: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getAllJobs();
    if (this.currentJobID !== '-1') {
      // If an actual job is selected, get the details of the job
      this.getCurrentJobDetails();
    } else {
      // setup the times as it is a new job
      this.getShiftTimes();
      if (this.shiftInProgress === '1') {
        this.jobDetails.startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
        this.jobDetails.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
      }
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.jobDetails.gps = position.coords.latitude + ' ' + position.coords.longitude;
      });
    }
    this.jobDetails.ta_id = this.taID;
    this.retrieveJobInfo(); // gets list of farms, job descriptions and product specificiations
  },

  watch: {
    'jobDetails.startTime': function jobDetailsStartTime(value) {
      this.startTimeFormat = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('HH:mm');
      this.validateForm();
    },
    'jobDetails.endTime': function jobDetailsEndTime(value) {
      this.endTimeFormat = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('HH:mm');
      this.validateForm();
    },
    'jobDetails.jobDescription': function jobDetailsJobDescription(value) {
      this.validateForm();
      if (this.jobInfo.jobDescription !== undefined) {
        var jobDescObj = this.jobInfo.jobDescription.find(function (x) {
          return x.ID === value;
        });
        if (jobDescObj !== null && jobDescObj.hasProduct === 0) {
          this.jobDetails.productSpec = null;
        }
        this.jobDetails.spray_bonus = null; // ensure spray bonus is always reset
      }
    },
    'jobDetails.startDate': function jobDetailsStartDate(value) {
      // let newStartTime = moment(value + ' ' + moment(this.jobDetails.startTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
      // if (moment(newStartTime).isSameOrBefore(moment(this.shiftStartTime))) {
      //   this.jobDetails.startTime = moment(this.shiftStartTime).toDate()
      // }
      this.validateForm();
    },
    'jobDetails.endDate': function jobDetailsEndDate(value) {
      this.validateForm();
      var newEndTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endTime).format('HH:mm'), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(newEndTime).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime))) {
        this.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime).toDate();
      }
    }
  },
  computed: {
    hasProductSpec: function hasProductSpec() {
      // returns whether the selected job description contains product specifications
      var jobDescID = this.jobDetails.jobDescription;
      var jobDescList = this.jobInfo.jobDescription;
      if (jobDescList === undefined) {
        return 0;
      }
      var jobDescObj = jobDescList.find(function (x) {
        return x.ID === jobDescID;
      });
      if (jobDescObj === undefined) {
        return 0;
      }
      return jobDescObj.hasProduct;
    },
    formatStartDate: function formatStartDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    formatEndDate: function formatEndDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    filteredFarms: function filteredFarms() {
      if (this.jobInfo.farms === undefined) {
        return [];
      }
      return this.jobInfo.farms.sort(function (a, b) {
        return a.farm_name.localeCompare(b.farm_name);
      });
    },
    filteredJobDesc: function filteredJobDesc() {
      if (this.jobInfo.jobDescription === undefined) {
        return [];
      }
      return this.jobInfo.jobDescription.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    filteredProdSpec: function filteredProdSpec() {
      if (this.jobInfo.productSpec === undefined) {
        return [];
      }
      return this.jobInfo.productSpec.sort(function (a, b) {
        return a.product_name.localeCompare(b.product_name);
      });
    },
    endMinTime: function endMinTime() {
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate);
      console.log('ENDDIFF: ' + end.diff(start, 'days'));
      if (end.diff(start, 'days') >= 1) {
        console.log('end is a day after start');
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 00:00').toDate();
      }
      var jobStartTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startTime).format('HH:mm');
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + jobStartTime).toDate();
    },
    startMinTime: function startMinTime() {
      if (this.shiftStartTime == null) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 00:00').toDate();
      }
      var shiftStartTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftStartTime).format('HH:mm');
      var shiftStartDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftStartTime).format('YYYY-MM-DD');
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate).isSameOrBefore(shiftStartDate)) {
        console.log('No end date set and job is same or before shift');
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + shiftStartTime).toDate();
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 00:00').toDate();
    },
    maxEndTime: function maxEndTime() {
      if (this.shiftStartTime == null) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 23:59').toDate();
      }
      var shiftEndTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime).format('HH:mm');
      var shiftEndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime).format('YYYY-MM-DD');
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate).isSameOrAfter(shiftEndDate) && this.shiftInProgress === '0') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + shiftEndTime).toDate();
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 23:59').toDate();
    },
    maxStartTime: function maxStartTime() {
      if (this.shiftEndTime == null) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 23:59').toDate();
      }
      var shiftEndTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime).format('HH:mm');
      var shiftEndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime).format('YYYY-MM-DD');
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate).isSameOrAfter(shiftEndDate) && this.shiftInProgress === '0') {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 ' + shiftEndTime).toDate();
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()('1970-01-01 23:59').toDate();
    },
    jobBackwards: function jobBackwards() {
      var startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate).format('YYYY-MM-DD');
      var startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startTime).format('HH:mm');
      var endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate).format('YYYY-MM-DD');
      var endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endTime).format('HH:mm');
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(startDate + ' ' + startTime).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(endDate + ' ' + endTime));
    },
    formattedJobLength: function formattedJobLength() {
      var startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate).format('YYYY-MM-DD');
      var startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startTime).format('HH:mm');
      var endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate).format('YYYY-MM-DD');
      var endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endTime).format('HH:mm');
      var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(startDate + ' ' + startTime);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(endDate + ' ' + endTime);
      var hrs = __WEBPACK_IMPORTED_MODULE_2_moment___default()(end).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(start), 'hours');
      var mins = __WEBPACK_IMPORTED_MODULE_2_moment___default()(end).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(start), 'minutes') % 60;
      return hrs + 'h ' + mins + 'm';
    },
    existingJobOverlap: function existingJobOverlap() {
      // No jobs or incomplete input? No overlap.
      console.log('Checking existing job overlap...');
      console.log(this.totalJobList);
      if (!Array.isArray(this.totalJobList) || this.totalJobList.length === 0) return false;
      if (!this.jobDetails.startDate || !this.jobDetails.startTime) return false;

      // Build new interval (local; use utc() if that’s your standard)
      var newStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startDate).local().format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.startTime).local().format('HH:mm'), 'YYYY-MM-DD HH:mm');
      var newEnd = null;

      // If end date/time is empty, treat as a single point in time (start only)
      if (this.jobDetails.endDate && this.jobDetails.endTime) {
        newEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endDate).local().format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.jobDetails.endTime).local().format('HH:mm'), 'YYYY-MM-DD HH:mm');
      }

      console.log('Checking overlap for new job ' + newStart.format() + (newEnd ? ' → ' + newEnd.format() : ' (no end)'));

      if (!newStart.isValid()) return false;
      if (newEnd && !newEnd.isValid()) return false;
      if (newEnd && !newEnd.isAfter(newStart)) return false; // zero/negative length: treat as invalid/no overlap

      // Normalise currentJobID to a number if possible
      var currentId = typeof this.currentJobID === 'string' ? parseInt(this.currentJobID, 10) : this.currentJobID;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.totalJobList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var job = _step.value;

          if (currentId !== -1 && job.job_id === currentId) continue; // skip the one we’re editing

          var jobStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(job.start_time, 'YYYY-MM-DD HH:mm:ss').local();
          // If no end_time, treat as "still running" → use now OR shiftEnd if you prefer
          var jobEnd = job.end_time ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(job.end_time, 'YYYY-MM-DD HH:mm:ss').local() : this.shiftEndTime ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime, 'YYYY-MM-DD HH:mm') : __WEBPACK_IMPORTED_MODULE_2_moment___default()();

          console.log('Comparing to existing job ' + jobStart.format() + ' → ' + jobEnd.format());

          if (!jobStart.isValid()) continue; // skip bad rows
          if (!jobEnd.isValid()) continue;

          if (newEnd) {
            // Overlap if ranges intersect (exclusive at the boundary)
            var overlaps = newStart.isBefore(jobEnd) && newEnd.isAfter(jobStart);
            if (overlaps) return true;
          } else {
            // No end: check if newStart falls within any existing job interval
            var _overlaps = newStart.isSameOrAfter(jobStart) && newStart.isBefore(jobEnd);
            if (_overlaps) return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  },
  methods: {
    stripDecimals: function stripDecimals(value) {
      if (value !== null && value !== '') {
        this.jobDetails.spray_bonus = Math.floor(Number(value)) || 0;
      }
    },
    startJob: function startJob() {
      var _this3 = this;

      if (!this.$refs.form.validate()) {
        return;
      }

      // Ensure jobs have been loaded before checking overlap
      if (!this.jobsLoaded) {
        return;
      }

      // Explicit overlap check as a safeguard
      if (this.existingJobOverlap) {
        this.validateForm();
        return;
      }

      this.loading = true;
      var jobDetails = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.jobDetails)); // deep clone to avoid mutating original object
      jobDetails.startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.startDate).format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.startTime).format('HH:mm');
      if (jobDetails.endDate !== null && jobDetails.endTime !== null) {
        // if end date and time are set
        jobDetails.endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.endDate).format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.endTime).format('HH:mm');
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/saveJobDetails.ajax.php', {
        company: this.company,
        type: 1, // initial add
        jobDetails: jobDetails

      }).then(function (response) {
        _this3.jobState = 1;
        _this3.loading = false;
        _this3.jobDetails.job_id = response.data;
      }).catch(function (e) {
        _this3.loading = false;
        _this3.saveFailedDialog = true;
        console.log(e);
      });
    },
    getShiftTimes: function getShiftTimes() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/getCurrentJobList.ajax.php', {
        company: this.company,
        type: 'current',
        ta_id: this.taID,
        currentJobID: this.currentJobID
      }).then(function (response) {
        _this4.shiftStartTime = response.data.shiftDetails.start_time !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.shiftDetails.start_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm') : null;
        _this4.shiftEndTime = response.data.shiftDetails.end_time !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.shiftDetails.end_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm') : null;
        console.log(_this4.shiftStartTime);
        if (_this4.shiftInProgress === '0') {
          _this4.jobDetails.startDate = _this4.shiftStartTime.split(' ')[0];
          _this4.jobDetails.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this4.shiftStartTime).toDate();
          _this4.jobDetails.endDate = _this4.shiftStartTime.split(' ')[0];
          _this4.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this4.shiftStartTime).toDate();
        }
        _this4.jobList = response.data.jobDetails;
      }).catch(function (e) {
        _this4.failedDialog = true;
        console.log(e);
      });
    },
    getCurrentJobDetails: function getCurrentJobDetails() {
      var _this5 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/getCurrentJobList.ajax.php', {
        company: this.company,
        type: 'current',
        ta_id: this.taID,
        currentJobID: this.currentJobID
      }).then(function (response) {
        _this5.jobList = response.data.jobDetails;
        _this5.jobStartTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(response.data.jobDetails[0].start_time, 'YYYY-MM-DD HH:mm:ss').local().toDate();
        _this5.shiftStartTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.shiftDetails.start_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm');
        _this5.shiftEndTime = response.data.shiftDetails.end_time !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.shiftDetails.end_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD HH:mm') : null;
        if (response.data.jobDetails.length > 0) {
          // shift has already been started
          var currentJob = response.data.jobDetails[0];
          _this5.jobState = 1; // shift started
          _this5.jobDetails.startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD');
          _this5.jobDetails.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().toDate();
          _this5.jobDetails.job_id = currentJob.job_id;
          _this5.jobDetails.farm = currentJob.farm_id;
          _this5.jobDetails.jobDescription = currentJob.job_desc_id;
          _this5.jobDetails.productSpec = currentJob.product_spec_id;
          _this5.jobDetails.spray_bonus = currentJob.spray_bonus;
          if (currentJob.end_time !== null) {
            _this5.jobState = 2; // job ended
            _this5.endJobActive = true;
            _this5.jobDetails.endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD');
            _this5.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().toDate();
          } else {
            if (_this5.shiftInProgress === '0') {
              _this5.jobDetails.endDate = _this5.shiftEndTime.split(' ')[0];
              _this5.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this5.shiftEndTime, 'YYYY-MM-DD HH:mm').toDate();
            } else {
              _this5.jobDetails.endDate = null;
              _this5.jobDetails.endTime = null;
            }
          }
          _this5.jobDetails.ta_id = currentJob.ta_id;
        }
        _this5.loading = false;
      }).catch(function (e) {
        _this5.failedDialog = true;
        console.log(e);
      });
    },
    getAllJobs: function getAllJobs() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/getCurrentJobList.ajax.php', {
        company: this.company,
        type: 'all',
        ta_id: this.taID,
        currentJobID: '-1'
      }).then(function (response) {
        _this6.totalJobList = response.data.jobDetails;
        _this6.jobsLoaded = true;
        _this6.validateForm();
      }).catch(function (e) {
        _this6.failedDialog = true;
        _this6.jobsLoaded = true;
        console.log(e);
      });
    },
    retrieveJobInfo: function retrieveJobInfo() {
      var _this7 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/getJobDetails.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this7.loading = false;
        _this7.jobInfo = response.data;
      }).catch(function (e) {
        _this7.failedDialog = true;
        _this7.loading = false;
        console.log(e);
      });
    },
    formatTimeStringToDate: function formatTimeStringToDate(val) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(val, 'HH:mm').toDate();
    },
    openEndDialog: function openEndDialog() {
      if (this.shiftInProgress === '0') {
        this.jobDetails.endDate = this.shiftEndTime.split(' ')[0];
        this.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.shiftEndTime, 'YYYY-MM-DD HH:mm').toDate();
      } else {
        this.jobDetails.endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
        this.jobDetails.endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
      }
      this.endJobActive = true;
    },
    deleteJob: function deleteJob() {
      var _this8 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/saveJobDetails.ajax.php', {
        company: this.company,
        type: 3, // remove
        jobDetails: this.jobDetails
      }).then(function (response) {
        _this8.loading = false;
        _this8.jobDetails.farm = null;
        _this8.jobDetails.spray_bonus = null;
        _this8.jobDetails.jobDescription = null;
        _this8.jobDetails.productSpec = null;
        if (_this8.shiftInProgress === '0') {
          _this8.jobDetails.startDate = _this8.shiftStartTime.split(' ')[0];
          _this8.jobDetails.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this8.shiftStartTime, 'YYYY-MM-DD HH:mm').toDate();
        } else {
          _this8.jobDetails.startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
          _this8.jobDetails.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();
        }
        _this8.jobDetails.endDate = null;
        _this8.jobDetails.endTime = null;
        _this8.jobDetails.job_id = null;
        _this8.endJobActive = false;
        _this8.jobState = 0;
        _this8.$router.back();
      }).catch(function (e) {
        _this8.loading = false;
        _this8.saveFailedDialog = true;
        console.log(e);
      });
    },
    completeJob: function completeJob() {
      var _this9 = this;

      // ending job
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.jobsLoaded) {
        return;
      }

      if (this.existingJobOverlap) {
        this.validateForm();
        return;
      }

      this.loading = true;
      var jobDetails = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.jobDetails)); // deep clone to avoid mutating original object
      jobDetails.startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.startDate).format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.startTime).format('HH:mm');
      jobDetails.endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.endDate).format('YYYY-MM-DD') + ' ' + __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(jobDetails.endTime).format('HH:mm');
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url + '/tanda-service/saveJobDetails.ajax.php', {
        company: this.company,
        type: 2, // 2 - Update of existing job
        jobDetails: jobDetails
      }).then(function (response) {
        _this9.jobState = 2;
        _this9.loading = false;
        if (_this9.currentJobID !== -1 && _this9.currentJobID !== '-1') {
          _this9.$router.back();
        } else {
          _this9.completeDialog = true;
          _this9.getCurrentJobDetails();
        }
      }).catch(function (e) {
        _this9.loading = false;
        _this9.saveFailedDialog = true;
        console.log(e);
      });
    },
    formatTimeDateToString: function formatTimeDateToString(val) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('HH:mm');
    },
    validateForm: function validateForm() {
      console.log('Validating form...');
      this.$refs.form.validate();
    }
  },
  filters: {
    formatDate: function formatDate(val) {
      return val !== undefined ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('DD/MM/YYYY HH:mm') : '--';
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchengenRequest_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f38177_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchengenRequest_vue__ = __webpack_require__(414);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchengenRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f38177_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchengenRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateFormat: 'Do MMMM',
      dateOne: '',
      dateTwo: '',
      addingTrip: false,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      detailsConfirmed: false,
      loading: false,
      schengenCountries: [],
      selected_country: null
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getSchengenCountries();
  },

  methods: {
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        formattedDates = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateOne, this.dateFormat);
      }
      if (dateTwo && dateTwo !== dateOne) {
        formattedDates += ' - ' + __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    getSchengenCountries: function getSchengenCountries() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getSchengenCountries.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this.schengenCountries = response.data.map(function (item) {
          return {
            value: item.country_id,
            text: item.country_name,
            code: item.country_code
          };
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    addTrip: function addTrip() {
      var _this2 = this;

      this.addingTrip = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/addSchengenTrip.ajax.php', {
        company: this.company,
        user: this.user,
        startDate: this.dateOne,
        endDate: this.dateTwo,
        emp: this.user.empID,
        country: this.selected_country
      }).then(function (response) {
        if (response.data.success) {
          _this2.$emit('closeSchengenRequest');
          _this2.$emit('addedSchengen');
        }
        _this2.addingTrip = false;
      }).catch(function (e) {
        console.log(e);
        _this2.addingTrip = false;
      });
    }
  },
  watch: {},
  filters: {}
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateFormat: 'Do MMMM YYYY',
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      loading: false,
      newSchengen: false,
      editSchengen: false,
      selectedTrip: null,
      schengenTrips: [],
      addedSchengen: false
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getSchengenTrips();
  },

  methods: {
    onTripAdded: function onTripAdded() {
      this.newSchengen = false;
      this.getSchengenTrips();
    },
    openEditDialog: function openEditDialog(trip) {
      this.selectedTrip = trip;
      this.editSchengen = true;
    },
    closeEditDialog: function closeEditDialog() {
      this.editSchengen = false;
      this.selectedTrip = null;
    },
    editSchengenTrip: function editSchengenTrip(updatedTrip) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/alterSchengenTrips.ajax.php', {
        company: this.company,
        function: 1,
        trip_id: updatedTrip.trip_id,
        emp: this.user.empID,
        country: updatedTrip.country,
        start_date: updatedTrip.startDate,
        end_date: updatedTrip.endDate
      }).then(function (response) {
        _this.getSchengenTrips();
      }).catch(function (e) {
        console.log(e);
      });
    },
    deleteSchengenTrip: function deleteSchengenTrip(trip) {
      var _this2 = this;

      if (!window.confirm('Are you sure you want to delete this trip?')) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/alterSchengenTrips.ajax.php', {
        company: this.company,
        function: 0,
        trip_id: trip.trip_id,
        emp: this.user.empID
      }).then(function (response) {
        _this2.getSchengenTrips();
      }).catch(function (e) {
        console.log(e);
      });
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        formattedDates = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateOne, this.dateFormat);
      }
      if (dateTwo && dateTwo !== dateOne) {
        formattedDates += ' - ' + __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    getSchengenTrips: function getSchengenTrips() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getSchengenTrips.ajax.php', {
        company: this.company,
        emp: this.user.empID
      }).then(function (response) {
        _this3.schengenTrips = Array.isArray(response.data) ? response.data : [];
        _this3.addedSchengen = false;
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  watch: {
    addedSchengen: function addedSchengen(val) {
      if (!val) {
        this.getSchengenTrips();
      }
    }
  },
  filters: {}
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dbPromise__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      load: [],
      completeDialog: false,
      errorDialog: false,
      errorDateDialog: false,
      modules: this.$store.getters.user.modules,
      empID: this.$store.getters.user.empID,
      occasionalDriving: false,
      isOnCall: false,
      isExtraShift: false,
      occasional_driver: this.$store.getters.user.occasional_driver,
      extra_shift: this.$store.getters.user.extra_shift,
      on_call: this.$store.getters.user.on_call,
      company: this.$store.getters.company,
      clockInFlagLimit: this.$store.getters.clockInFlagLimit,
      disableTimeChangeIn: this.$store.getters.disableTimeChangeIn,
      loading: false,
      gps: null,
      loadIdRules: [function (v) {
        return v.length < 19 || 'Maximum length exceeded';
      }],
      notes: '',
      formValid: true,
      displayDisclaimer: true,
      clockInLimit: this.$store.getters.clockInLimit,
      gpsStatus: '',
      gpsAttemptComplete: false,
      geoClock: '0'
    };
  },
  created: function created() {
    this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
    this.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
      this.displayDisclaimer = false;
    } else {
      this.displayDisclaimer = !this.$store.getters.disclaimerAccepted;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.getItem('lat') && localStorage.getItem('long')) {
      this.gps = localStorage.getItem('lat') + ' ' + localStorage.getItem('long');
      this.gpsAttemptComplete = true;
      this.gpsStatus = 'Using Static Machine GPS';
    } else if (navigator.geolocation) {
      this.gpsStatus = 'Getting GPS';
      navigator.geolocation.getCurrentPosition(function (position) {
        _this.gpsStatus = 'GPS Acquired';
        _this.gpsAttemptComplete = true;
        _this.gps = position.coords.latitude + ' ' + position.coords.longitude;
      }, function (error) {
        _this.gpsStatus = 'GPS Error';
        _this.gpsAttemptComplete = true;
        console.log(error);
      }, { enableHighAccuracy: false, timeout: 5000, maximumAge: 0 });
    } else {
      this.gpsAttemptComplete = true;
      this.gpsStatus = 'GPS not available on this machine.';
    }
    this.$store.dispatch('checkLoginTime');
  },

  watch: {
    time: function time(value) {
      this.timeFormat = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(value)).format('HH:mm');
    }
  },
  computed: {
    formatDate: function formatDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('DD/MM/YYYY');
    },
    timeRules: function timeRules() {
      var _this2 = this;

      var arr = [];
      if (this.clockInLimit > -1) {
        arr.push(function (v) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this2.date + ' ' + _this2.timeFormat, 'YYYY-MM-DD HH:mm').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(_this2.clockInLimit, 'minutes'), 'minute') || 'Clocking in, in the past is not allowed';
        });
      }
      return arr;
    }
  },
  methods: {
    submitClockIn: function submitClockIn() {
      var _this3 = this;

      console.log(this.gps);
      if (this.$refs.loadSelect) {
        this.$refs.loadSelect.blur();
      }
      this.$nextTick(function () {
        if (_this3.$refs.form.validate()) {
          _this3.loading = true;
          var start = _this3.date + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this3.timeFormat, 'HH:mm').format('HH:mm');
          if (_this3.emp !== '' && _this3.company !== '') {
            var delayedStart = 0;
            if (_this3.clockInFlagLimit && _this3.clockInFlagLimit > -1) {
              var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(start, 'YYYY-MM-DD HH:mm'), 'minutes');
              if (diff > _this3.clockInFlagLimit) {
                delayedStart = 1;
              }
            }
            var postObj = {
              emp: _this3.empID,
              company: _this3.company,
              type: 'in',
              data: {
                start: start,
                load_array: _this3.load,
                gps: _this3.gps,
                notes: _this3.notes,
                occasional_driving: _this3.occasionalDriving * 1,
                extra_shift: _this3.isExtraShift * 1,
                on_call: _this3.isOnCall * 1
              },
              delayed_start: delayedStart
            };
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.url + '/tanda-service/saveShiftsForEmp.ajax.php', postObj).then(function (response) {
              console.log(response);
              if (response.data > 0) {
                _this3.loading = false;
                _this3.completeDialog = true;
                _this3.addNewClockIn(start);
              } else if (response.data === 'You Are Not Within A Suitable Location' || response.data === 'Invalid GPS format' || response.data === 'Invalid GPS coordinates') {
                alert(response.data);
                _this3.loading = false;
              } else {
                _this3.loading = false;
                _this3.errorDateDialog = true;
              }
            }).catch(function (error) {
              _this3.loading = false;
              _this3.errorDialog = true;
              console.log(error);
            });
          }
        }
      });
    },
    addNewClockIn: function addNewClockIn(start) {
      var _this4 = this;

      var timesheet = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
      var newObj = { start: start, notes: this.notes };
      timesheet.push(newObj);

      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('timesheet-archive', 'readwrite');
        var timesheetStore = tx.objectStore('timesheet-archive');
        timesheetStore.put(timesheet, _this4.empID);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    saveLocally: function saveLocally(data) {
      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox-timesheets', 'readwrite');
        var timesheetStore = tx.objectStore('outbox-timesheets');
        timesheetStore.put(data);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    formatTimeStringToDate: function formatTimeStringToDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time, 'HH:mm').toDate();
    },
    formatTimeDateToString: function formatTimeDateToString() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time).format('HH:mm');
    },
    disclaimerAction: function disclaimerAction() {
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dbPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idb__);


function dbPromise() {
  var dbPromise = __WEBPACK_IMPORTED_MODULE_0_idb___default.a.open('tanda-db', 1, function (upgradeDb) {
    switch (upgradeDb.oldVersion) {
      case 0:
        upgradeDb.createObjectStore('outbox-timesheets', { autoIncrement: true });
        upgradeDb.createObjectStore('outbox-receipts');
        upgradeDb.createObjectStore('timesheet-archive');
        upgradeDb.createObjectStore('image-store');
        upgradeDb.createObjectStore('current-expenses');
    }
  });

  return dbPromise;
}

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dbPromise__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      nightOut: '',
      bonus: null,
      completeDialog: false,
      empID: this.$store.getters.user.empID,
      has_bonus: this.$store.getters.user.has_bonus,
      company: this.$store.getters.company,
      disableTimeChangeOut: this.$store.getters.disableTimeChangeOut,
      notes: '',
      loading: false,
      errorDialog: false,
      shiftID: null,
      nightOutRules: [function (v) {
        return v.length < 19 || 'Maximum length exceeded';
      }],
      formValid: true,
      gps: null,
      tachoService: {
        snackbar: false,
        status: 0,
        msg: '',
        closeable: true
      },
      tachoDayPrompt: false,
      addingTachoDay: false,
      postObj: {
        emp: this.empID,
        company: this.company,
        type: 'out',
        tacho: null,
        data: {
          end: null,
          nightOut: null,
          gps: null
        }
      },
      clockOutLimit: this.$store.getters.clockOutLimit,
      nightOutRefType: this.$store.getters.nightOutRefType,
      gpsStatus: '',
      gpsAttemptComplete: false,
      latestJobEndTime: null,
      latestJobEndDate: null,
      latestJobEndTimeDateObj: null,
      minEndTime: __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate()
    };
  },
  created: function created() {
    var timesheetData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
    this.notes = timesheetData[timesheetData.length - 1].notes || '';
    this.latestJobEndTime = sessionStorage.getItem('latestJobEndTime');
    this.latestJobEndTimeDateObj = this.latestJobEndTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.latestJobEndTime).toDate() : null;
    this.latestJobEndDate = this.latestJobEndTime ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.latestJobEndTime).format('YYYY-MM-DD') : null;

    this.date = this.latestJobEndTime ? this.latestJobEndDate : __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
    this.time = this.latestJobEndTime ? this.latestJobEndTimeDateObj : __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
  },

  watch: {
    time: function time(value) {
      this.timeFormat = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(value)).format('HH:mm');
      this.$refs.form.validate();
    },
    date: function date(value) {
      this.$refs.form.validate();
      console.log('date changed');
      console.log(value);
      if (this.latestJobEndTimeDateObj && __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).isSame(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.latestJobEndTime), 'day')) {
        this.minEndTime = this.latestJobEndTimeDateObj;
      } else {
        this.minEndTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day').toDate();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.getItem('lat') && localStorage.getItem('long')) {
      this.gps = localStorage.getItem('lat') + ' ' + localStorage.getItem('long');
      this.gpsAttemptComplete = true;
      this.gpsStatus = 'Using Static Machine GPS';
    } else if (navigator.geolocation) {
      this.gpsStatus = 'Getting GPS';
      navigator.geolocation.getCurrentPosition(function (position) {
        _this.gps = position.coords.latitude + ' ' + position.coords.longitude;
        _this.gpsStatus = 'GPS Acquired';
        _this.gpsAttemptComplete = true;
      }, function (error) {
        _this.gpsAttemptComplete = true;
        _this.gpsStatus = 'GPS Error';
        console.log(error);
      }, {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0
      });
    } else {
      this.gpsAttemptComplete = true;
      this.gpsStatus = 'GPS not available on this machine.';
    }
    this.$store.dispatch('checkLoginTime');
  },
  computed: {
    formatDate: function formatDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('DD/MM/YYYY');
    },
    maxEndTime: function maxEndTime() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(30, 'minutes').toDate();
    },
    applicationMode: function applicationMode() {
      return this.$store.getters.applicationMode;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    clockInDate: function clockInDate() {
      var timesheetData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
      return timesheetData[timesheetData.length - 1].start;
    },
    spanMidnight: function spanMidnight() {
      var clockIn = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.clockInDate, 'YYYY-MM-DD HH:mm:ss.SSS');
      var clockOut = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm');
      return !clockIn.isSame(clockOut, 'day');
    },
    timeRules: function timeRules() {
      var _this2 = this;

      var arr = [function (v) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this2.date + ' ' + _this2.timeFormat, 'YYYY-MM-DD HH:mm').isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(_this2.clockInDate, 'YYYY-MM-DD HH:mm:ss.SSS')) || 'Clocking out time must be after clocking in time';
      }];
      if (this.clockOutLimit > -1) {
        arr.push(function (v) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this2.date + ' ' + _this2.timeFormat, 'YYYY-MM-DD HH:mm').isSameOrBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()().add(_this2.clockOutLimit, 'minutes'), 'minute') || 'Clocking out in the future is not allowed';
        });
      }
      return arr;
    }
  },
  methods: {
    clockOut: function clockOut() {
      if (this.applicationMode === 'tacho' && this.spanMidnight === false) {
        this.tachoDayPrompt = true;
      } else {
        this.postObj.tacho = null;
        this.submitClockOut();
      }
    },
    addTachoDay: function addTachoDay() {
      var _this3 = this;

      this.addingTachoDay = true;
      var end = this.date + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.timeFormat, 'HH:mm').format('HH:mm');
      var tachoObj = {
        username: 'tanda.' + this.company,
        emp_id: this.user.empID.toString(),
        shift_start: this.clockInDate,
        shift_end: end + ':00.000'
      };
      console.log(tachoObj);
      // axios.post(this.url + '/cwelite_utilities/cwelite_utilities.svc/AddTachoDayToLegacy', {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/cwelite_utilities/cwelite_utilities.svc/AddTachoDayToLegacy', tachoObj).then(function (serviceResponse) {
        _this3.tachoDayPrompt = false;
        console.log(serviceResponse);
        if (serviceResponse.data.ExceptionMessage.length === 0) {
          _this3.tachoService.snackbar = true;
          _this3.tachoService.status = 1;
          _this3.tachoService.closeable = true;
          _this3.tachoService.msg = 'Tachograph day successfully added';
          _this3.postObj.tacho = 1;
        } else if (serviceResponse.data.emp_id === -1) {
          _this3.tachoService.snackbar = true;
          _this3.tachoService.status = 2;
          _this3.tachoService.closeable = true;
          _this3.tachoService.msg = 'Error adding Tachograph day: Employee not found.';
          _this3.postObj.tacho = 0;
        } else {
          _this3.tachoService.snackbar = true;
          _this3.tachoService.status = 2;
          _this3.tachoService.closeable = true;
          _this3.tachoService.msg = 'Error adding Tachograph day: ' + serviceResponse.data.ExceptionMessage;
          _this3.postObj.tacho = 0;
        }
        _this3.addingTachoDay = false;
        _this3.submitClockOut();
      }).catch(function (error) {
        _this3.tachoDayPrompt = false;
        console.log(error);
        _this3.addingTachoDay = false;
        _this3.tachoService.snackbar = true;
        _this3.tachoService.status = 2;
        _this3.tachoService.closeable = false;
        _this3.tachoService.msg = 'Error adding Tachograph day';
        _this3.postObj.tacho = 0;
        _this3.submitClockOut();
      });
    },
    submitClockOut: function submitClockOut() {
      var _this4 = this;

      if (this.$refs.form.validate()) {
        this.loading = true;
        var end = this.date + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.timeFormat, 'HH:mm').format('HH:mm');
        if (this.latestJobEndTime != null && __WEBPACK_IMPORTED_MODULE_1_moment___default()(end).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.latestJobEndTime))) {
          alert('End time is after latest job end time, Please verify job entries');
          this.loading = false;
          return;
        }
        if (this.emp !== '' && this.company !== '') {
          this.postObj = {
            emp: this.empID,
            company: this.company,
            type: 'out',
            data: {
              end: end,
              nightOut: this.nightOut,
              gps: this.gps,
              notes: this.notes,
              bonus: this.bonus
            }
          };
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/saveShiftsForEmp.ajax.php', this.postObj).then(function (response) {
            if (response.data > 0) {
              _this4.loading = false;
              _this4.completeDialog = true;
              _this4.addNewClockOut(end);
              _this4.shiftID = response.data;
            } else if (response.data === 'You Are Not Within A Suitable Location' || response.data === 'Invalid GPS format' || response.data === 'Invalid GPS coordinates') {
              alert(response.data);
              _this4.loading = false;
            }
          }).catch(function (error) {
            console.log('subMitClock3');
            _this4.loading = false;
            _this4.errorDialog = true;
            console.log(error);
          });
        }
      }
    },
    addNewClockOut: function addNewClockOut(end) {
      var _this5 = this;

      localStorage.removeItem('savedJobHistory');
      var timesheet = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
      for (var shift in timesheet) {
        if (typeof timesheet[shift].end === 'undefined') {
          timesheet[shift].end = end;
          break;
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('timesheet-archive', 'readwrite');
        var timesheetStore = tx.objectStore('timesheet-archive');
        timesheetStore.put(timesheet, _this5.empID);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    saveLocally: function saveLocally(data) {
      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox-timesheets', 'readwrite');
        var timesheetStore = tx.objectStore('outbox-timesheets');
        timesheetStore.put(data);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    formatTimeStringToDate: function formatTimeStringToDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time, 'HH:mm').toDate();
    },
    formatTimeDateToString: function formatTimeDateToString() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time).format('HH:mm');
    }
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dbPromise__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['pin'],
  data: function data() {
    return {
      mode: 'In',
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      load: [],
      completeDialog: false,
      errorDialog: false,
      errorDateDialog: false,
      company: this.$store.getters.company,
      clockInFlagLimit: this.$store.getters.clockInFlagLimit,
      loading: false,
      gps: null,
      loadIdRules: [function (v) {
        return v.length < 19 || 'Maximum length exceeded';
      }],
      nightOutRules: [function (v) {
        return v.length < 19 || 'Maximum length exceeded';
      }],
      nightOut: '',
      formValid: true,
      displayDisclaimer: true,
      clockInLimit: this.$store.getters.clockInLimit
    };
  },
  created: function created() {
    this.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
    this.time = __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
    if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
      this.displayDisclaimer = false;
    } else {
      this.displayDisclaimer = !this.$store.getters.disclaimerAccepted;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        _this.gps = position.coords.latitude + ' ' + position.coords.longitude;
      });
    }
    this.$store.dispatch('checkLoginTime');
  },

  watch: {
    time: function time(value) {
      this.timeFormat = __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(value)).format('hh:mm a');
    }
  },
  computed: {
    formatDate: function formatDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.date).format('DD/MM/YYYY');
    },
    timeRules: function timeRules() {
      var _this2 = this;

      var arr = [];
      if (this.clockInLimit > -1) {
        arr.push(function (v) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this2.date + ' ' + _this2.timeFormat, 'YYYY-MM-DD HH:mm a').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(_this2.clockInLimit, 'minutes'), 'minute') || 'Clocking out in the past is not allowed';
        });
      }
      return arr;
    }
  },
  methods: {
    refreshApp: function refreshApp() {
      location.reload();
    },
    submitClockIn: function submitClockIn() {
      var _this3 = this;

      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.mode === 'In') {
          var val = this.$refs.loadSelect.getCurrentTag();
          if (val !== '' && val !== undefined && val !== null) {
            this.triggerUpdateChip();
          }
        }
        var start = this.date + ' ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.timeFormat, 'hh:mm a').format('HH:mm');
        if (this.company !== '') {
          var delayedStart = 0;
          if (this.clockInFlagLimit && this.clockInFlagLimit > -1) {
            var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(start, 'YYYY-MM-DD HH:mm'), 'minutes');
            if (diff > this.clockInFlagLimit) {
              delayedStart = 1;
            }
          }
          var postObj = {
            pin: this.pin,
            company: this.company,
            type: this.mode.toLowerCase(),
            data: {
              start: start,
              end: start,
              load_array: this.load,
              nightOut: this.nightOut,
              gps: this.gps
            },
            delayed_start: delayedStart
          };
          __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* firedb */].ref('recoveryData').push(postObj).then(function () {
            _this3.loading = false;
            _this3.completeDialog = true;
          }).catch(function () {
            _this3.loading = false;
            _this3.errorDateDialog = true;
          });
        }
      }
    },
    addNewClockIn: function addNewClockIn(start) {
      var _this4 = this;

      var timesheet = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
      var newObj = { start: start };
      timesheet.push(newObj);

      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('timesheet-archive', 'readwrite');
        var timesheetStore = tx.objectStore('timesheet-archive');
        timesheetStore.put(timesheet, _this4.empID);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    saveLocally: function saveLocally(data) {
      Object(__WEBPACK_IMPORTED_MODULE_3__dbPromise__["a" /* default */])().then(function (db) {
        var tx = db.transaction('outbox-timesheets', 'readwrite');
        var timesheetStore = tx.objectStore('outbox-timesheets');
        timesheetStore.put(data);
        return tx.complete;
      }).then(function () {
        console.log('data saved locally');
      });
    },
    formatTimeStringToDate: function formatTimeStringToDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time, 'HH:mm').toDate();
    },
    formatTimeDateToString: function formatTimeDateToString() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.time).format('hh:mm a');
    },
    disclaimerAction: function disclaimerAction() {
      this.$router.push('/');
    },
    remove: function remove(item) {
      this.load.splice(this.load.indexOf(item), 1);
      this.load = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.load));
    },
    triggerUpdateChip: function triggerUpdateChip() {
      var sel = this.$refs.loadSelect;
      console.log(sel);
      var val = this.$refs.loadSelect.getCurrentTag();
      val = val.trim();
      this.load.push(val);
      sel.updateTags();
    },
    getCharCode: function getCharCode(e) {
      var charCode = e.target.value.charAt(e.target.value.length - 1).charCodeAt();
      if (charCode === 32 && this.$refs.loadSelect.getCurrentTag().trim() !== '') {
        this.triggerUpdateChip();
      }
    }
  }
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog'],
  data: function data() {
    return {
      translateDialog: false
    };
  },

  computed: {
    disclaimerText: function disclaimerText() {
      return this.$store.getters.disclaimerText;
    },
    disclaimerAccepted: function disclaimerAccepted() {
      return this.$store.getters.disclaimerAccepted;
    },
    disclaimerLanguage: function disclaimerLanguage() {
      return this.$store.getters.disclaimerLanguage;
    },
    languages: function languages() {
      return this.$store.getters.languages;
    }
  },
  created: function created() {
    this.disclaimerDialog = this.showDialog;
  },

  watch: {
    showDialog: function showDialog(val) {
      this.$store.dispatch('checkLoginTime');
    }
  },
  methods: {
    acceptDisclaimer: function acceptDisclaimer() {
      this.$emit('update:showDialog', false);
      this.$store.dispatch('acceptDisclaimer');
    },
    declineDisclaimer: function declineDisclaimer() {
      this.$emit('update:showDialog', false);
      this.$emit('declined');
    },
    hideDisclaimer: function hideDisclaimer() {
      this.$emit('update:showDialog', false);
    },
    selectLanguage: function selectLanguage(newLanguage) {
      this.$store.dispatch('setDisclaimerLanguage', newLanguage);
      this.translateDialog = false;
    }
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(39);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: false,
      alertText: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('appData/alert').once('value').then(function (result) {
      var val = result.val();
      _this.alertText = val.msg;
      if (val.visible === true) {
        _this.show = true;
      }
    });
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'taId'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      load: [],
      saving: false
    };
  },

  computed: {
    company: function company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    showDialog: function showDialog(val) {
      this.$store.dispatch('checkLoginTime');
    }
  },
  methods: {
    close: function close() {
      this.$emit('closeLoadDialog');
    },
    addLoads: function addLoads() {
      var _this = this;

      this.saving = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/tanda-service/addLoadsToShift.ajax.php', { load_ids: this.load, ta_id: this.taId, company: this.company }).then(function (result) {
        _this.saving = false;
        _this.$emit('closeLoadDialog');
        _this.load = [];
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'workerType', 'holAllowance', 'total_days_left', 'nextPeriodReleaseDays'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateFormat: 'Do MMMM',
      dateOne: '',
      dateTwo: '',
      length: 8,
      hour: this.company === 'lfp' ? '0' : '9',
      minute: '00',
      halfDay: false,
      halfDayPM: false,
      allowedHours: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      allowedMinutes: ['00', '30'],
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dateConfirmed: false,
      detailsConfirmed: false,
      loading: false,
      anotherRequest: false,
      whitelistedDates: [],
      whitelistedDatesCurrentYear: [],
      whitelistedDatesNextYear: [],
      subTotalDays: 0,
      subTotalDaysNextYear: 0,
      currentLieuAllowance: this.holAllowance.currentLieuAllowance,
      nextLieuAllowance: this.holAllowance.nextLieuAllowance,
      curentyearholidays: 0,
      nextyearholidays: 0,
      enoughDaysForHolidayThisYear: false,
      enoughDaysForHolidayNextYear: false,
      empDetails: [],
      holidayTypes: [],
      holiday_type: -1,
      included_in_allowance: 1,
      canEditHolType: 0,
      showHalfDay: 0,
      requestComment: '',
      listOfSelectedDatesWithCounts: [],
      taSettings: [],
      bookingThreshold: -1,
      gettingExistingRequests: false,
      requestsDayCounts: {},
      hourRule: function hourRule(v) {
        if (!v.trim()) {
          return true;
        }
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 23) return true;
        return 'Value has to be a valid 24 hour time';
      },
      minuteRule: function minuteRule(v) {
        if (!v.trim()) {
          return true;
        }
        if (!isNaN(parseFloat(v)) && v === 0 && v === 30) return true;
        return 'A shift can only start on the hour or half past the hour.';
      }
    };
  },

  computed: {
    dateOfThresholdForNextPeriod: function dateOfThresholdForNextPeriod() {
      var nextPeriodStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_start).add(1, 'year').startOf('day');
      var releaseDays = parseInt(this.nextPeriodReleaseDays, 10);
      var releaseDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(nextPeriodStart).subtract(releaseDays, 'days');
      // Leap year adjustment: if a Feb 29 falls within [releaseDay, nextPeriodStart),
      // subtract one extra day so the date stays consistent across leap/non-leap years
      var startYear = releaseDay.year();
      var endYear = nextPeriodStart.year();
      for (var y = startYear; y <= endYear; y++) {
        var feb29 = __WEBPACK_IMPORTED_MODULE_8_moment___default()(y + '-02-29', 'YYYY-MM-DD', true);
        if (feb29.isValid() && !releaseDay.isAfter(feb29) && nextPeriodStart.isAfter(feb29)) {
          releaseDay = releaseDay.subtract(1, 'day');
          break;
        }
      }
      return releaseDay.format('DD/MM/YYYY');
    },
    disableBtnForOtherBookings: function disableBtnForOtherBookings() {
      var threshold = this.bookingThreshold;
      return this.listOfSelectedDatesWithCounts.some(function (item) {
        return threshold !== -1 && threshold <= Number(item.count);
      });
    },
    selectedDateNextPeriodBeforeRelease: function selectedDateNextPeriodBeforeRelease() {
      if (this.nextPeriodReleaseDays === '-1') {
        return 0;
      } else {
        var nextPeriodStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_start).add(1, 'year').startOf('day');
        var hasNextPeriodDates = this.nextyearholidays > 0;
        if (!hasNextPeriodDates) return 0;
        var releaseDays = parseInt(this.nextPeriodReleaseDays, 10);
        var releaseDay = __WEBPACK_IMPORTED_MODULE_8_moment___default()(nextPeriodStart).subtract(releaseDays, 'days');
        // Leap year adjustment: if a Feb 29 falls within [releaseDay, nextPeriodStart),
        // subtract one extra day so the date stays consistent across leap/non-leap years
        var startYear = releaseDay.year();
        var endYear = nextPeriodStart.year();
        for (var y = startYear; y <= endYear; y++) {
          var feb29 = __WEBPACK_IMPORTED_MODULE_8_moment___default()(y + '-02-29', 'YYYY-MM-DD', true);
          if (feb29.isValid() && !releaseDay.isAfter(feb29) && nextPeriodStart.isAfter(feb29)) {
            releaseDay = releaseDay.subtract(1, 'day');
            break;
          }
        }
        var today = __WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf('day');
        return today.isBefore(releaseDay, 'day') ? 1 : 0;
      }
    },
    holidayTypeText: function holidayTypeText() {
      var _this = this;

      var matchingType = this.holidayTypes.find(function (type) {
        return type.value === _this.holiday_type;
      });
      return matchingType ? matchingType.text : 'Unknown';
    },
    filteredEndShiftTime: function filteredEndShiftTime() {
      if (this.hour * 1 + this.length < 24) {
        return this.hour * 1 + this.length;
      } else {
        return this.hour * 1 + this.length - 24;
      }
    },
    isButtonDisabled: function isButtonDisabled() {
      return this.loading || this.subTotalDays > 0 && this.enoughDaysForHolidayThisYear === false || this.subTotalDaysNextYear > 0 && this.enoughDaysForHolidayNextYear === false || this.whitelistedDates.length === 0;
    },

    // Numeric value of the `booking_threshold` TA setting, or NaN when unset.
    bookingThresholdSettingValue: function bookingThresholdSettingValue() {
      var setting = this.taSettings && this.taSettings.booking_threshold;
      return setting ? Number(setting.value) : NaN;
    }
  },
  created: function created() {
    this.getRegularDays();
    this.getHolidayTypes();
    this.getCompanyEditHolTypeSetting();
    this.getHalfDaySetting();
    this.getTASettings();
  },

  methods: {
    getTASettings: function getTASettings() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getTASettings.ajax.php', { company: this.company }).then(function (result) {
        if (result.data) {
          _this2.taSettings = result.data;
          _this2.bookingThreshold = Number(_this2.taSettings['booking_threshold_prevent_booking'].value);
        } else {
          _this2.taSettings = [];
        }
      });
    },
    allowedWhitelistDate: function allowedWhitelistDate(val) {
      if (__WEBPACK_IMPORTED_MODULE_8_moment___default()(val).isBetween(this.dateOne, this.dateTwo, undefined, '[]')) {
        return true;
      }
      return false;
    },
    formatNextHolPrdDate: function formatNextHolPrdDate(date, format) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).add(1, 'year').format(format);
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        formattedDates = __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(dateOne, this.dateFormat);
      }
      if (dateTwo && dateTwo !== dateOne) {
        formattedDates += ' - ' + __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    submitRequest: function submitRequest() {
      var _this3 = this;

      this.loading = true;
      var obj = { fname: this.user.fname, sname: this.user.sname, empID: this.user.empID, period_start: this.holAllowance.period_start, period_end: this.holAllowance.period_end, start: this.dateOne, end: this.dateTwo, hour: this.hour, minute: parseInt(this.minute), length: this.length, company: this.company, date_requested: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD HH:mm:ss'), whitelisted_days: this.whitelistedDates, holiday_type: this.holiday_type, holiday_type_text: this.holidayTypeText, included_in_allowance: this.included_in_allowance, request_comment: this.requestComment };
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/saveEmpHolRequest.ajax.php', obj).then(function (result) {
        if (result && result.data && result.data.status === 'OK') {
          _this3.loading = false;
          _this3.$emit('requestSubmitted', obj);
          _this3.anotherRequest = true;
          _this3.dateOne = '';
          _this3.dateTwo = '';
          _this3.dateConfirmed = false;
          _this3.detailsConfirmed = false;
          _this3.whitelistedDates = [];
          _this3.holiday_type = -1;
          _this3.included_in_allowance = 1;
          _this3.requestComment = '';
          // sending the email for the holiday request
          __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(_this3.url + '/tanda-service/sendEmailOnRequestToEmailAddress.ajax.php', obj).catch(function (e) {
            console.log(e);
          });
        } else {
          _this3.loading = false;
          _this3.$emit('requestSubmitted', obj);
          _this3.anotherRequest = true;
          _this3.dateOne = '';
          _this3.dateTwo = '';
          _this3.dateConfirmed = false;
          _this3.detailsConfirmed = false;
          _this3.whitelistedDates = [];
          _this3.holiday_type = -1;
          _this3.included_in_allowance = 1;
          _this3.requestComment = '';
          alert(result.data.message);
        }
      });
    },
    getHolidayTypes: function getHolidayTypes() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getHolidayTypes.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this4.holidayTypes = response.data.map(function (item) {
          return {
            text: item.holiday_type,
            value: item.ID,
            included_in_allowance: item.included_in_allowance
          };
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    getCompanyEditHolTypeSetting: function getCompanyEditHolTypeSetting() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getHolidayEditSetting.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this5.canEditHolType = response.data[0].value;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getHalfDaySetting: function getHalfDaySetting() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getHalfDaySetting.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this6.showHalfDay = response.data[0].value;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getRegularDays: function getRegularDays() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getRegularWorkDays.ajax.php', {
        company: this.company,
        empID: this.user.empID
      }).then(function (response) {
        _this7.empDetails = response.data;
        console.log(response.data);
        // initialise the whitelistedDates based on regular work days
        _this7.adjustWhiteListedDatesForRegularDays();
      }).catch(function (e) {
        console.log(e);
      });
    },
    adjustWhiteListedDatesForRegularDays: function adjustWhiteListedDatesForRegularDays() {
      // Clear the array if details are not confirmed
      if (!this.detailsConfirmed) {
        this.whitelistedDates = [];
      }
      var startDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateOne);
      var endDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateTwo);
      while (startDate.isSameOrBefore(endDate)) {
        var dayOfWeek = startDate.format('ddd').toLowerCase();
        var isRegular = this.empDetails.length > 0 && this.empDetails[0][dayOfWeek] === 1;
        if (isRegular) {
          this.whitelistedDates.push(startDate.format('YYYY-MM-DD'));
        }
        startDate.add(1, 'day');
      }
    },
    calculateOtherVariables: function calculateOtherVariables() {
      var currentYearStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_start);
      var currentYearEnd = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_end);

      // Filter the whitelistedDates based on whether they are in the current year
      var currentYearDates = this.whitelistedDates.filter(function (date) {
        var currentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date);
        return currentDate.isBetween(currentYearStart, currentYearEnd, null, '[]');
      });

      // Filter the whitelistedDates based on whether they are in the next year
      var nextYearDates = this.whitelistedDates.filter(function (date) {
        var currentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date);
        var nextYearStart = currentYearStart.clone().add(1, 'year');
        var nextYearEnd = currentYearEnd.clone().add(1, 'year');
        return currentDate.isBetween(nextYearStart, nextYearEnd, null, '[]');
      });

      this.curentyearholidays = currentYearDates.length;
      this.nextyearholidays = nextYearDates.length;
      this.subTotalDaysCalc();

      if (this.canEditHolType === '0') {
        // if the company does not allow the user to edit the holiday type use allowance AND Lieu allowance
        if (this.holAllowance.total_days_left + this.holAllowance.currentLieuAllowance - this.subTotalDays < 0) {
          this.enoughDaysForHolidayThisYear = false;
        } else if (this.holAllowance.total_days_left + this.holAllowance.currentLieuAllowance - this.subTotalDays >= 0) {
          this.enoughDaysForHolidayThisYear = true;
        }
        // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
        if (this.holAllowance.total_next_period_approved_days_left + this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear < 0) {
          this.enoughDaysForHolidayNextYear = false;
        } else if (this.holAllowance.total_next_period_approved_days_left + this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear >= 0) {
          this.enoughDaysForHolidayNextYear = true;
        }
      }
      // if the company allows the user to edit the holiday type use individual allowances
      if (this.canEditHolType === '1') {
        if (this.included_in_allowance === 0) {
          this.enoughDaysForHolidayThisYear = true;
        }
        if (this.included_in_allowance === 1) {
          // if theres exactly enough days or more than enough days in current period allow submit, else dont allow submit
          if (this.holAllowance.total_days_left - this.subTotalDays < 0) {
            this.enoughDaysForHolidayThisYear = false;
          } else if (this.holAllowance.total_days_left - this.subTotalDays >= 0) {
            this.enoughDaysForHolidayThisYear = true;
          }
          // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
          if (this.holAllowance.total_next_period_approved_days_left - this.subTotalDaysNextYear < 0) {
            this.enoughDaysForHolidayNextYear = false;
          } else if (this.holAllowance.total_next_period_approved_days_left - this.subTotalDaysNextYear >= 0) {
            this.enoughDaysForHolidayNextYear = true;
          }
        }
        if (this.included_in_allowance === 2) {
          // if theres exactly enough days or more than enough days in current period allow submit, else dont allow submit
          if (this.holAllowance.currentLieuAllowance - this.subTotalDays < 0) {
            this.enoughDaysForHolidayThisYear = false;
          } else if (this.holAllowance.currentLieuAllowance - this.subTotalDays >= 0) {
            this.enoughDaysForHolidayThisYear = true;
          }
          // if theres exactly enough days or more than enough days next period allow submit, else dont allow submit
          if (this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear < 0) {
            this.enoughDaysForHolidayNextYear = false;
          } else if (this.holAllowance.nextLieuAllowance - this.subTotalDaysNextYear >= 0) {
            this.enoughDaysForHolidayNextYear = true;
          }
        }
      }
    },
    updateWhitelistedDates: function updateWhitelistedDates() {
      var _this8 = this;

      var dateDiff = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateTwo).diff(this.dateOne, 'days');
      var outputCurrentYear = [];
      var outputNextYear = [];
      var updatedWhitelistedDates = [];
      var currentYearStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_start);
      var currentYearEnd = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_end);
      var nextYearStart = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_start).add(1, 'year');
      var nextYearEnd = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.holAllowance.period_end).add(1, 'year');
      var allDaysZero = this.empDetails.length > 0 && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(this.empDetails[0]).every(function (value) {
        return value === 0;
      });
      for (var index = 0; index < dateDiff + 1; index++) {
        var currentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateOne).add(index, 'days');
        var formattedDate = currentDate.format('YYYY-MM-DD');
        if (this.empDetails.length === 0 || this.areRegularDaysAllowed(currentDate)) {
          // Check if the date is in the current year or the next year
          var dateYear = currentDate;
          if (dateYear >= currentYearStart && dateYear <= currentYearEnd) {
            outputCurrentYear.push(formattedDate);
          } else if (dateYear >= nextYearStart && dateYear <= nextYearEnd) {
            outputNextYear.push(formattedDate);
          }
          updatedWhitelistedDates.push(formattedDate);
        }
      }
      // If all days are 0, use the full picked range
      if (allDaysZero) {
        updatedWhitelistedDates = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()({ length: dateDiff + 1 }, function (_, index) {
          return __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this8.dateOne).add(index, 'days').format('YYYY-MM-DD');
        });
      }
      this.whitelistedDatesCurrentYear = outputCurrentYear;
      this.whitelistedDatesNextYear = outputNextYear;
      this.whitelistedDates = updatedWhitelistedDates;
      this.calculateOtherVariables();
    },
    areRegularDaysAllowed: function areRegularDaysAllowed(date) {
      var dayOfWeek = date.format('ddd').toLowerCase();
      return this.empDetails.length > 0 && this.empDetails[0][dayOfWeek] === 1;
    },
    subTotalDaysCalc: function subTotalDaysCalc() {
      if (this.length === 8) {
        this.subTotalDays = this.curentyearholidays;
        this.subTotalDaysNextYear = this.nextyearholidays;
      } else if (this.length === 4) {
        this.subTotalDays = this.curentyearholidays / 2;
        this.subTotalDaysNextYear = this.nextyearholidays / 2;
      }
    },
    getBorderColour: function getBorderColour() {
      // logic to determine the border colour for the prompt on final screen of holiday request
      if (this.isButtonDisabled) {
        return '#EE0000'; // Red
      } else if (!this.isButtonDisabled && this.whitelistedDates.length > 0) {
        return '#008900'; // Green
      } else {
          return '#D54200'; // Orange
        }
    },
    getExistingRequestsCount: function getExistingRequestsCount() {
      var _this9 = this;

      var threshold = this.bookingThresholdSettingValue;
      if (!(threshold > 0)) {
        this.requestsDayCounts = {};
        this.gettingExistingRequests = false;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve();
      }
      this.gettingExistingRequests = true;
      return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.url + '/tanda-service/getEmpHolRequestsCount.ajax.php', { empID: this.user.empID, company: this.company, startDate: this.dateOne, endDate: this.dateTwo }).then(function (result) {
        if (result.data && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(result.data) === 'object' && !Array.isArray(result.data)) {
          _this9.requestsDayCounts = result.data;
        } else {
          _this9.requestsDayCounts = {};
        }
      }).catch(function (e) {
        console.log(e);
        _this9.requestsDayCounts = {};
      }).then(function () {
        _this9.gettingExistingRequests = false;
      });
    },

    updateSelectedDatesWithCounts: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var counts, entries, dateOne, dateTwo, startDate, endDate, selectedDates;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.dateOne || !this.dateTwo)) {
                  _context.next = 3;
                  break;
                }

                this.listOfSelectedDatesWithCounts = [];
                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this.getExistingRequestsCount();

              case 5:
                if (this.bookingThresholdSettingValue > 0) {
                  _context.next = 8;
                  break;
                }

                this.listOfSelectedDatesWithCounts = [];
                return _context.abrupt('return');

              case 8:
                // API wraps the day->count map under a `dates` property, so unwrap if present
                counts = this.requestsDayCounts || {};

                if (counts.dates !== undefined) {
                  counts = counts.dates;
                }
                // Normalise both shapes into an array of { date, count }
                entries = [];

                if (Array.isArray(counts)) {
                  entries = counts.map(function (item) {
                    return {
                      key: item.date || item.day || item.Date,
                      count: item.count !== undefined ? item.count : item.value
                    };
                  });
                } else if (counts && (typeof counts === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(counts)) === 'object') {
                  entries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(counts).map(function (key) {
                    return { key: key, count: counts[key] };
                  });
                }

                if (!(entries.length === 0)) {
                  _context.next = 15;
                  break;
                }

                this.listOfSelectedDatesWithCounts = [];
                return _context.abrupt('return');

              case 15:
                dateOne = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateOne).startOf('day');
                dateTwo = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.dateTwo).startOf('day');

                if (!(!dateOne.isValid() || !dateTwo.isValid())) {
                  _context.next = 20;
                  break;
                }

                this.listOfSelectedDatesWithCounts = [];
                return _context.abrupt('return');

              case 20:
                startDate = __WEBPACK_IMPORTED_MODULE_8_moment___default.a.min(dateOne, dateTwo);
                endDate = __WEBPACK_IMPORTED_MODULE_8_moment___default.a.max(dateOne, dateTwo);
                selectedDates = [];

                entries.forEach(function (entry) {
                  if (!entry.key) {
                    return;
                  }
                  var requestDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(entry.key, ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', __WEBPACK_IMPORTED_MODULE_8_moment___default.a.ISO_8601], false);
                  if (!requestDate.isValid()) {
                    requestDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(entry.key);
                  }
                  if (!requestDate.isValid()) {
                    return;
                  }
                  if (requestDate.isSameOrAfter(startDate, 'day') && requestDate.isSameOrBefore(endDate, 'day')) {
                    selectedDates.push({
                      date: requestDate.format('YYYY-MM-DD'),
                      dateFormatted: requestDate.format('DD/MM/YYYY'),
                      dayOfWeek: requestDate.format('dddd'),
                      count: Number(entry.count)
                    });
                  }
                });
                selectedDates.sort(function (a, b) {
                  return __WEBPACK_IMPORTED_MODULE_8_moment___default()(a.date).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.date));
                });
                this.listOfSelectedDatesWithCounts = selectedDates;

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateSelectedDatesWithCounts() {
        return _ref.apply(this, arguments);
      }

      return updateSelectedDatesWithCounts;
    }()
  },
  watch: {
    dateOne: function dateOne() {
      this.updateSelectedDatesWithCounts();
    },
    dateTwo: function dateTwo() {
      this.updateSelectedDatesWithCounts();
    },
    'halfDay': function halfDay() {
      if (this.halfDay) {
        this.length = 4;
      } else {
        this.length = 8;
        this.halfDayPM = false;
      }
    },
    'halfDayPM': function halfDayPM() {
      if (this.halfDayPM) {
        this.hour = 13;
      } else {
        this.hour = 9;
      }
    },
    'detailsConfirmed': function detailsConfirmed() {
      this.updateWhitelistedDates();
    },
    'whitelistedDates': function whitelistedDates() {
      this.calculateOtherVariables();
    },
    'holiday_type': function holiday_type() {
      var _this10 = this;

      var selectedHolidayType = this.holidayTypes.find(function (item) {
        return item.value === _this10.holiday_type;
      });
      if (selectedHolidayType) {
        this.included_in_allowance = selectedHolidayType.included_in_allowance;
      }
    }
  },
  filters: {
    filterTime: function filterTime(val) {
      if (val === 24) {
        return 0;
      }
      return val;
    },
    formatDate: function formatDate(date, format) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format(format);
    },
    formatNextHolPrdDate: function formatNextHolPrdDate(date, format) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).add(1, 'year').format(format);
    },
    filterActionText: function filterActionText(val) {
      if (val === 0) {
        return 'Pending';
      } else if (val === 1) {
        return 'Approved';
      } else if (val === 2) {
        return 'Declined';
      } else if (val === 3) {
        return 'Cancellation Requested';
      } else if (val === 5) {
        return 'Holiday Deleted';
      }
    },
    formatTime: function formatTime(val) {
      var startTimestamp = __WEBPACK_IMPORTED_MODULE_8_moment___default()('1970-01-01 ' + (val.hour * 1 < 10 ? '0' + val.hour : val.hour) + ':00').add(val.minute, 'minutes').format('h:mma');
      var endTime = val.hour + val.length > 24 ? val.hour + val.length - 24 : val.hour + val.length;
      var endTimestamp = __WEBPACK_IMPORTED_MODULE_8_moment___default()('1970-01-01 ' + endTime + ':00').add(val.minute, 'minutes').format('h:mma');
      // return val.hour * 1 + '    1970-01-01 ' + ((val.hour * 1) < 10 ? '0' + val.hour : val.hour) + ':00'
      return startTimestamp + ' - ' + endTimestamp;
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'requestObj'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      time: 9,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dateConfirmed: false,
      cancelHours: parseInt(localStorage.getItem('cancel_hours')) || 48,
      showThisDialog: false
    };
  },

  computed: {
    filteredEndShiftTime: function filteredEndShiftTime() {
      if (this.time < 16) {
        return this.time + 8;
      } else {
        return this.time + 8 - 24;
      }
    }
  },
  created: function created() {},

  watch: {
    showDialog: function showDialog(val) {
      this.showThisDialog = val;
    },
    showThisDialog: function showThisDialog(val) {
      if (!val) {
        this.$emit('closeEditRequestDialog');
      }
    }
  },
  methods: {
    isLessThan48HoursAway: function isLessThan48HoursAway(date) {
      var now = new Date();
      var startDate = new Date(date);
      var diffInHours = (startDate - now) / 1000 / 60 / 60;
      return diffInHours < this.cancelHours;
    },
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        formattedDates = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateOne, this.dateFormat);
      }
      if (dateTwo && dateTwo !== dateOne) {
        formattedDates += ' - ' + __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    submitRequest: function submitRequest() {
      var _this = this;

      var obj = { empID: this.user.empID, start: this.dateOne, end: this.dateTwo, time: this.time, company: this.company, date_requested: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD HH:mm:ss') };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/saveEmpHolRequest.ajax.php', obj).then(function (result) {
        _this.$emit('requestSubmitted', obj);
        _this.dateOne = '';
        _this.dateTwo = '';
        _this.dateConfirmed = false;
      });
    },
    removeHolRequest: function removeHolRequest(ID) {
      var _this2 = this;

      var obj = { company: this.company, empID: this.user.empID, cancellationID: ID, type: 0 };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/editEmpHolRequest.ajax.php', obj).then(function (result) {
        _this2.$emit('closeEditRequestDialog');
        _this2.$emit('requestSubmitted', obj);
        _this2.dateConfirmed = false;
      });
    },
    requestHolCancellation: function requestHolCancellation(ID) {
      var _this3 = this;

      var obj = { company: this.company, empID: this.user.empID, cancellationID: ID, type: 1 };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.url + '/tanda-service/editEmpHolRequest.ajax.php', obj).then(function (result) {
        _this3.$emit('closeEditRequestDialog');
        _this3.$emit('requestSubmitted', obj);
        _this3.dateConfirmed = false;
      });
    },
    allowedValues: function allowedValues() {
      return 0;
    }
  },
  filters: {
    filterTime: function filterTime(val) {
      if (val === 24) {
        return 0;
      }
      return val;
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      dateConfirmed: false
    };
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'trip'],
  data: function data() {
    return {
      url: this.$store.getters.url,
      dateFormat: 'Do MMMM',
      dateOne: '',
      dateTwo: '',
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      detailsConfirmed: false,
      loading: false,
      schengenCountries: [],
      selected_country: null
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getSchengenCountries();
    this.populateFromTrip();
  },

  methods: {
    formatDates: function formatDates(dateOne, dateTwo) {
      var formattedDates = '';
      if (dateOne) {
        formattedDates = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateOne, this.dateFormat);
      }
      if (dateTwo && dateTwo !== dateOne) {
        formattedDates += ' - ' + __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    populateFromTrip: function populateFromTrip() {
      if (!this.trip) {
        this.dateOne = '';
        this.dateTwo = '';
        this.selected_country = null;
        return;
      }
      this.dateOne = this.trip.start_date || '';
      this.dateTwo = this.trip.end_date || '';
      this.setSelectedCountryFromTrip();
    },
    setSelectedCountryFromTrip: function setSelectedCountryFromTrip() {
      var _this = this;

      if (!this.trip) {
        this.selected_country = null;
        return;
      }
      if (this.trip.country_id) {
        this.selected_country = this.trip.country_id;
        return;
      }
      if (this.trip.country && this.schengenCountries.length) {
        var match = this.schengenCountries.find(function (c) {
          return c.text === _this.trip.country;
        });
        this.selected_country = match ? match.value : null;
      }
    },
    getSchengenCountries: function getSchengenCountries() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getSchengenCountries.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this2.schengenCountries = response.data.map(function (item) {
          return {
            value: item.country_id,
            text: item.country_name,
            code: item.country_code
          };
        });
        _this2.setSelectedCountryFromTrip();
      }).catch(function (e) {
        console.log(e);
      });
    },
    saveTrip: function saveTrip() {
      this.$emit('editSchengenTrip', {
        trip_id: this.trip ? this.trip.trip_id : null,
        startDate: this.dateOne,
        endDate: this.dateTwo,
        country: this.selected_country
      });
      this.$emit('closeEditSchengenRequest');
    }
  },
  watch: {
    trip: {
      handler: function handler() {
        this.populateFromTrip();
      },

      deep: true
    },
    showDialog: function showDialog(val) {
      if (val) {
        this.populateFromTrip();
      }
    }
  },
  filters: {}
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_auth__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_database__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_airbnb_style_datepicker__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_airbnb_style_datepicker_dist_vue_airbnb_style_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ClockInComponent_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ClockOutComponent_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_RecoveryModeFormComponent_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DisclaimerDialog_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_NoticeAlert_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AddLoadDialog_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NewHolidayRequestDialog_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_EditHolidayRequestDialog_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AnotherHolidayRequestDialog_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_SchengenRequest_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_EditSchengenRequest_vue__ = __webpack_require__(494);


























__webpack_require__(68);
__webpack_require__(496);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a, {
  theme: {
    primary: '#1E2D4F',
    secondary: '#50C3F9',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_buefy__["a" /* Timepicker */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Clock-In', __WEBPACK_IMPORTED_MODULE_13__components_ClockInComponent_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Clock-Out', __WEBPACK_IMPORTED_MODULE_14__components_ClockOutComponent_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Recovery-Form', __WEBPACK_IMPORTED_MODULE_15__components_RecoveryModeFormComponent_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Disclaimer-Dialog', __WEBPACK_IMPORTED_MODULE_16__components_DisclaimerDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Add-Load-Dialog', __WEBPACK_IMPORTED_MODULE_18__components_AddLoadDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('New-Holiday-Request-Dialog', __WEBPACK_IMPORTED_MODULE_19__components_NewHolidayRequestDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Edit-Holiday-Request-Dialog', __WEBPACK_IMPORTED_MODULE_20__components_EditHolidayRequestDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Another-Holiday-Request-Dialog', __WEBPACK_IMPORTED_MODULE_21__components_AnotherHolidayRequestDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Schengen-Request', __WEBPACK_IMPORTED_MODULE_22__components_SchengenRequest_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Edit-Schengen-Request', __WEBPACK_IMPORTED_MODULE_23__components_EditSchengenRequest_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Notice-Alert', __WEBPACK_IMPORTED_MODULE_17__components_NoticeAlert_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var datepickerOptions = {
  colors: {
    selected: '#337ab7',
    inRange: '#429ded',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#3378b5',
    disabled: '#fff'
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_airbnb_style_datepicker__["a" /* default */], datepickerOptions);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    var company = localStorage.getItem('company') !== null && localStorage.getItem('company') !== undefined ? localStorage.company : null;
    this.$store.dispatch('checkCompany', company);
    var url = localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com';
    this.$store.dispatch('setURL', url);
    __WEBPACK_IMPORTED_MODULE_8_firebase_app__["auth"]().signOut(); // Make sure we don't have a user authenticated with firebase initially
    __WEBPACK_IMPORTED_MODULE_8_firebase_app__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        console.log('Authenticated with firebase, uid = ' + user.uid);
        // ...
      } else {
        console.log('Unauthenticated from firebase');
        if (!_this.$router.currentRoute.path.includes('signin')) {
          _this.$router.push('/signin');
        }
        // User is signed out.
        // ...
      }
      if (_this.$router.currentRoute.path.includes('signin/')) {
        window.addEventListener('visibilitychange', function () {
          if (!document.hidden && _this.$router.currentRoute.path.indexOf('Expenses') === -1) {
            window.location.reload();
          }
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_8_firebase_app__["database"]().ref('appData/versions').once('value').then(function (result) {
      var latestVersions = result.val();
      if (localStorage.getItem('db-version')) {
        var currentDbVersion = localStorage.getItem('db-version');
        if (latestVersions.db !== currentDbVersion) {
          console.log('Database outdated, clearing local storage');
          localStorage.removeItem('languages');
          localStorage.removeItem('disclaimerText');
          localStorage.setItem('db-version', latestVersions.db);
        }
      }
      if (latestVersions.app !== _this.appVersion) {
        console.log('App outdated, need to update');
        _this.$store.dispatch('appOutdated', true);
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  data: function data() {
    return {
      appVersion: '0.10.75'
    };
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29997b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29997b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-navigation-drawer',{attrs:{"fixed":"","app":"","right":"","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{attrs:{"router":"","to":"/","exact":""}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Home")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"router":"","to":"/settings"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Settings")])],1)],1),_vm._v(" "),(_vm.hasDisclaimer)?_c('v-list-tile',{on:{"click":_vm.showDisclaimer}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("description")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("View Disclaimer")])],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"mt-3"}),_vm._v(" "),(_vm.user !== null)?_c('v-list-tile',{attrs:{"router":""},on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Log Out")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"fixed":"","app":"","color":"primary","dark":""}},[(_vm.user !== null)?_c('v-btn',{attrs:{"icon":"","to":"/"}},[_c('v-icon',[_vm._v("home")])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{attrs:{"right":""},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}})],1),_vm._v(" "),_c('v-alert',{staticStyle:{"position":"fixed","top":"60px","width":"100%","z-index":"100"},attrs:{"value":_vm.appOutdated,"color":"warning","icon":"history"}},[_vm._v("The application has an update available "),_c('v-btn',{attrs:{"color":"success","depressed":""},on:{"click":_vm.resetApp}},[_vm._v("Click here to update")])],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('Disclaimer-Dialog',{attrs:{"show-dialog":_vm.disclaimer},on:{"update:showDialog":function($event){_vm.disclaimer=$event},"update:show-dialog":function($event){_vm.disclaimer=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Expenses__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ViewExpenses__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TimesheetEntry__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_JobOverview__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Settings__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Signin__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HolidayRequest__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_JobDetails__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SchengenRequest__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SchengenTrips__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AuthGuard__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NotAuthGuard__ = __webpack_require__(423);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/Settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Settings__["a" /* default */]
  }, {
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/Expenses/:shiftID?',
    name: 'Expenses',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Expenses__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */],
    props: true
  }, {
    path: '/ViewExpenses/:shiftID?',
    name: 'ViewExpenses',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ViewExpenses__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */],
    props: true
  }, {
    path: '/TimesheetEntry/:intent',
    name: 'TimesheetEntry',
    component: __WEBPACK_IMPORTED_MODULE_5__components_TimesheetEntry__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/JobDetails/:taID/:shiftInProgress/:jobID?',
    name: 'JobDetails',
    component: __WEBPACK_IMPORTED_MODULE_10__components_JobDetails__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/HolidayRequest',
    name: 'HolidayRequest',
    component: __WEBPACK_IMPORTED_MODULE_9__components_HolidayRequest__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/SchengenTrips',
    name: 'SchengenTrips',
    component: __WEBPACK_IMPORTED_MODULE_12__components_SchengenTrips__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/SchengenRequest',
    name: 'SchengenRequest',
    component: __WEBPACK_IMPORTED_MODULE_11__components_SchengenRequest__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/JobOverview/:taID',
    name: 'JobOverview',
    component: __WEBPACK_IMPORTED_MODULE_6__components_JobOverview__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_13__AuthGuard__["a" /* default */]
  }, {
    path: '/signin/:company?/:emp?',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Signin__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_14__NotAuthGuard__["a" /* default */]
  }]
}));

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50779c80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(371);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50779c80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 109,
	"./af.js": 109,
	"./ar": 110,
	"./ar-dz": 111,
	"./ar-dz.js": 111,
	"./ar-kw": 112,
	"./ar-kw.js": 112,
	"./ar-ly": 113,
	"./ar-ly.js": 113,
	"./ar-ma": 114,
	"./ar-ma.js": 114,
	"./ar-ps": 115,
	"./ar-ps.js": 115,
	"./ar-sa": 116,
	"./ar-sa.js": 116,
	"./ar-tn": 117,
	"./ar-tn.js": 117,
	"./ar.js": 110,
	"./az": 118,
	"./az.js": 118,
	"./be": 119,
	"./be.js": 119,
	"./bg": 120,
	"./bg.js": 120,
	"./bm": 121,
	"./bm.js": 121,
	"./bn": 122,
	"./bn-bd": 123,
	"./bn-bd.js": 123,
	"./bn.js": 122,
	"./bo": 124,
	"./bo.js": 124,
	"./br": 125,
	"./br.js": 125,
	"./bs": 126,
	"./bs.js": 126,
	"./ca": 127,
	"./ca.js": 127,
	"./cs": 128,
	"./cs.js": 128,
	"./cv": 129,
	"./cv.js": 129,
	"./cy": 130,
	"./cy.js": 130,
	"./da": 131,
	"./da.js": 131,
	"./de": 132,
	"./de-at": 133,
	"./de-at.js": 133,
	"./de-ch": 134,
	"./de-ch.js": 134,
	"./de.js": 132,
	"./dv": 135,
	"./dv.js": 135,
	"./el": 136,
	"./el.js": 136,
	"./en-au": 137,
	"./en-au.js": 137,
	"./en-ca": 138,
	"./en-ca.js": 138,
	"./en-gb": 139,
	"./en-gb.js": 139,
	"./en-ie": 140,
	"./en-ie.js": 140,
	"./en-il": 141,
	"./en-il.js": 141,
	"./en-in": 142,
	"./en-in.js": 142,
	"./en-nz": 143,
	"./en-nz.js": 143,
	"./en-sg": 144,
	"./en-sg.js": 144,
	"./eo": 145,
	"./eo.js": 145,
	"./es": 146,
	"./es-do": 147,
	"./es-do.js": 147,
	"./es-mx": 148,
	"./es-mx.js": 148,
	"./es-us": 149,
	"./es-us.js": 149,
	"./es.js": 146,
	"./et": 150,
	"./et.js": 150,
	"./eu": 151,
	"./eu.js": 151,
	"./fa": 152,
	"./fa.js": 152,
	"./fi": 153,
	"./fi.js": 153,
	"./fil": 154,
	"./fil.js": 154,
	"./fo": 155,
	"./fo.js": 155,
	"./fr": 156,
	"./fr-ca": 157,
	"./fr-ca.js": 157,
	"./fr-ch": 158,
	"./fr-ch.js": 158,
	"./fr.js": 156,
	"./fy": 159,
	"./fy.js": 159,
	"./ga": 160,
	"./ga.js": 160,
	"./gd": 161,
	"./gd.js": 161,
	"./gl": 162,
	"./gl.js": 162,
	"./gom-deva": 163,
	"./gom-deva.js": 163,
	"./gom-latn": 164,
	"./gom-latn.js": 164,
	"./gu": 165,
	"./gu.js": 165,
	"./he": 166,
	"./he.js": 166,
	"./hi": 167,
	"./hi.js": 167,
	"./hr": 168,
	"./hr.js": 168,
	"./hu": 169,
	"./hu.js": 169,
	"./hy-am": 170,
	"./hy-am.js": 170,
	"./id": 171,
	"./id.js": 171,
	"./is": 172,
	"./is.js": 172,
	"./it": 173,
	"./it-ch": 174,
	"./it-ch.js": 174,
	"./it.js": 173,
	"./ja": 175,
	"./ja.js": 175,
	"./jv": 176,
	"./jv.js": 176,
	"./ka": 177,
	"./ka.js": 177,
	"./kk": 178,
	"./kk.js": 178,
	"./km": 179,
	"./km.js": 179,
	"./kn": 180,
	"./kn.js": 180,
	"./ko": 181,
	"./ko.js": 181,
	"./ku": 182,
	"./ku-kmr": 183,
	"./ku-kmr.js": 183,
	"./ku.js": 182,
	"./ky": 184,
	"./ky.js": 184,
	"./lb": 185,
	"./lb.js": 185,
	"./lo": 186,
	"./lo.js": 186,
	"./lt": 187,
	"./lt.js": 187,
	"./lv": 188,
	"./lv.js": 188,
	"./me": 189,
	"./me.js": 189,
	"./mi": 190,
	"./mi.js": 190,
	"./mk": 191,
	"./mk.js": 191,
	"./ml": 192,
	"./ml.js": 192,
	"./mn": 193,
	"./mn.js": 193,
	"./mr": 194,
	"./mr.js": 194,
	"./ms": 195,
	"./ms-my": 196,
	"./ms-my.js": 196,
	"./ms.js": 195,
	"./mt": 197,
	"./mt.js": 197,
	"./my": 198,
	"./my.js": 198,
	"./nb": 199,
	"./nb.js": 199,
	"./ne": 200,
	"./ne.js": 200,
	"./nl": 201,
	"./nl-be": 202,
	"./nl-be.js": 202,
	"./nl.js": 201,
	"./nn": 203,
	"./nn.js": 203,
	"./oc-lnc": 204,
	"./oc-lnc.js": 204,
	"./pa-in": 205,
	"./pa-in.js": 205,
	"./pl": 206,
	"./pl.js": 206,
	"./pt": 207,
	"./pt-br": 208,
	"./pt-br.js": 208,
	"./pt.js": 207,
	"./ro": 209,
	"./ro.js": 209,
	"./ru": 210,
	"./ru.js": 210,
	"./sd": 211,
	"./sd.js": 211,
	"./se": 212,
	"./se.js": 212,
	"./si": 213,
	"./si.js": 213,
	"./sk": 214,
	"./sk.js": 214,
	"./sl": 215,
	"./sl.js": 215,
	"./sq": 216,
	"./sq.js": 216,
	"./sr": 217,
	"./sr-cyrl": 218,
	"./sr-cyrl.js": 218,
	"./sr.js": 217,
	"./ss": 219,
	"./ss.js": 219,
	"./sv": 220,
	"./sv.js": 220,
	"./sw": 221,
	"./sw.js": 221,
	"./ta": 222,
	"./ta.js": 222,
	"./te": 223,
	"./te.js": 223,
	"./tet": 224,
	"./tet.js": 224,
	"./tg": 225,
	"./tg.js": 225,
	"./th": 226,
	"./th.js": 226,
	"./tk": 227,
	"./tk.js": 227,
	"./tl-ph": 228,
	"./tl-ph.js": 228,
	"./tlh": 229,
	"./tlh.js": 229,
	"./tr": 230,
	"./tr.js": 230,
	"./tzl": 231,
	"./tzl.js": 231,
	"./tzm": 232,
	"./tzm-latn": 233,
	"./tzm-latn.js": 233,
	"./tzm.js": 232,
	"./ug-cn": 234,
	"./ug-cn.js": 234,
	"./uk": 235,
	"./uk.js": 235,
	"./ur": 236,
	"./ur.js": 236,
	"./uz": 237,
	"./uz-latn": 238,
	"./uz-latn.js": 238,
	"./uz.js": 237,
	"./vi": 239,
	"./vi.js": 239,
	"./x-pseudo": 240,
	"./x-pseudo.js": 240,
	"./yo": 241,
	"./yo.js": 241,
	"./zh-cn": 242,
	"./zh-cn.js": 242,
	"./zh-hk": 243,
	"./zh-hk.js": 243,
	"./zh-mo": 244,
	"./zh-mo.js": 244,
	"./zh-tw": 245,
	"./zh-tw.js": 245
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalMessage_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50dda86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalMessage_vue__ = __webpack_require__(370);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50dda86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGlobalMessage)?_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.dialogVisible),callback:function ($$v) {_vm.dialogVisible=$$v},expression:"dialogVisible"}},[_c('v-card',[(_vm.messages.length > 0)?_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.messages[_vm.messageIndex].title)+" - "+_vm._s(_vm._f("formatDate")(_vm.messages[_vm.messageIndex].createdOn)))]):_vm._e(),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"0px 18px 0px 18px"}},[(_vm.messages.length > 0)?_c('div',[_vm._v("\n        "+_vm._s(_vm.messages[_vm.messageIndex].content)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding":"0px 14px 0px 14px"}},[_c('v-checkbox',{attrs:{"label":"I have read and understand this message"},model:{value:(_vm.messageReadCheckboxes[_vm.messageIndex]),callback:function ($$v) {_vm.$set(_vm.messageReadCheckboxes, _vm.messageIndex, $$v)},expression:"messageReadCheckboxes[messageIndex]"}}),_vm._v(" "),(!_vm.isLastMessage)?_c('v-btn',{staticClass:"ml-auto",attrs:{"disabled":!_vm.messageReadCheckboxes[_vm.messageIndex]},on:{"click":_vm.nextMessage}},[_vm._v("Next Message")]):_vm._e(),_vm._v(" "),(_vm.isLastMessage)?_c('v-btn',{staticClass:"ml-auto",attrs:{"stacked":"","disabled":!_vm.allCheckboxesCompleted},on:{"click":_vm.submitMessages}},[_vm._v("Accept Messages")]):_vm._e()],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100%"},on:{"click":function($event){_vm.timer > 0 ? _vm.timer = _vm.timerDefault : ''}}},[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fluid":""}},[(_vm.timer > 0)?_c('p',{staticClass:"caption text-xs-right"},[_vm._v("Auto signout in "+_vm._s(_vm.logoutCountdown))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"headline text-xs-center"},[_vm._v("Welcome "+_vm._s(_vm.fullname))]),_vm._v(" "),(_vm.modules.pod2 === 1)?[_c('hr')]:_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":"","wrap":"","grid-list-xs":"","justify-center":""}},[(_vm.modules.expenses === 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","to":"/Expenses","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-receipt-text")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Receipt Capture")])],1)],1):_vm._e(),_vm._v(" "),(_vm.modules.viewexpenses === 1 && _vm.showExpenses === '1')?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","to":"/ViewExpenses","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-receipt-text-clock")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("View Expenses")])],1)],1):_vm._e(),_vm._v(" "),(_vm.modules.pod === 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"disabled":_vm.clockedIn,"color":"purple darken-2","large":"","flat":"","icon":""},on:{"click":function($event){_vm.loadDialog = true}}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("local_shipping")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Add Additional Loads")])],1)],1):_vm._e(),_vm._v(" "),(_vm.modules.jobEntry === 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"disabled":_vm.clockedIn || _vm.loadingTimeline,"color":"purple darken-2","to":'/JobDetails/' + _vm.taId + '/1/' +  (_vm.jobStarted ? _vm.latestJobId : -1),"large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v(_vm._s(!_vm.jobStarted ? 'Start New Job' : 'End Job'))])],1)],1):_vm._e(),_vm._v(" "),(_vm.modules.timesheets === 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"disabled":!_vm.clockedIn,"color":"green darken-2","to":"/TimesheetEntry/in","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("file_download")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Clock In")])],1)],1):_vm._e(),_vm._v(" "),(_vm.modules.timesheets === 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"disabled":_vm.clockedIn || (_vm.modules.jobEntry === 1 && (_vm.jobStarted || !_vm.anyJobsInShift)),"color":"red darken-2","to":"/TimesheetEntry/out","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("file_upload")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Clock Out")])],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.user.modules.holrequest == 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"orange darken-2","to":"/HolidayRequest","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("work")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Holiday Request")])],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.user.modules.Schengen == 1)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"blue darken-2","to":"/SchengenTrips","large":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-earth")])],1),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Schengen Trips")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.timelineFailed && _vm.loadingTimeline && _vm.modules.jobEntry === 1),expression:"!timelineFailed && loadingTimeline && modules.jobEntry === 1"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs-12":""}},[_c('v-progress-circular',{staticClass:"ma-5",attrs:{"size":70,"width":7,"indeterminate":"","color":"primary"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.timelineFailed && _vm.modules.jobEntry === 1),expression:"timelineFailed && modules.jobEntry === 1"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center ms-3 mb-4 pa-4 elevation-10",attrs:{"xs-12":""}},[_c('div',{staticClass:"title"},[_vm._v("Failed to load timeline")]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v("Check your connection and try again")])])],1),_vm._v(" "),(_vm.savedJobData.length > 0 && _vm.modules.jobEntry === 1 && !_vm.loadingTimeline && !_vm.clockedIn)?_c('v-subheader',[_vm._v("Jobs\n          Completed In Current Shift")]):_vm._e(),_vm._v(" "),(_vm.savedJobData.length > 0 && _vm.modules.jobEntry === 1 && !_vm.loadingTimeline && !_vm.clockedIn)?_c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((_vm.savedJobData),function(job,p){return _c('v-timeline-item',{key:p,attrs:{"color":job.end_time == null ? 'green' : 'grey',"small":""}},[_c('v-layout',{attrs:{"pt-2":""}},[_c('v-flex',{attrs:{"align-center":""}},[_c('div',{staticClass:"subheading"},[_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(job.start_time))+" - "+_vm._s(_vm._f("formatDate")(job.end_time)))])]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm._f("filterJobTime")(job.start_time))+"-"+_vm._s(_vm._f("filterJobTime")(job.end_time))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm._f("formattedJobLength")(job)))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(job.farm_name))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(job.job_desc_name)+" "+_vm._s(job.product_name))]),_vm._v(" "),(job.spray_bonus != null)?_c('div',{key:p,staticClass:"caption"},[_vm._v(_vm._s(job.spray_bonus)+" Hectares")]):_vm._e()])]),_vm._v(" "),(job.end_time !== null)?_c('v-flex',{attrs:{"justify-end":"","shrink":""}},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":"","to":'/JobDetails/' + _vm.taId + '/1/' + job.job_id}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("mode_edit")])],1)],1):_vm._e()],1)],1)}),1):_vm._e(),_vm._v(" "),(_vm.modules.timesheets === 1)?_c('v-alert',{attrs:{"v-model":_vm.timesheetData.length < 1,"type":"info"}},[_vm._v("No Recent\n          Shifts")]):_vm._e(),_vm._v(" "),(_vm.timesheetData.length > 0 && _vm.modules.timesheets === 1)?_c('v-list',{attrs:{"subheader":"","three-line":"","dark":""}},[_c('v-subheader',[_vm._v("Recent Shifts")]),_vm._v(" "),_vm._l((_vm.timesheetData),function(shift,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{staticClass:"grey--text text--darken-1"},[_vm._v("IN:")]),_vm._v(" "+_vm._s(_vm._f("formatDateTime")(shift.start)))]),_vm._v(" "),_c('v-list-tile-title',[_c('strong',{staticClass:"grey--text text--darken-1"},[_vm._v("OUT:")]),_vm._v(" "+_vm._s(_vm._f("formatDateTime")(shift.end)))]),_vm._v(" "),(shift.penalty)?_c('v-list-tile-title',{staticStyle:{"min-height":"fit-content"}},[_c('strong',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.penaltyName)+":")]),_vm._v(" "+_vm._s(_vm._f("formatTime")(shift.penalty))+"\n              "),_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"icon":"","dense":""},on:{"click":function($event){return _vm.showPenaltyReason(shift.penalty_reason)}}},[_c('v-icon',[_vm._v("mdi-information")])],1)],1):_vm._e()],1),_vm._v(" "),(shift.end !== undefined && _vm.modules.expenses === 1)?_c('v-list-tile-action',[_c('div',[_c('v-btn',{attrs:{"icon":"","ripple":"","to":'/Expenses/' + shift.id}},[_c('v-badge',{attrs:{"left":"","overlap":"","color":"green"}},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("add")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"grey darken-1","medium":""}},[_vm._v("\n                      receipt\n                    ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.modules.jobEntry === 1 && shift.end !== undefined)?_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":"","to":'/JobOverview/' + shift.id}},[_c('v-icon',{attrs:{"color":"grey darken-1","medium":""}},[_vm._v("\n                      assignment\n                  ")])],1)],1):_vm._e()],1)})],2):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('Notice-Alert')],1)],1)],2)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarTimeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('Add-Load-Dialog',{attrs:{"showDialog":_vm.loadDialog,"taId":_vm.taId},on:{"closeLoadDialog":function($event){_vm.loadDialog = false}}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.penaltyDialog),callback:function ($$v) {_vm.penaltyDialog=$$v},expression:"penaltyDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(_vm.penaltyName)+" Reason\n      ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.penaltyReason)+"  \n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.penaltyDialog = false}}},[_vm._v("\n          Close\n        ")])],1)],1)],1),_vm._v(" "),_c('GlobalMessage',{attrs:{"showDialog":_vm.showGlobalMessage},on:{"closeDialog":function($event){_vm.showGlobalMessage = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expenses_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461258dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expenses_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_461258dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.submitDialog),callback:function ($$v) {_vm.submitDialog=$$v},expression:"submitDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Link expenses to a shift")]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":"Link to shift","items":_vm.shiftArray,"item-text":"text","item-value":"key","no-data-text":"No full shifts to link to"},model:{value:(_vm.linkedShift),callback:function ($$v) {_vm.linkedShift=$$v},expression:"linkedShift"}}),_vm._v("\n        Submitting this claim will link the claim to the shift above.\n      ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","flat":""},nativeOn:{"click":function($event){_vm.submitDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","loading":_vm.isLoading,"flat":""},nativeOn:{"click":function($event){return _vm.submitClaim.apply(null, arguments)}}},[_vm._v("Submit Claim")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Offline")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"cloud_off","type":"error"},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_vm._v("You are currently offline, Please try again\n          later")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorText))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.unauthorisedDialog),callback:function ($$v) {_vm.unauthorisedDialog=$$v},expression:"unauthorisedDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Access Denied")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"block","type":"error"},model:{value:(_vm.unauthorisedDialog),callback:function ($$v) {_vm.unauthorisedDialog=$$v},expression:"unauthorisedDialog"}},[_vm._v("The server could not authorise this request.\n          Please try logging in again and submitting the claim.")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Exit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1200","persistent":""},model:{value:(_vm.currencyDialog),callback:function ($$v) {_vm.currencyDialog=$$v},expression:"currencyDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Change Expenses Currency")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xs":"","align-content-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.currencies),function(currency,key,index){return (currency.show == 1)?_c('v-flex',{key:index,staticClass:"text-xs-center",attrs:{"xs6":"","sm2":"","lg1":""}},[_c('div',{on:{"click":function($event){return _vm.setCurrency(key)}}},[_c('v-btn',{staticClass:"green white--text hidden-sm-and-down",attrs:{"fab":"","large":""}},[_c('span',{staticStyle:{"font-size":"28px"}},[_vm._v(_vm._s(currency.text))])]),_vm._v(" "),_c('v-btn',{staticClass:"green white--text display hidden-xs-only hidden-md-and-up",attrs:{"fab":""}},[_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(currency.text))])]),_vm._v(" "),_c('v-btn',{staticClass:"green white--text hidden-sm-and-up",attrs:{"fab":"","small":""}},[_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(currency.text))])])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(currency.desc))])]):_vm._e()}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',[_vm._v("Changing currency will affect all claim items. If you need to make claims with different\n              currencies, submit the claim with the first currency and then change the currency and make a second\n              claim.")])],1)],2)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"mb-3"},[(_vm.hasClaim)?_c('v-btn',{staticClass:"primary",attrs:{"block":"","loading":_vm.isLoading},on:{"click":function($event){$event.stopPropagation();_vm.submitDialog = true}}},[_vm._v("Submit\n            Claim")]):_vm._e()],1),_vm._v(" "),_c('v-fab-transition',[(!_vm.claimContainsMileage)?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.newClaim),expression:"newClaim"}],attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"pink"},on:{"click":_vm.addClaim}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-fab-transition',[(!_vm.claimContainsMileage)?_c('v-btn',{attrs:{"fab":"","dark":"","right":"","small":"","absolute":"","color":"green"},on:{"click":function () { return _vm.currencyDialog = true; }}},[_vm._v("\n            "+_vm._s(_vm.currentCurrency.text)+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('v-alert',{staticClass:"mb-5",attrs:{"type":"info","value":!_vm.hasClaim}},[_vm._v("\n            To start a claim add an item using the + button.\n          ")])],1),_vm._v(" "),(_vm.hasClaim)?_c('v-list',{attrs:{"subheader":""}},[_c('v-subheader',[_vm._v("\n            Current Claim\n          ")]),_vm._v(" "),_vm._l((_vm.currentClaim),function(claim,i){return _c('v-list-tile',{key:i,attrs:{"avatar":""}},[_c('v-list-tile-content',[(claim.type !== 'Other')?_c('v-list-tile-title',[_vm._v(_vm._s(claim.type))]):_vm._e(),_vm._v(" "),(claim.type === 'Other')?_c('v-list-tile-title',[_vm._v(_vm._s(claim.desc))]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('strong',[(_vm.currentCurrency.text != 'M')?_c('span',[_vm._v(_vm._s(_vm.currentCurrency.text))]):_vm._e(),_vm._v(_vm._s(_vm._f("currency")(claim.cost))+" "),(_vm.currentCurrency.text == 'M')?_c('span',[_vm._v(_vm._s(_vm.currentCurrency.currency))]):_vm._e()])])],1)}),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',[_vm._v("Total")])])],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('strong',[(_vm.currentCurrency.text != 'M')?_c('span',[_vm._v(_vm._s(_vm.currentCurrency.text))]):_vm._e(),_vm._v(_vm._s(_vm._f("currency")(_vm.total))+"\n                "),(_vm.currentCurrency.text == 'M')?_c('span',[_vm._v(_vm._s(_vm.currentCurrency.currency))]):_vm._e()])])],1)],2):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarTimeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.detailsDialog),callback:function ($$v) {_vm.detailsDialog=$$v},expression:"detailsDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Add Item")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.detailsDialog = false}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),(_vm.detailsDialog)?_c('v-stepper',{attrs:{"vertical":"","light":""},model:{value:(_vm.detailsStepper),callback:function ($$v) {_vm.detailsStepper=$$v},expression:"detailsStepper"}},[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.detailsStepper > 1,"editable":""}},[_vm._v("Add details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.detailsValid),callback:function ($$v) {_vm.detailsValid=$$v},expression:"detailsValid"}},[(!_vm.hideExpenseDropdown)?_c('v-select',{attrs:{"items":_vm.computedExpenseTypes,"item-text":"expense_name","item-value":"expense_name","label":"Expense Type","rules":_vm.typeRules,"required":"","single-line":"","menu-props":{ maxHeight: 500 }},on:{"input":function($event){return _vm.checkDescription()}},model:{value:(_vm.currentItem.type),callback:function ($$v) {_vm.$set(_vm.currentItem, "type", $$v)},expression:"currentItem.type"}}):_vm._e(),_vm._v(" "),(_vm.currentItem.type == 'Other' || (_vm.company === 'lfp' || _vm.company === 'aquahaulage' || _vm.company === 'bmtransport'))?_c('v-text-field',{attrs:{"label":"Description","required":"","rules":_vm.descRules,"counter":50},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.gotoStep2.apply(null, arguments)}},model:{value:(_vm.currentItem.desc),callback:function ($$v) {_vm.$set(_vm.currentItem, "desc", $$v)},expression:"currentItem.desc"}}):_vm._e(),_vm._v(" "),(_vm.currentItem.type === 'Parking' && (_vm.taSettings.parking_location_provider.value == '1' || _vm.taSettings.parking_location_provider.value == '2'))?_c('v-text-field',{attrs:{"disabled":_vm.canEditExpense == false,"label":"Provider","rules":_vm.providerRules,"counter":50},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.gotoStep2.apply(null, arguments)}},model:{value:(_vm.currentItem.provider),callback:function ($$v) {_vm.$set(_vm.currentItem, "provider", $$v)},expression:"currentItem.provider"}}):_vm._e(),_vm._v(" "),(_vm.currentItem.type === 'Parking' 
              && (_vm.taSettings.parking_location_provider.value == '1' || _vm.taSettings.parking_location_provider.value == '2'))?_c('v-text-field',{attrs:{"disabled":_vm.canEditExpense == false,"label":"Location","rules":_vm.locationsRules,"counter":50},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.gotoStep2.apply(null, arguments)}},model:{value:(_vm.currentItem.location),callback:function ($$v) {_vm.$set(_vm.currentItem, "location", $$v)},expression:"currentItem.location"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.canEditExpense == false,"label":_vm.currentCurrency.text + ' Amount',"rules":_vm.currencyRules,"type":"number"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.gotoStep2.apply(null, arguments)}},model:{value:(_vm.currentItem.cost),callback:function ($$v) {_vm.$set(_vm.currentItem, "cost", $$v)},expression:"currentItem.cost"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"block":"","disabled":_vm.isLoading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.gotoStep2.apply(null, arguments)}}},[_vm._v("Add Details")])],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.detailsStepper > 2,"editable":""}},[_vm._v("Take photo")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-btn',{staticClass:"primary",attrs:{"block":""},on:{"click":_vm.triggerPick}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("photo_camera")]),_vm._v("\n            Add Photo\n          ")],1),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"id":"imagePicker","type":"file","accept":"image/jpeg,android/camera-workaround"},on:{"change":_vm.saveImages}}),_vm._v(" "),_c('canvas',{attrs:{"id":"imageCanvas","hidden":""}})],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.detailsStepper > 3}},[_vm._v("Confirm and Save")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.isLoading,"block":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.addCurrentItem.apply(null, arguments)}}},[_vm._v("Add to Claim")]),_vm._v(" "),_c('h3',[_vm._v("Expense Type: "+_vm._s(_vm.currentItem.type))]),_vm._v(" "),(_vm.currentItem.desc)?_c('h3',[_vm._v("Description: "+_vm._s(_vm.currentItem.desc))]):_vm._e(),_vm._v(" "),(_vm.currentCurrency.text != 'M')?_c('h3',[_vm._v("Cost: "+_vm._s(_vm.currentCurrency.text)+_vm._s(_vm._f("currency")(_vm.currentItem.cost)))]):_vm._e(),_vm._v(" "),(_vm.currentCurrency.text == 'M')?_c('h3',[_vm._v(_vm._s(_vm._f("currency")(_vm.currentItem.cost))+" "+_vm._s(_vm.currentCurrency.currency))]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.currentItem.photo}})],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewExpenses_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdede816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewExpenses_vue__ = __webpack_require__(386);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewExpenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdede816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewExpenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',[_c('div',[_c('v-select',{attrs:{"items":_vm.approvalStatuses,"label":"Select Approval Status"},on:{"change":_vm.applyFilters},model:{value:(_vm.selectedApproval),callback:function ($$v) {_vm.selectedApproval=$$v},expression:"selectedApproval"}})],1),_vm._v(" "),_vm._l((_vm.filteredExpenses),function(expense){return _c('div',{key:expense.claim_id},[_c('v-card',{staticStyle:{"margin-bottom":"15px"}},[_c('v-card-title',{style:(_vm.getClassForCard(expense.accepted))},[_c('span',[_c('strong',[_vm._v(_vm._s(expense.type))])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.formatDateTime(expense.date)))])])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('strong',[_c('p',{style:(_vm.colourForAction(expense.accepted))},[_vm._v(_vm._s(_vm.actioned(expense.accepted))+" ")])]),_vm._v(" "),_c('strong',[(expense.accepted_date)?_c('p',{style:(_vm.colourForAction(expense.accepted))},[_vm._v(_vm._s(_vm.formatDateTime(expense.accepted_date)))]):_vm._e()])]),_vm._v(" "),(expense.description)?_c('p',[_vm._v("Description: "+_vm._s(expense.description))]):_vm._e(),_vm._v(" "),(expense.type === 'Parking' && expense.location && (_vm.taSettings.parking_location_provider.value == '1' || _vm.taSettings.parking_location_provider.value == '2'))?_c('p',[_vm._v("Location: "+_vm._s(expense.location))]):_vm._e(),_vm._v(" "),(expense.type === 'Parking' && expense.provider && (_vm.taSettings.parking_location_provider.value == '1' || _vm.taSettings.parking_location_provider.value == '2'))?_c('p',[_vm._v("Provider: "+_vm._s(expense.provider))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Amount: "+_vm._s(_vm.currency(expense.amount, expense.currency))+" "+_vm._s(expense.currency))]),_vm._v(" "),(expense.img)?_c('v-btn',{attrs:{"color":"accent"},on:{"click":function($event){return _vm.viewImage(expense.img)}}},[_vm._v("View Image")]):_vm._e(),_vm._v(" "),(_vm.filteredExpenseAudit.some(function (audit) { return audit.label === expense.claim_id; }))?_c('h3',{staticStyle:{"margin-top":"10px","font-weight":"bold","font-size":"1em"}},[_vm._v("Claim Audit Log:")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredExpenseAudit),function(audit){return (audit.label === expense.claim_id)?_c('div',{key:audit.label,staticStyle:{"border":"1px solid #eee","padding":"10px","border-radius":"5px"}},_vm._l((audit.audits),function(item){return _c('div',{key:item.id},[_c('p',[_c('i',[_vm._v(_vm._s(_vm.formatDateTime(item.entry_date)))]),_vm._v(" - "),_c('strong',[_vm._v(_vm._s(item.user_id))]),_vm._v(" : "+_vm._s(item.comment))])])}),0):_vm._e()})],2)],1)],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimesheetEntry_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bb7b3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimesheetEntry_vue__ = __webpack_require__(388);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimesheetEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47bb7b3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimesheetEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.dialogTitle))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.dialogText))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-alert',{attrs:{"type":"info","value":_vm.shiftStarted}},[_vm._v("This shift was started at "+_vm._s(_vm.lastStart))]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-xs-center mt-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7,"color":"primary"}})],1):_vm._e(),_vm._v(" "),(!_vm.shiftStarted && _vm.loading === false)?_c('Clock-In'):_vm._e(),_vm._v(" "),(_vm.shiftStarted && _vm.loading === false)?_c('Clock-Out'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobOverview_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ad7f06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobOverview_vue__ = __webpack_require__(390);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ad7f06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fullscreen":"","persistent":"","transition":"dialog-bottom-transition"}},[(_vm.loading == 1)?_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Previous Shift Overview")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n      "+_vm._s(_vm._f("formatDateTime")(_vm.startTime))+" - "+_vm._s(_vm._f("formatDateTime")(_vm.endTime))+"\n    ")])],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mt-3"},[(_vm.loading == 1)?_c('v-container',[(_vm.jobData.length > 0)?_c('v-subheader',[_vm._v("Jobs Completed In Selected Shift")]):_c('v-subheader',[_vm._v("No Jobs Completed In Selected Shift")]),_vm._v(" "),(_vm.jobData.length > 0)?_c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((_vm.jobData),function(job,p){return _c('v-timeline-item',{key:p,attrs:{"color":job.end_time == null ? 'green' : 'grey',"small":""}},[_c('v-layout',{attrs:{"pt-2":""}},[_c('v-flex',{attrs:{"align-center":""}},[_c('div',{staticClass:"subheading"},[_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(job.start_time))+" - "+_vm._s(_vm._f("formatDate")(job.end_time)))])]),_vm._v(" "),_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm._f("filterJobTime")(job.start_time))+"-"+_vm._s(_vm._f("filterJobTime")(job.end_time))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm._f("formattedJobLength")(job)))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(job.farm_name))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("\n                  "+_vm._s(job.job_desc_name)+" "+_vm._s(job.product_name)+"\n                ")]),_vm._v(" "),(job.spray_bonus != null)?_c('div',{key:p,staticClass:"caption"},[_vm._v("\n                  "+_vm._s(job.spray_bonus)+" Hectares\n                ")]):_vm._e()])]),_vm._v(" "),_c('v-flex',{attrs:{"justify-end":"","shrink":""}},[_c('v-btn',{attrs:{"color":"primary","flat":"","icon":"","to":'/JobDetails/' + _vm.taID + '/0/' + job.job_id}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("mode_edit")])],1)],1)],1)],1)}),1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.loading == 0)?_c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.loading == 2)?_c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v("Error loading job details")])],1)],1):_vm._e(),_vm._v(" "),(_vm.anyJobInProgress)?_c('div',[_c('strong',{staticClass:"red--text"},[_vm._v("Cannot add a new job until all jobs in selected shift have been closed")])]):_vm._e(),_vm._v(" "),(_vm.loading != 2)?_c('v-btn',{attrs:{"color":"success","block":"","to":'/JobDetails/' + _vm.taID + '/0/-1',"disabled":_vm.loading != 1 || _vm.anyJobInProgress}},[_vm._v("Add Job")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":"","disabled":_vm.loading != 1,"to":'/'}},[_vm._v("\n        Back to Overview\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e923c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e923c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-card',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Settings")]),_vm._v(" "),_c('v-list-tile',[_c('v-text-field',{attrs:{"label":"Company Code"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1),_vm._v(" "),_c('v-list-tile',[_c('v-text-field',{attrs:{"label":"Remote Server"},model:{value:(_vm.server),callback:function ($$v) {_vm.server=$$v},expression:"server"}})],1),_vm._v(" "),_c('v-list-tile',[_c('v-text-field',{attrs:{"label":"Auto Signout Interval (Minutes)","type":"number"},on:{"change":_vm.setSignoutInterval},model:{value:(_vm.signoutInterval),callback:function ($$v) {_vm.signoutInterval=$$v},expression:"signoutInterval"}})],1),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":item.action}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1)],1)})],2),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"subheading"},[_vm._v("Camera Quality")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{staticClass:"px-3",attrs:{"prepend-icon":"camera","min":"20","thumb-label":"","step":"10","ticks":""},model:{value:(_vm.cameraQuality),callback:function ($$v) {_vm.cameraQuality=$$v},expression:"cameraQuality"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[(_vm.showAppMode)?_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"subheading font-weight-medium"},[_vm._v("Application Mode")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.applicationMode),callback:function ($$v) {_vm.applicationMode=$$v},expression:"applicationMode"}},[_c('v-radio',{attrs:{"label":"Normal","value":"tanda","color":"primary"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Tacho Day","value":"tacho","color":"primary"}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[(!_vm.secureMenu)?_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"subheading font-weight-medium"},[_vm._v("Location Settings")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Enter Code"},model:{value:(_vm.secureMenuCode),callback:function ($$v) {_vm.secureMenuCode=$$v},expression:"secureMenuCode"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[(_vm.secureMenu)?_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"subheading font-weight-medium"},[_vm._v("Set location For this machine")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Latitude"},model:{value:(_vm.lat),callback:function ($$v) {_vm.lat=$$v},expression:"lat"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Longitude"},model:{value:(_vm.long),callback:function ($$v) {_vm.long=$$v},expression:"long"}})],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-snackbar',{model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a7d472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(396);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a7d472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.companyDialog),callback:function ($$v) {_vm.companyDialog=$$v},expression:"companyDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Company Code")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Please enter your company code")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Company Code","autofocus":""},model:{value:(_vm.companyValue),callback:function ($$v) {_vm.companyValue=$$v},expression:"companyValue"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.companyValue.length < 1,"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.setCompanyValue()}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"lg6":"","offset-lg3":""}},[(_vm.pinVisible)?_c('v-card',{attrs:{"height":"100%"}},[_c('p',{staticClass:"headline text-xs-center py-3"},[_vm._v("Please Enter Your PIN Code")]),_vm._v(" "),(_vm.pinLength <= 4)?_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"text-xs-center px-5 py-1",attrs:{"row":"","wrap":"","grid-list-xs":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{class:this.value.length > 0 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 0 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{class:this.value.length > 1 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 1 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{class:this.value.length > 2 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 2 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{class:this.value.length > 3 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 3 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1)],1)],1):_c('v-container',{attrs:{"fluid":""}},[_c('v-text-field',{staticClass:"mx-6",attrs:{"label":"PIN Code","type":"password","maxlength":_vm.pinLength},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center px-5 pb-5",staticStyle:{"touch-action":"manipulation"},attrs:{"row":"","wrap":"","grid-list-xs":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(1)}}},[_vm._v("1")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(2)}}},[_vm._v("2")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(3)}}},[_vm._v("3")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(4)}}},[_vm._v("4")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(5)}}},[_vm._v("5")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(6)}}},[_vm._v("6")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(7)}}},[_vm._v("7")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(8)}}},[_vm._v("8")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(9)}}},[_vm._v("9")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.addDigit(0)}}},[_vm._v("0")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"fab":"","flat":"","large":""},on:{"click":function($event){return _vm.removeDigit()}}},[_c('v-icon',[_vm._v("backspace")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('Notice-Alert')],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.recoveryModal),callback:function ($$v) {_vm.recoveryModal=$$v},expression:"recoveryModal"}},[_c('v-card',[(!_vm.recoveryOptions)?[_c('v-card-text',{staticClass:"my-0 pt-3 pb-0"},[_c('v-select',{attrs:{"prepend-icon":"mdi-translate","label":"Choose Language","items":['English', 'Polskie', 'Română', 'Lietuvis']},model:{value:(_vm.maintLang),callback:function ($$v) {_vm.maintLang=$$v},expression:"maintLang"}})],1),_vm._v(" "),_c('v-card-title',{staticClass:"headline",domProps:{"textContent":_vm._s(_vm.maintText[_vm.maintLang].title)}}),_vm._v(" "),_c('v-card-text',{domProps:{"textContent":_vm._s(_vm.maintText[_vm.maintLang].para1)}}),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.maintText[_vm.maintLang].para2preIcon)+"\n        "),_c('v-badge',{staticStyle:{"margin-right":"3px"},attrs:{"overlap":"","color":"green"}},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("add")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"grey darken-1","medium":""}},[_vm._v("\n            receipt\n          ")])],1),_vm._v("\n          "+_vm._s(_vm.maintText[_vm.maintLang].para2postIcon)+"\n        ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.recoveryOptions = true}}},[_vm._v("Next")])],1)]:_c('Recovery-Form',{attrs:{"pin":_vm.value}})],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.signingIn),callback:function ($$v) {_vm.signingIn=$$v},expression:"signingIn"}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n          Signing In\n          "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":"error","multi-line":"","timeout":0},model:{value:(_vm.unauthorised),callback:function ($$v) {_vm.unauthorised=$$v},expression:"unauthorised"}},[_c('v-icon',{staticClass:"mr-4",attrs:{"large":""}},[_vm._v("error")]),_vm._v("\n    "+_vm._s(_vm.unauthorisedMsg)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.unauthorised = false}}},[_vm._v("\n      Close\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayRequest_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d947a0b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HolidayRequest_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d947a0b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HolidayRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-container',[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.gettingExistingRequests),expression:"gettingExistingRequests"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs-12":""}},[_c('v-progress-circular',{staticClass:"ma-5",attrs:{"size":70,"width":7,"indeterminate":"","color":"primary"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mb-4 v-btn--block",attrs:{"color":"primary"},on:{"click":function($event){_vm.newRequestDialog = true}}},[_vm._v("New Request")]),_vm._v(" "),_c('v-container',{staticClass:"hidden-xs-only"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h1',{staticClass:"title"},[_vm._v("Current Period")]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" -\n                  "+_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_end,'DD/MM/YYYY')))]),_vm._v(" "),_c('h4',{staticClass:"subtitle-2"},[_c('b',[_vm._v("Remaining Holiday Allowance (including any unapproved requests):")]),_vm._v("\n                  "+_vm._s(_vm.holAllowance.total_days_left))]),_vm._v(" "),(_vm.holAllowance.currentLieuAllowance > 0)?_c('h4',{staticClass:"mb-3 subtitle-2"},[_c('b',[_vm._v("Lieu Days Left:")]),_vm._v(" "+_vm._s(_vm.holAllowance.currentLieuAllowance))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h1',{staticClass:"title"},[_vm._v("Next Period")]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" -\n                  "+_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_end,'DD/MM/YYYY')))]),_vm._v(" "),_c('h4',{staticClass:"subtitle-2"},[_c('b',[_vm._v("Remaining Holiday Allowance (including any unapproved requests):")]),_vm._v("\n                  "+_vm._s(_vm.holAllowance.total_next_period_days_left))]),_vm._v(" "),(_vm.holAllowance.nextLieuAllowance > 0)?_c('h4',{staticClass:"mb-3 subtitle-2"},[_c('b',[_vm._v("Lieu Days Left:")]),_vm._v(" "+_vm._s(_vm.holAllowance.nextLieuAllowance))]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{staticClass:"hidden-xs-only mb-4"},[_c('full-calendar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.gettingExistingRequests),expression:"!gettingExistingRequests"}],attrs:{"events":_vm.filteredRequests},on:{"eventClick":_vm.viewEventDetails,"changeMonth":_vm.updateCurrentMonthYear}})],1),_vm._v(" "),(!_vm.isMobile)?_c('h2',{staticClass:"mt-0"},[_vm._v("All Existing Holiday Requests")]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('h1',{staticClass:"title",staticStyle:{"margin-bottom":"5px"}},[_vm._v("All Existing Holiday Requests")]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('v-checkbox',{attrs:{"label":"Include Past Requests","hide-details":""},model:{value:(_vm.showPastRequests),callback:function ($$v) {_vm.showPastRequests=$$v},expression:"showPastRequests"}}):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('v-checkbox',{staticStyle:{"margin-top":"5px"},attrs:{"label":"Include Past Requests","hide-details":""},model:{value:(_vm.showPastRequests),callback:function ($$v) {_vm.showPastRequests=$$v},expression:"showPastRequests"}}):_vm._e(),_vm._v(" "),_c('v-list',{staticClass:"hidden-xs-only",attrs:{"two-line":""}})],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"display":"flex","flex-direction":"column","margin-top":"15px"}},[(_vm.showPastRequests && _vm.previousPeriodRequests.length)?_c('div',{staticClass:"mb-5 mt-5"},[_c('h1',{staticClass:"title",staticStyle:{"margin-bottom":"8px"}},[_vm._v("Previous Periods")]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v("\n            Before "+_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+"\n          ")]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.previousPeriodRequests),function(request){return _c('v-list-group',{key:'previous-' + request.ID,class:[
                request.whitelisted_days == 0 ? 'error'
                  : request.type !== null ? 'blue-grey lighten-4'
                    : request.actioned === 0 ? 'warning'
                      : request.actioned === 1 ? 'success'
                        : 'error',
                'white--text',
                'mb-1'
              ],model:{value:(request.active),callback:function ($$v) {_vm.$set(request, "active", $$v)},expression:"request.active"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[(request.type === null && request.whitelisted_days > 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("filterActionText")(request.actioned))+":\n                    ")]):_vm._e(),_vm._v(" "),(request.type_name !== null && request.whitelisted_days > 0)?_c('strong',[_vm._v("\n                      "+_vm._s(request.type_name)+"\n                      "),(request.actioned === 5)?_c('span',{staticClass:"has-text-danger"},[_vm._v(" - DELETED")]):_vm._e()]):_vm._e(),_vm._v(" "),(request.whitelisted_days == 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                      Cancelled\n                    ")]):_vm._e()]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                    "+_vm._s(_vm._f("formatDate")(request.start,'DD/MM/YYYY'))+"\n                    "),(request.end)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("formatDate")(request.end,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),(_vm.company !== 'lfp')?_c('v-list-tile-sub-title',[_vm._v("\n                    "+_vm._s(_vm._f("formatTime")(request))+"\n                  ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[((request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0)?_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.selectedRequestObj = request; _vm.editRequestDialog = true}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},_vm._l((request.auditlog),function(audit,i){return _c('div',{key:request.ID + '-audit-' + i,staticClass:"white--text",staticStyle:{"margin-bottom":"25px"}},[_vm._v("\n                      "+_vm._s(_vm._f("formatDate")(audit.date,'DD/MM/YYYY HH:mm'))+" : "+_vm._s(audit.content)+"\n                    ")])}),0)],1)],1)],1)}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 mt-5"},[_c('h1',{staticClass:"title",staticStyle:{"margin-bottom":"8px"}},[_vm._v("Current Period")]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v("\n            "+_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" -\n            "+_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_end,'DD/MM/YYYY'))+"\n          ")]),_vm._v(" "),(_vm.isMobile)?_c('h4',{staticClass:"subtitle-2"},[_c('b',[_vm._v("Remaining Holiday Allowance:")]),_vm._v(" "+_vm._s(_vm.holAllowance.total_days_left)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.currentPeriodRequests),function(request){return _c('v-list-group',{key:'current-' + request.ID,class:[
              request.whitelisted_days == 0 ? 'error'
                : request.type !== null ? 'blue-grey lighten-4'
                  : request.actioned === 0 ? 'warning'
                    : request.actioned === 1 ? 'success'
                      : 'error',
              'white--text',
              'mb-1'
            ],model:{value:(request.active),callback:function ($$v) {_vm.$set(request, "active", $$v)},expression:"request.active"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[(request.type === null && request.whitelisted_days > 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                    "+_vm._s(_vm._f("filterActionText")(request.actioned))+":\n                  ")]):_vm._e(),_vm._v(" "),(request.type_name !== null && request.whitelisted_days > 0)?_c('strong',[_vm._v("\n                    "+_vm._s(request.type_name)+"\n                    "),(request.actioned === 5)?_c('span',{staticClass:"has-text-danger"},[_vm._v(" - DELETED")]):_vm._e()]):_vm._e(),_vm._v(" "),(request.whitelisted_days == 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                    Cancelled\n                  ")]):_vm._e()]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                  "+_vm._s(_vm._f("formatDate")(request.start,'DD/MM/YYYY'))+"\n                  "),(request.end)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("formatDate")(request.end,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),(_vm.company !== 'lfp')?_c('v-list-tile-sub-title',[_vm._v("\n                  "+_vm._s(_vm._f("formatTime")(request))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[((request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0)?_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.selectedRequestObj = request; _vm.editRequestDialog = true}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},_vm._l((request.auditlog),function(audit,i){return _c('div',{key:request.ID + '-audit-' + i,staticClass:"white--text",staticStyle:{"margin-bottom":"25px"}},[_vm._v("\n                    "+_vm._s(_vm._f("formatDate")(audit.date,'DD/MM/YYYY HH:mm'))+" : "+_vm._s(audit.content)+"\n                  ")])}),0)],1)],1)],1)}),1),_vm._v(" "),_c('div',{staticClass:"mt-5 mb-3"},[_c('h1',{staticClass:"title",staticStyle:{"margin-bottom":"8px"}},[_vm._v("Next Period")]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v("\n            "+_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" -\n            "+_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_end,'DD/MM/YYYY'))+"\n          ")]),_vm._v(" "),(_vm.isMobile)?_c('h4',{staticClass:"subtitle-2"},[_c('b',[_vm._v("Remaining Holiday Allowance:")]),_vm._v(" "+_vm._s(_vm.holAllowance.total_next_period_days_left)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.nextPeriodRequests),function(request){return _c('v-list-group',{key:'next-' + request.ID,class:[
              request.whitelisted_days == 0 ? 'error'
                : request.type !== null ? 'blue-grey lighten-4'
                  : request.actioned === 0 ? 'warning'
                    : request.actioned === 1 ? 'success'
                      : 'error',
              'white--text',
              'mb-1'
            ],model:{value:(request.active),callback:function ($$v) {_vm.$set(request, "active", $$v)},expression:"request.active"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[(request.type === null && request.whitelisted_days > 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                    "+_vm._s(_vm._f("filterActionText")(request.actioned))+":\n                  ")]):_vm._e(),_vm._v(" "),(request.type_name !== null && request.whitelisted_days > 0)?_c('strong',[_vm._v("\n                    "+_vm._s(request.type_name)+"\n                    "),(request.actioned === 5)?_c('span',{staticClass:"has-text-danger"},[_vm._v(" - DELETED")]):_vm._e()]):_vm._e(),_vm._v(" "),(request.whitelisted_days == 0)?_c('strong',{staticClass:"white--text"},[_vm._v("\n                    Cancelled\n                  ")]):_vm._e()]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                  "+_vm._s(_vm._f("formatDate")(request.start,'DD/MM/YYYY'))+"\n                  "),(request.end)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("formatDate")(request.end,'DD/MM/YYYY')))]):_vm._e()]),_vm._v(" "),(_vm.company !== 'lfp')?_c('v-list-tile-sub-title',[_vm._v("\n                  "+_vm._s(_vm._f("formatTime")(request))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[((request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0)?_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.selectedRequestObj = request; _vm.editRequestDialog = true}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},_vm._l((request.auditlog),function(audit){return _c('div',{key:audit.date + audit.content,staticClass:"white--text",staticStyle:{"margin-bottom":"25px"}},[_vm._v("\n                    "+_vm._s(_vm._f("formatDate")(audit.date,'DD/MM/YYYY HH:mm'))+" : "+_vm._s(audit.content)+"\n                  ")])}),0)],1)],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('New-Holiday-Request-Dialog',{staticClass:"mb-4",attrs:{"nextPeriodReleaseDays":_vm.nextPeriodReleaseDays,"workerType":_vm.empDetails.worker_type,"showDialog":_vm.newRequestDialog,"holAllowance":_vm.holAllowance},on:{"closeNewRequestDialog":function($event){_vm.newRequestDialog = false},"requestSubmitted":_vm.getExistingRequests}}),_vm._v(" "),_c('Edit-Holiday-Request-Dialog',{staticClass:"mb-4",attrs:{"showDialog":_vm.editRequestDialog,"requestObj":_vm.selectedRequestObj},on:{"closeEditRequestDialog":function($event){_vm.editRequestDialog = false},"requestSubmitted":_vm.getExistingRequests}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobDetails_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cffd60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobDetails_vue__ = __webpack_require__(403);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cffd60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-bottom":"10px"}},[_vm._v("Job Details")])],1),_vm._v(" "),_c('v-card'),_vm._v(" "),(_vm.shiftInProgress == '0')?_c('v-card',{staticClass:"mb-3"},[_c('v-card-title',[_c('h3',{staticClass:"title"},[_vm._v("Editing Historic Timesheet")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm._f("formatDate")(_vm.shiftStartTime))+" - "+_vm._s(_vm._f("formatDate")(_vm.shiftEndTime))+"\n"),_c('br'),_c('br'),_vm._v("\n        The start & end times of jobs is restricted to fall within the timesheet.\n      ")])],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"pa-0"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.saveFailedDialog),callback:function ($$v) {_vm.saveFailedDialog=$$v},expression:"saveFailedDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Failed to update job")]),_vm._v(" "),_c('v-card-text',[_vm._v("Failed to update job on the server, please try again")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"red darken-1","flat":"","to":"/"}},[_vm._v("Back to Overview")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1"},on:{"click":function($event){_vm.saveFailedDialog = false}}},[_vm._v("Dismiss")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.failedDialog),callback:function ($$v) {_vm.failedDialog=$$v},expression:"failedDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Connection Failed")]),_vm._v(" "),_c('v-card-text',[_vm._v("Failed to retrieve data from the server, please check your connection and try again")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"red darken-1","flat":"","to":"/"}},[_vm._v("Back to Overview")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500","persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.completeDialog),callback:function ($$v) {_vm.completeDialog=$$v},expression:"completeDialog"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Job Entry Successful")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","to":'/'}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"mt-3 grey darken-1","block":"","dark":"","to":'/Expenses'}},[_c('v-icon',[_vm._v("receipt")]),_vm._v(" Add Expenses")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"mt-3 green darken-1","block":"","dark":""},on:{"click":function($event){_vm.completeDialog = false}}},[_c('v-icon',[_vm._v("assignment")]),_vm._v(" Start Another Job")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"mt-3 red darken-1","block":"","dark":"","to":"/TimesheetEntry/out"}},[_c('v-icon',[_vm._v("file_upload")]),_vm._v(" Clock Out")],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.startDialog),callback:function ($$v) {_vm.startDialog=$$v},expression:"startDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Job Start Saved")]),_vm._v(" "),_c('v-card-text',[_vm._v("You have successfully recorded the start a job.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Offline")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"cloud_off","type":"error"},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_vm._v("You are currently offline, Please try again later")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.deleteConfirmDialog),callback:function ($$v) {_vm.deleteConfirmDialog=$$v},expression:"deleteConfirmDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete Job")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"delete","type":"error"},model:{value:(_vm.deleteConfirmDialog),callback:function ($$v) {_vm.deleteConfirmDialog=$$v},expression:"deleteConfirmDialog"}},[_vm._v("Are you sure you want to delete this job? This cannot be undone!")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.deleteConfirmDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},on:{"click":function($event){_vm.deleteConfirmDialog = false; _vm.deleteJob()}}},[_vm._v("Delete Job")])],1)],1)],1),_vm._v(" "),_c('v-container',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-card',{staticClass:"pa-2",attrs:{"elevation":_vm.jobState === 1 ? '2' : '0',"color":_vm.jobState === 1 ? 'grey lighten-5' : ''}},[_c('v-dialog',{ref:"startDateDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.jobDetails.startDate,"disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},on:{"update:returnValue":function($event){return _vm.$set(_vm.jobDetails, "startDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.jobDetails, "startDate", $event)}},model:{value:(_vm.startDateDialog),callback:function ($$v) {_vm.startDateDialog=$$v},expression:"startDateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":"","disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},slot:"activator",model:{value:(_vm.formatStartDate),callback:function ($$v) {_vm.formatStartDate=$$v},expression:"formatStartDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"actions":"","full-width":"","disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading),"min":_vm.shiftStartTime != null ? _vm.shiftStartTime.split(' ')[0] : null,"max":_vm.shiftInProgress == '0' && _vm.shiftEndTime != null ? _vm.shiftEndTime.split(' ')[0] : null},model:{value:(_vm.jobDetails.startDate),callback:function ($$v) {_vm.$set(_vm.jobDetails, "startDate", $$v)},expression:"jobDetails.startDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.startDateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.startDateDialog.save(_vm.jobDetails.startDate); _vm.validateForm()}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-dialog',{ref:"startTimeDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"fit-content","return-value":_vm.jobDetails.startTime,"disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},on:{"update:returnValue":function($event){return _vm.$set(_vm.jobDetails, "startTime", $event)},"update:return-value":function($event){return _vm.$set(_vm.jobDetails, "startTime", $event)}},model:{value:(_vm.startTimeDialog),callback:function ($$v) {_vm.startTimeDialog=$$v},expression:"startTimeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Time","rules":_vm.startTimeRules,"prepend-icon":"access_time","readonly":"","disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},slot:"activator",model:{value:(_vm.startTimeFormat),callback:function ($$v) {_vm.startTimeFormat=$$v},expression:"startTimeFormat"}}),_vm._v(" "),_c('b-timepicker',{attrs:{"inline":"","size":"is-large","placeholder":"Click to select...","icon":"clock","time-parser":_vm.formatTimeStringToDate,"time-format":_vm.formatTimeDateToString,"min-time":_vm.startMinTime,"max-time":_vm.maxStartTime,"hour-format":"24","disabled":_vm.loading},model:{value:(_vm.jobDetails.startTime),callback:function ($$v) {_vm.$set(_vm.jobDetails, "startTime", $$v)},expression:"jobDetails.startTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.startTimeDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.startTimeDialog.save(_vm.jobDetails.startTime)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-autocomplete',{attrs:{"label":"Select Farm","items":_vm.filteredFarms,"disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading),"item-value":"ID","rules":_vm.inputRules,"item-text":"farm_name"},model:{value:(_vm.jobDetails.farm),callback:function ($$v) {_vm.$set(_vm.jobDetails, "farm", $$v)},expression:"jobDetails.farm"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"label":"Job Description","items":_vm.filteredJobDesc,"item-value":"ID","rules":_vm.inputRules,"item-text":"name","disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},model:{value:(_vm.jobDetails.jobDescription),callback:function ($$v) {_vm.$set(_vm.jobDetails, "jobDescription", $$v)},expression:"jobDetails.jobDescription"}}),_vm._v(" "),(_vm.hasProductSpec)?_c('v-autocomplete',{attrs:{"label":"Product Specification","items":_vm.filteredProdSpec,"item-value":"ID","rules":_vm.prodSpecRules,"item-text":"product_name","disabled":!_vm.shiftInProgress && (!_vm.endJobActive || _vm.loading)},model:{value:(_vm.jobDetails.productSpec),callback:function ($$v) {_vm.$set(_vm.jobDetails, "productSpec", $$v)},expression:"jobDetails.productSpec"}}):_vm._e(),_vm._v(" "),(_vm.jobState === 0)?_c('v-btn',{staticClass:"primary my-2",attrs:{"loading":_vm.loading,"block":""},on:{"click":_vm.startJob}},[_vm._v("Confirm Start")]):_vm._e(),_vm._v(" "),(_vm.jobState === 1 && !_vm.endJobActive)?_c('v-btn',{staticClass:"default my-2",attrs:{"loading":_vm.loading,"block":""},on:{"click":function($event){return _vm.openEndDialog()}}},[_vm._v("End Job")]):_vm._e(),_vm._v(" "),(_vm.jobState !== 0)?_c('v-btn',{staticClass:"red darken-4 my-2",attrs:{"loading":_vm.loading,"block":""},on:{"click":function($event){_vm.deleteConfirmDialog = true}}},[_vm._v("Delete Job")]):_vm._e(),_vm._v(" "),(_vm.currentJobID !== -1 && _vm.loading)?_c('v-btn',{staticClass:"default my-2",attrs:{"loading":_vm.loading,"block":"","disabled":""}}):_vm._e()],1),_vm._v(" "),(_vm.endJobActive)?_c('v-card',{staticClass:"pa-2 mt-1",attrs:{"elevation":"0"}},[_c('v-dialog',{ref:"endDateDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.jobDetails.endDate,"disabled":_vm.loading || (!_vm.endJobActive && _vm.jobState !== 0)},on:{"update:returnValue":function($event){return _vm.$set(_vm.jobDetails, "endDate", $event)},"update:return-value":function($event){return _vm.$set(_vm.jobDetails, "endDate", $event)}},model:{value:(_vm.endDateDialog),callback:function ($$v) {_vm.endDateDialog=$$v},expression:"endDateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","prepend-icon":"event","rules":_vm.endDateRules,"readonly":"","disabled":_vm.loading || (!_vm.endJobActive && !_vm.jobState == 0)},slot:"activator",model:{value:(_vm.formatEndDate),callback:function ($$v) {_vm.formatEndDate=$$v},expression:"formatEndDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"actions":"","full-width":"","min":_vm.shiftInProgress == '0' && _vm.shiftStartTime != null ? _vm.shiftStartTime.split(' ')[0] : _vm.jobDetails.startDate.split(' ')[0],"max":_vm.shiftInProgress == '0' && _vm.shiftEndTime != null ? _vm.shiftEndTime.split(' ')[0] : null},model:{value:(_vm.jobDetails.endDate),callback:function ($$v) {_vm.$set(_vm.jobDetails, "endDate", $$v)},expression:"jobDetails.endDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.endDateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.endDateDialog.save(_vm.jobDetails.endDate)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-dialog',{ref:"endTimeDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"fit-content","return-value":_vm.jobDetails.endTime,"disabled":_vm.loading || (!_vm.endJobActive && !_vm.jobState == 0)},on:{"update:returnValue":function($event){return _vm.$set(_vm.jobDetails, "endTime", $event)},"update:return-value":function($event){return _vm.$set(_vm.jobDetails, "endTime", $event)}},model:{value:(_vm.endTimeDialog),callback:function ($$v) {_vm.endTimeDialog=$$v},expression:"endTimeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Time","prepend-icon":"access_time","rules":_vm.endTimeRules,"readonly":"","disabled":_vm.loading || (!_vm.endJobActive && !_vm.jobState == 0)},slot:"activator",model:{value:(_vm.endTimeFormat),callback:function ($$v) {_vm.endTimeFormat=$$v},expression:"endTimeFormat"}}),_vm._v(" "),_c('b-timepicker',{attrs:{"inline":"","size":"is-large","placeholder":"Click to select...","icon":"clock","time-parser":_vm.formatTimeStringToDate,"time-format":_vm.formatTimeDateToString,"min-time":_vm.endMinTime,"max-time":_vm.maxEndTime,"hour-format":"24","disabled":_vm.loading || (!_vm.endJobActive && !_vm.jobState == 0)},model:{value:(_vm.jobDetails.endTime),callback:function ($$v) {_vm.$set(_vm.jobDetails, "endTime", $$v)},expression:"jobDetails.endTime"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.endTimeDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.endTimeDialog.save(_vm.jobDetails.endTime)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),(_vm.jobDetails.jobDescription == 0)?[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('label',[_vm._v("Spray Bonus")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"min":"0","step":"1","pattern":"[0-9]*","type":"number","rules":_vm.sprayBonusRules},on:{"input":_vm.stripDecimals},model:{value:(_vm.jobDetails.spray_bonus),callback:function ($$v) {_vm.$set(_vm.jobDetails, "spray_bonus", $$v)},expression:"jobDetails.spray_bonus"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('p',{staticStyle:{"font-size":"20px","margin-top":"16px","margin-bottom":"0"}},[_vm._v("Hectares")])])],1)]:_vm._e(),_vm._v(" "),(_vm.formValid)?[_c('div',[_c('strong',{class:_vm.jobBackwards ? 'red--text' : ''},[_vm._v(_vm._s(_vm.formattedJobLength))])])]:_vm._e(),_vm._v(" "),(_vm.jobState != 2)?_c('v-btn',{staticClass:"primary my-2",attrs:{"loading":_vm.loading,"block":""},on:{"click":function($event){_vm.endJobActive = false}}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"success my-2",attrs:{"loading":_vm.loading,"block":""},on:{"click":_vm.completeJob}},[_vm._v(_vm._s(_vm.jobState == 1 ? 'Complete Job' : 'Update Job'))])],2):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","persistent":"","value":_vm.showDialog,"transition":"dialog-bottom-transition"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("New Schengen Trip")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('closeSchengenRequest')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('div',{staticClass:"datepicker-trigger"},[_c('div',{staticClass:"text-xs-left"},[_c('div',{staticClass:"mt-3 text-xs-left"},[_c('h3',[_c('strong',[_vm._v("Schengen Trip Dates: ")])])]),_vm._v(" "),_c('div',{staticClass:"text-xs-left",attrs:{"id":"datepicker-trigger"}},[_vm._v(_vm._s(_vm.dateOne ? _vm.formatDates(_vm.dateOne, _vm.dateTwo) : 'Please select dates for the new Schengen trip'))]),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.schengenCountries,"label":"Select A Country"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.code)?_c('span',{class:'flag flag-' + data.item.code,staticStyle:{"margin-right":"10px"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.item.text)+"\n                      ")]}},{key:"item",fn:function(data){return [(data.item.code)?_c('span',{class:'flag flag-' + data.item.code,staticStyle:{"margin-right":"10px"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.item.text)+"\n                      ")]}}]),model:{value:(_vm.selected_country),callback:function ($$v) {_vm.selected_country=$$v},expression:"selected_country"}})],1)],1)],1),_vm._v(" "),_c('AirbnbStyleDatepicker',{attrs:{"trigger-element-id":'datepicker-trigger',"mode":'range',"date-one":_vm.dateOne,"date-two":_vm.dateTwo,"inline":"","showActionButtons":false,"showShortcutsMenuTrigger":false},on:{"date-one-selected":function (val) { _vm.dateOne = val },"date-two-selected":function (val) { _vm.dateTwo = val }}})],1)]),_vm._v(" "),(!_vm.selected_country)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('h4',[_vm._v("Please select a country")])])],1):_vm._e(),_vm._v(" "),(_vm.dateOne == '' || _vm.dateTwo == '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('h4',[_vm._v("Please select dates for the new Schengen trip")])])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","block":"","disabled":_vm.dateOne == '' || _vm.dateTwo == '' || !_vm.selected_country || _vm.addingTrip},on:{"click":_vm.addTrip}},[_vm._v("Add Trip")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchengenTrips_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b9939c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchengenTrips_vue__ = __webpack_require__(416);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SchengenTrips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b9939c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchengenTrips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-container',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","block":""},on:{"click":function($event){_vm.newSchengen = true}}},[_vm._v("New Schengen Trip")])],1)],1),_vm._v(" "),_c('h3',[_vm._v("Existing Schengen Trips:")])],1),_vm._v(" "),_vm._l((_vm.schengenTrips),function(trip){return _c('v-card',{key:trip.trip_id,staticClass:"mb-3"},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","width":"100%"}},[_c('div',{staticStyle:{"display":"flex","align-items":"flex-start","justify-content":"space-between","width":"100%"}},[_c('h3',{staticStyle:{"margin":"0","display":"flex","align-items":"center"}},[(trip.country_code)?_c('span',{class:'flag flag-' + trip.country_code,staticStyle:{"margin-right":"10px"}}):_vm._e(),_vm._v(" "),_c('strong',[_vm._v(_vm._s(trip.country))])]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('v-icon',{staticStyle:{"color":"orange","margin-right":"10px"},on:{"click":function($event){return _vm.openEditDialog(trip)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{staticStyle:{"color":"red"},on:{"click":function($event){return _vm.deleteSchengenTrip(trip)}}},[_vm._v("delete")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","width":"100%","margin-top":"8px"}},[_c('h3',{staticStyle:{"margin":"0"}},[_c('strong',[_vm._v(_vm._s(_vm.formatDates(trip.start_date, trip.end_date)))])])])])])],1)],1)],1)})],2),_vm._v(" "),_c('Schengen-Request',{attrs:{"showDialog":_vm.newSchengen},on:{"closeSchengenRequest":function($event){_vm.newSchengen = false},"addedSchengen":_vm.onTripAdded}}),_vm._v(" "),_c('Edit-Schengen-Request',{attrs:{"showDialog":_vm.editSchengen,"trip":_vm.selectedTrip},on:{"closeEditSchengenRequest":_vm.closeEditDialog,"editSchengenTrip":_vm.editSchengenTrip}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(71);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.company) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    company: null,
    disclaimerAccepted: false,
    disclaimerText: {},
    disclaimerLanguage: 'English',
    languages: [],
    loginTime: null,
    timeout: null,
    clockInFlagLimit: -1,
    clockOutLimit: -1,
    clockInLimit: -1,
    disableTimeChangeIn: false,
    disableTimeChangeOut: false,
    nightOutRefType: 'number'
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setCompany: function setCompany(state, payload) {
      state.company = payload ? payload.toLowerCase() : payload;
    },
    setDisclaimerAccepted: function setDisclaimerAccepted(state, payload) {
      state.disclaimerAccepted = payload;
    },
    setDisclaimerText: function setDisclaimerText(state, payload) {
      state.disclaimerText = payload;
    },
    setDisclaimerLanguage: function setDisclaimerLanguage(state, payload) {
      state.disclaimerLanguage = payload;
    },
    setLanguages: function setLanguages(state, payload) {
      state.languages = payload;
    },
    setLoginTime: function setLoginTime(state, payload) {
      state.loginTime = payload;
    },
    setTimeout: function setTimeout(state, payload) {
      state.timeout = payload;
    },
    setClockInFlagLimit: function setClockInFlagLimit(state, payload) {
      state.clockInFlagLimit = payload;
    },
    setClockOutLimit: function setClockOutLimit(state, payload) {
      state.clockOutLimit = payload;
    },
    setClockInLimit: function setClockInLimit(state, payload) {
      state.clockInLimit = payload;
    },
    setDisableTimeChangeIn: function setDisableTimeChangeIn(state, payload) {
      state.disableTimeChangeIn = payload;
    },
    setDisableTimeChangeOut: function setDisableTimeChangeOut(state, payload) {
      state.disableTimeChangeOut = payload;
    },
    setNightOutRefType: function setNightOutRefType(state, payload) {
      state.nightOutRefType = payload;
    },
    setModules: function setModules(state, payload) {
      state.user.modules = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, state.user.modules);
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      var userObj = {
        empID: payload.empID,
        fname: payload.fname,
        sname: payload.sname,
        pin: payload.pin,
        modules: payload.modules,
        occasional_driver: payload.occasional_driver,
        extra_shift: payload.extra_shift,
        has_bonus: payload.has_bonus,
        on_call: payload.on_call
      };
      commit('setUser', userObj);
      commit('setLoginTime', __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss'));
      if (payload.timeout > 0) {
        commit('setTimeout', payload.timeout);
      } else {
        commit('setTimeout', null);
      }
    },
    checkCompany: function checkCompany(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setCompany', payload);
    },
    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      commit('setUser', null);
      commit('setDisclaimerAccepted', false);
      commit('setDisclaimerText', '');
      commit('setLoginTime', null);
      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["auth"]().signOut();
    },
    fetchDisclaimerAccepted: function fetchDisclaimerAccepted(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      var company = this.getters.company;
      var user = this.getters.user;
      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(company + '/disclaimers/' + user.empID).once('value').then(function (data) {
        var obj = data.val();
        if (obj && obj.accepted) {
          commit('setDisclaimerAccepted', obj.accepted);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    acceptDisclaimer: function acceptDisclaimer(_ref5) {
      var commit = _ref5.commit,
          getters = _ref5.getters;

      var company = this.getters.company;
      var user = this.getters.user;
      var obj = {
        accepted: true,
        date: new Date().toISOString()
      };
      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(company + '/disclaimers/' + user.empID).update(obj).then(function (data) {
        console.log(data);
        commit('setDisclaimerAccepted', true);
      }).catch(function (error) {
        console.log(error);
      });
    },
    fetchDisclaimerText: function fetchDisclaimerText(_ref6) {
      var commit = _ref6.commit,
          getters = _ref6.getters;

      var company = this.getters.company;
      if (localStorage.getItem('disclaimerText') !== null && localStorage.getItem('disclaimerText') !== undefined && localStorage.getItem('languages') !== null && localStorage.getItem('languages') !== undefined) {
        commit('setDisclaimerText', JSON.parse(localStorage.getItem('disclaimerText')));
        commit('setLanguages', JSON.parse(localStorage.getItem('languages')));
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase_app__["database"]().ref(company + '/disclaimerText').once('value').then(function (data) {
        var obj = data.val();
        var languages = [];
        for (var language in obj) {
          languages.push(language);
        }
        if (obj) {
          commit('setDisclaimerText', obj); // obj.accepted should always be true if set so we'll be setting disclaimer to false
          localStorage.setItem('disclaimerText', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
        }
        if (languages) {
          localStorage.setItem('languages', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(languages));
          commit('setLanguages', languages);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setDisclaimerLanguage: function setDisclaimerLanguage(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setDisclaimerLanguage', payload);
    },
    setLoginTime: function setLoginTime(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setLoginTime', payload);
    },
    checkLoginTime: function checkLoginTime(_ref9) {
      var dispatch = _ref9.dispatch,
          state = _ref9.state,
          rootState = _ref9.rootState;

      var timeout = state.timeout + 15;
      var loginTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.loginTime, 'YYYY-MM-DD HH:mm:ss');
      var diff = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(loginTime, 'm');
      var diffText = __WEBPACK_IMPORTED_MODULE_5_moment___default()().to(loginTime);
      if (timeout && diff >= timeout) {
        console.log('Login timed out');
        var company = this.getters.company;
        var user = this.getters.user;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(rootState.shared.url + '/tanda-service/clockoutLongShift.ajax.php', { emp_id: user.empID, now: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss'), company: company }).then(function (result) {
          console.log(result);
          dispatch('logout');
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        console.log('Logged in ' + diffText + ', login timeouts after ' + timeout + ' minutes.');
      }
    },
    setClockInFlagLimit: function setClockInFlagLimit(_ref10, payload) {
      var commit = _ref10.commit;

      commit('setClockInFlagLimit', payload);
    },
    setClockOutLimit: function setClockOutLimit(_ref11, payload) {
      var commit = _ref11.commit;

      commit('setClockOutLimit', payload);
    },
    setClockInLimit: function setClockInLimit(_ref12, payload) {
      var commit = _ref12.commit;

      commit('setClockInLimit', payload);
    },
    setDisableTimeChangeIn: function setDisableTimeChangeIn(_ref13, payload) {
      var commit = _ref13.commit;

      commit('setDisableTimeChangeIn', payload);
    },
    setDisableTimeChangeOut: function setDisableTimeChangeOut(_ref14, payload) {
      var commit = _ref14.commit;

      commit('setDisableTimeChangeOut', payload);
    },
    setModules: function setModules(_ref15, payload) {
      var commit = _ref15.commit;

      commit('setModules', payload);
    },
    setNightOutRefType: function setNightOutRefType(_ref16, payload) {
      var commit = _ref16.commit;

      commit('setNightOutRefType', payload);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    company: function company(state) {
      return state.company;
    },
    disclaimerAccepted: function disclaimerAccepted(state) {
      return state.disclaimerAccepted;
    },
    disclaimerText: function disclaimerText(state, getters) {
      return state.disclaimerText[getters.disclaimerLanguage];
    },
    disclaimerLanguage: function disclaimerLanguage(state) {
      return state.disclaimerLanguage;
    },
    languages: function languages(state) {
      return state.languages;
    },
    loginTime: function loginTime(state) {
      return state.loginTime;
    },
    clockInFlagLimit: function clockInFlagLimit(state) {
      return state.clockInFlagLimit;
    },
    clockOutLimit: function clockOutLimit(state) {
      return state.clockOutLimit;
    },
    clockInLimit: function clockInLimit(state) {
      return state.clockInLimit;
    },
    disableTimeChangeIn: function disableTimeChangeIn(state) {
      return state.disableTimeChangeIn;
    },
    disableTimeChangeOut: function disableTimeChangeOut(state) {
      return state.disableTimeChangeOut;
    },
    nightOutRefType: function nightOutRefType(state) {
      return state.nightOutRefType;
    }
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dbPromise__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    timesheet: []
  },
  mutations: {
    setTimesheetData: function setTimesheetData(state, payload) {
      state.timesheet = payload;
    }
  },
  actions: {
    fetchTimesheet: function fetchTimesheet(_ref) {
      var commit = _ref.commit,
          getters = _ref.getters;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(getters.url + '/tanda-service/getShiftsForEmp.ajax.php', {
        emp: getters.user.empID,
        company: getters.company
      }).then(function (response) {
        commit('setLoading', false);
        var data = response.data;
        commit('setTimesheetData', data);
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('timesheet-archive', 'readwrite');
          var timesheetStore = tx.objectStore('timesheet-archive');
          timesheetStore.put(data, getters.user.empID);
          return tx.complete;
        }).then(function () {
          console.log('data saved locally');
        });
      }).catch(function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('timesheet-archive');
          var timesheetStore = tx.objectStore('timesheet-archive');
          return timesheetStore.get(getters.user.empID);
        }).then(function (val) {
          commit('setLoading', false);
          if (val !== undefined) {
            commit('setTimesheetData', val);
          }
        });
      });
    }
  },
  getters: {
    timesheet: function timesheet(state) {
      return state.timesheet;
    }
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null,
    GPS: null,
    url: 'https://cwelite.aquariusit.com',
    versions: {
      app: null,
      db: null
    },
    appOutdated: false,
    applicationMode: localStorage.getItem('applicationMode') !== null && localStorage.getItem('applicationMode') !== undefined ? localStorage.applicationMode : 'tanda',
    signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0,
    taSettings: []
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setGPS: function setGPS(state, payload) {
      state.GPS = payload;
    },
    setURL: function setURL(state, payload) {
      state.url = payload;
    },
    setApplicationMode: function setApplicationMode(state, payload) {
      state.applicationMode = payload;
    },
    appOutdated: function appOutdated(state, payload) {
      state.appOutdated = payload;
    },
    setSignoutInterval: function setSignoutInterval(state, payload) {
      state.signoutInterval = payload;
    },
    setTASettings: function setTASettings(state, payload) {
      state.taSettings = payload;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setLoading: function setLoading(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setLoading', payload);
    },
    getLocation: function getLocation(_ref3) {
      var commit = _ref3.commit;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          commit('setGPS', position);
        }, function (error) {
          commit('setGPS', error);
        });
      } else {
        commit('setGPS', null);
      }
    },
    setURL: function setURL(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setURL', payload);
    },
    setApplicationMode: function setApplicationMode(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setApplicationMode', payload);
    },
    appOutdated: function appOutdated(_ref6, payload) {
      var commit = _ref6.commit;

      commit('appOutdated', payload);
    },
    setSignoutInterval: function setSignoutInterval(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setSignoutInterval', payload);
    },
    setTASettings: function setTASettings(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setTASettings', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    GPS: function GPS(state) {
      return state.GPS;
    },
    url: function url(state) {
      return state.url;
    },
    applicationMode: function applicationMode(state) {
      return state.applicationMode;
    },
    appOutdated: function appOutdated(state) {
      return state.appOutdated;
    },
    signoutInterval: function signoutInterval(state) {
      return state.signoutInterval;
    },
    taSettings: function taSettings(state) {
      return state.taSettings;
    }
  }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    currencyData: {}
  },
  mutations: {
    setCurrencyData: function setCurrencyData(state, payload) {
      state.currencyData = payload;
    }
  },
  actions: {
    setCurrencyData: function setCurrencyData(_ref, payload) {
      var commit = _ref.commit;

      commit('setCurrencyData', payload);
    }
  },
  getters: {
    currency: function currency(state) {
      return state.currencyData;
    }
  }
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(71);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user || !__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.company) {
    next();
  } else {
    next('/');
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClockInComponent_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67716fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClockInComponent_vue__ = __webpack_require__(446);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClockInComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67716fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClockInComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-bottom":"10px"}},[_vm._v("Clock In")])],1),_vm._v(" "),_c('v-card',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.completeDialog),callback:function ($$v) {_vm.completeDialog=$$v},expression:"completeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Clock In Successful")]),_vm._v(" "),_c('v-card-text',[_vm._v("You have successfully managed to clock in.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Offline")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"cloud_off","type":"error"},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_vm._v("You are currently offline, Please try again later")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDateDialog),callback:function ($$v) {_vm.errorDateDialog=$$v},expression:"errorDateDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Shift Conflict")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"mdi-clock-alert","type":"error"},model:{value:(_vm.errorDateDialog),callback:function ($$v) {_vm.errorDateDialog=$$v},expression:"errorDateDialog"}},[_vm._v("You have already clocked in with this start time")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-container',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-dialog',{ref:"dateDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.date,"disabled":_vm.disableTimeChangeIn},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":"","rules":_vm.timeRules,"disabled":_vm.disableTimeChangeIn},slot:"activator",model:{value:(_vm.formatDate),callback:function ($$v) {_vm.formatDate=$$v},expression:"formatDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"actions":"","full-width":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dateDialog.save(_vm.date)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-dialog',{ref:"timeDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"fit-content","return-value":_vm.time,"disabled":_vm.disableTimeChangeIn},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Time","prepend-icon":"access_time","readonly":"","rules":_vm.timeRules,"disabled":_vm.disableTimeChangeIn},slot:"activator",model:{value:(_vm.timeFormat),callback:function ($$v) {_vm.timeFormat=$$v},expression:"timeFormat"}}),_vm._v(" "),_c('b-timepicker',{attrs:{"inline":"","size":"is-large","placeholder":"Click to select...","icon":"clock","time-parser":_vm.formatTimeStringToDate,"time-format":_vm.formatTimeDateToString,"hour-format":"24"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timeDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.timeDialog.save(_vm.time)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),(_vm.modules.pod)?_c('v-combobox',{ref:"loadSelect",attrs:{"label":"Load Numbers","prepend-icon":"local_shipping","chips":"","multiple":"","clearable":"","deletable-chips":"","color":"primary"},model:{value:(_vm.load),callback:function ($$v) {_vm.load=$$v},expression:"load"}}):_vm._e(),_vm._v(" "),(_vm.extra_shift)?_c('v-checkbox',{attrs:{"label":"Is this an extra shift?"},model:{value:(_vm.isExtraShift),callback:function ($$v) {_vm.isExtraShift=$$v},expression:"isExtraShift"}}):_vm._e(),_vm._v(" "),(_vm.on_call)?_c('v-checkbox',{attrs:{"label":"Is this an \"on call\" shift?"},model:{value:(_vm.isOnCall),callback:function ($$v) {_vm.isOnCall=$$v},expression:"isOnCall"}}):_vm._e(),_vm._v(" "),(_vm.occasional_driver)?_c('v-checkbox',{attrs:{"label":"Occasional Driving?"},model:{value:(_vm.occasionalDriving),callback:function ($$v) {_vm.occasionalDriving=$$v},expression:"occasionalDriving"}}):_vm._e(),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Notes","maxlength":"255"},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.loading || !_vm.gpsAttemptComplete,"block":"","disabled":!_vm.formValid},on:{"click":_vm.submitClockIn}},[_vm._v("Confirm Start")])],1),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.gpsStatus))])],1)],1),_vm._v(" "),_c('Disclaimer-Dialog',{attrs:{"show-dialog":_vm.displayDisclaimer},on:{"update:showDialog":function($event){_vm.displayDisclaimer=$event},"update:show-dialog":function($event){_vm.displayDisclaimer=$event},"declined":_vm.disclaimerAction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClockOutComponent_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a73987ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClockOutComponent_vue__ = __webpack_require__(448);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClockOutComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a73987ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClockOutComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"headline",staticStyle:{"margin-bottom":"10px"}},[_vm._v("Clock Out")])],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-card',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.completeDialog),callback:function ($$v) {_vm.completeDialog=$$v},expression:"completeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Clock Out Successful")]),_vm._v(" "),_c('v-card-text',[_vm._v("You have successfully managed to clock out. Do you have any expenses to claim for this shift?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"","to":"/"}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":'/Expenses/'+this.shiftID}},[_vm._v("Yes")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Offline")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"cloud_off","type":"error"},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_vm._v("You are currently offline, Please try again later")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-container',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-dialog',{ref:"dateDialog",attrs:{"persistent":"","lazy":"","full-width":"","return-value":_vm.date,"width":"290px","disabled":_vm.disableTimeChangeOut},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","prepend-icon":"event","readonly":"","rules":_vm.timeRules,"disabled":_vm.disableTimeChangeOut},slot:"activator",model:{value:(_vm.formatDate),callback:function ($$v) {_vm.formatDate=$$v},expression:"formatDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"actions":"","full-width":"","min":_vm.latestJobEndDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dateDialog.save(_vm.date)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-dialog',{ref:"timeDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"fit-content","return-value":_vm.time,"disabled":_vm.disableTimeChangeOut},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Time","prepend-icon":"access_time","readonly":"","rules":_vm.timeRules,"disabled":_vm.disableTimeChangeOut},slot:"activator",model:{value:(_vm.timeFormat),callback:function ($$v) {_vm.timeFormat=$$v},expression:"timeFormat"}}),_vm._v(" "),_c('b-timepicker',{attrs:{"inline":"","size":"is-large","placeholder":"Click to select...","icon":"clock","time-parser":_vm.formatTimeStringToDate,"time-format":_vm.formatTimeDateToString,"min-time":_vm.minEndTime,"hour-format":"24"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timeDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.timeDialog.save(_vm.time)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),(_vm.applicationMode === 'tacho' && _vm.spanMidnight)?_c('span',{staticClass:"warning--text"},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"warning"}},[_vm._v("warning")]),_vm._v("Shifts spanning midnight are unable to be added as tachograph days")],1):_vm._e(),_vm._v(" "),(_vm.nightOutRefType !== 'off' && _vm.nightOutRefType !== 'yes/no')?_c('v-text-field',{attrs:{"label":"Night Out Reference","prepend-icon":"hotel","type":_vm.nightOutRefType,"rules":_vm.nightOutRules},model:{value:(_vm.nightOut),callback:function ($$v) {_vm.nightOut=$$v},expression:"nightOut"}}):_vm._e(),_vm._v(" "),(_vm.nightOutRefType === 'yes/no')?_c('v-select',{attrs:{"label":"Night Out","prepend-icon":"hotel","items":[
              {value: '1', text: 'Yes'},
              {value: '', text: 'No'} ]},model:{value:(_vm.nightOut),callback:function ($$v) {_vm.nightOut=$$v},expression:"nightOut"}}):_vm._e(),_vm._v(" "),(_vm.has_bonus)?_c('v-text-field',{attrs:{"label":"Drops/Collections Total","type":"number"},model:{value:(_vm.bonus),callback:function ($$v) {_vm.bonus=$$v},expression:"bonus"}}):_vm._e(),_vm._v(" "),_c('v-textarea',{attrs:{"label":"Notes","maxlength":"255"},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.loading,"block":"","disabled":!_vm.formValid},on:{"click":_vm.clockOut}},[_vm._v("Confirm End")])],1),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.gpsStatus))]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.tachoDayPrompt),callback:function ($$v) {_vm.tachoDayPrompt=$$v},expression:"tachoDayPrompt"}},[_c('v-card',[_c('v-card-title',[_vm._v("Tachograph Day")]),_vm._v(" "),_c('v-card-text',[_vm._v("Would you like to add this shift as a tachograph day?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","dark":"","color":"error","disabled":_vm.addingTachoDay},on:{"click":function($event){_vm.tachoDayPrompt = false;_vm.submitClockOut()}}},[_vm._v("\n            No\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","dark":"","color":"success","loading":_vm.addingTachoDay},on:{"click":_vm.addTachoDay}},[_vm._v("\n            Yes\n          ")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.tachoService.status === 1 ? 'success' : 'error',"multi-line":"","timeout":_vm.tachoService.status === 1 ? 8000 : 0},model:{value:(_vm.tachoService.snackbar),callback:function ($$v) {_vm.$set(_vm.tachoService, "snackbar", $$v)},expression:"tachoService.snackbar"}},[_vm._v("\n          "+_vm._s(_vm.tachoService.msg)+"\n          "),(_vm.tachoService.closeable)?_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.tachoService.snackbar = false}}},[_vm._v("\n            Close\n          ")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoveryModeFormComponent_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e3c81c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoveryModeFormComponent_vue__ = __webpack_require__(450);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoveryModeFormComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e3c81c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoveryModeFormComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.completeDialog),callback:function ($$v) {_vm.completeDialog=$$v},expression:"completeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Request Successful")]),_vm._v(" "),_c('v-card-text',[_vm._v("Your request has been successfully sent to the server.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.refreshApp}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Offline")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"cloud_off","type":"error"},model:{value:(_vm.errorDialog),callback:function ($$v) {_vm.errorDialog=$$v},expression:"errorDialog"}},[_vm._v("You are currently offline, Please try again later")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.refreshApp}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":""},model:{value:(_vm.errorDateDialog),callback:function ($$v) {_vm.errorDateDialog=$$v},expression:"errorDateDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Shift Conflict")]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"icon":"mdi-clock-alert","type":"error"},model:{value:(_vm.errorDateDialog),callback:function ($$v) {_vm.errorDateDialog=$$v},expression:"errorDateDialog"}},[_vm._v("You have already clocked in with this start time")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","to":"/"}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-container',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-select',{attrs:{"label":"Clock In/Out","items":['In', 'Out']},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}}),_vm._v(" "),_c('v-dialog',{ref:"dateDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"290px","return-value":_vm.date},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.mode === 'In' ? 'Start Date' : 'End Date',"prepend-icon":"event","readonly":"","rules":_vm.timeRules},slot:"activator",model:{value:(_vm.formatDate),callback:function ($$v) {_vm.formatDate=$$v},expression:"formatDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"actions":"","full-width":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.dateDialog.save(_vm.date)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-dialog',{ref:"timeDialog",attrs:{"persistent":"","lazy":"","full-width":"","width":"fit-content","return-value":_vm.time},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.mode === 'In' ? 'Start Time' : 'End Time',"prepend-icon":"access_time","readonly":"","rules":_vm.timeRules},slot:"activator",model:{value:(_vm.timeFormat),callback:function ($$v) {_vm.timeFormat=$$v},expression:"timeFormat"}}),_vm._v(" "),_c('b-timepicker',{attrs:{"inline":"","size":"is-large","placeholder":"Click to select...","icon":"clock","time-parser":_vm.formatTimeStringToDate,"time-format":_vm.formatTimeDateToString,"hour-format":"12"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timeDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.timeDialog.save(_vm.time)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),(_vm.mode === 'In')?_c('v-select',{ref:"loadSelect",attrs:{"label":"Load Numbers","prepend-icon":"local_shipping","chips":"","tags":"","clearable":"","type":"text","append-icon":""},nativeOn:{"keyup":function($event){return _vm.getCharCode.apply(null, arguments)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"close":"","selected":data.selected,"color":"primary white--text"},on:{"input":function($event){return _vm.remove(data.item)}}},[_vm._v("\n              "+_vm._s(data.item)+" \n            ")])]}}],null,false,1334909664),model:{value:(_vm.load),callback:function ($$v) {_vm.load=$$v},expression:"load"}}):_c('v-text-field',{attrs:{"label":"Night Out Reference","prepend-icon":"hotel","type":"number","rules":_vm.nightOutRules},model:{value:(_vm.nightOut),callback:function ($$v) {_vm.nightOut=$$v},expression:"nightOut"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.loading,"block":"","disabled":!_vm.formValid},on:{"click":_vm.submitClockIn}},[_vm._v("Confirm "+_vm._s(_vm.mode === 'In' ? 'Start' : 'End'))])],1)],1),_vm._v(" "),_c('Disclaimer-Dialog',{attrs:{"show-dialog":_vm.displayDisclaimer},on:{"update:showDialog":function($event){_vm.displayDisclaimer=$event},"update:show-dialog":function($event){_vm.displayDisclaimer=$event},"declined":_vm.disclaimerAction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisclaimerDialog_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c8f0a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisclaimerDialog_vue__ = __webpack_require__(452);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisclaimerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c8f0a9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisclaimerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('h3',{staticClass:"display-1 grey--text text--darken-2 text-xs-center"},[_vm._v("Timesheet Disclaimer")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 white--text",attrs:{"block":"","depressed":""},on:{"click":function($event){_vm.translateDialog = true}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("translate")]),_vm._v(_vm._s(_vm.disclaimerLanguage))],1),_vm._v(" "),_c('p',{staticClass:"mt-3",domProps:{"innerHTML":_vm._s(_vm.disclaimerText)}})],1),_vm._v(" "),(!_vm.disclaimerAccepted)?_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"red--text text-xs-center mb-0"},[_c('b',[_vm._v("This disclaimer must be accepted before you can clock in.")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{staticClass:"success",attrs:{"block":""},on:{"click":_vm.acceptDisclaimer}},[_vm._v("Accept")])],1),_vm._v(" "),_c('v-flex',{attrs:{"offset-xs1":"","xs3":""}},[_c('v-btn',{staticClass:"error",attrs:{"block":""},on:{"click":_vm.declineDisclaimer}},[_vm._v("Decline")])],1)],1)],1):_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"green--text text-xs-center mb-0"},[_c('b',[_vm._v("You've already accepted the disclaimer.")])]),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-1 white--text",attrs:{"block":""},on:{"click":_vm.hideDisclaimer}},[_vm._v("Close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.translateDialog),callback:function ($$v) {_vm.translateDialog=$$v},expression:"translateDialog"}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"title"},[_vm._v("Disclaimer Language")])]),_vm._v(" "),_c('v-list',_vm._l((_vm.languages),function(language){return _c('v-list-tile',{key:language,attrs:{"avatar":""},on:{"click":function($event){return _vm.selectLanguage(language)}}},[_c('span',{staticClass:"body-1"},[_vm._v(_vm._s(language))])])}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeAlert_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0c623c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeAlert_vue__ = __webpack_require__(454);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e0c623c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":"primary","value":_vm.show}},[_c('span',[_c('strong',{staticClass:"white--text"},[_vm._v("Notice: ")]),_vm._v(_vm._s(_vm.alertText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLoadDialog_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6262da8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLoadDialog_vue__ = __webpack_require__(456);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLoadDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6262da8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLoadDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"450","persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('h3',{staticClass:"headline grey--text text--darken-2 text-xs-center"},[_vm._v("Add Additional Loads")])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{ref:"loadSelect",attrs:{"label":"Load Numbers","prepend-icon":"local_shipping","chips":"","multiple":"","clearable":"","deletable-chips":"","color":"primary"},model:{value:(_vm.load),callback:function ($$v) {_vm.load=$$v},expression:"load"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"success",attrs:{"disabled":_vm.load.length === 0,"loading":_vm.saving},on:{"click":_vm.addLoads}},[_vm._v("Add Loads")]),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-1 white--text",attrs:{"disabled":_vm.saving},on:{"click":_vm.close}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHolidayRequestDialog_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a308a1e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewHolidayRequestDialog_vue__ = __webpack_require__(489);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHolidayRequestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a308a1e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewHolidayRequestDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","persistent":"","value":_vm.showDialog,"transition":"dialog-bottom-transition"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("New Holiday Request")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('closeNewRequestDialog')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('div',{staticClass:"datepicker-trigger"},[_c('div',{staticClass:"text-xs-left"},[_c('div',{staticClass:"mt-3 text-xs-left"},[_c('h3',[_c('strong',[_vm._v("Requested Dates: ")])])]),_vm._v(" "),_c('div',{staticClass:"text-xs-left",attrs:{"id":"datepicker-trigger"}},[_vm._v(_vm._s(_vm.dateOne ? _vm.formatDates(_vm.dateOne, _vm.dateTwo) : 'Please select dates for you request'))]),_vm._v(" "),(_vm.canEditHolType == "1" && !_vm.dateConfirmed)?_c('v-layout',{attrs:{"classs":"mt-3","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.holidayTypes,"label":"Select A Holiday Type"},model:{value:(_vm.holiday_type),callback:function ($$v) {_vm.holiday_type=$$v},expression:"holiday_type"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && _vm.company !== 'lfp')?_c('div',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.hour)+":"+_vm._s(_vm.minute)+" - "+_vm._s(_vm.filteredEndShiftTime)+":"+_vm._s(_vm.minute)),(_vm.halfDay)?_c('span',[_vm._v(" - (Half Day)")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3 text-xs-left",staticStyle:{"display":"inline-block","margin-right":"5px"}},[_c('h3',[_c('strong',[_vm._v("Current Period:")])]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" - "+_vm._s(_vm._f("formatDate")(_vm.holAllowance.period_end,'DD/MM/YYYY')))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 text-xs-left",staticStyle:{"display":"inline-block"}},[_c('h3',[_c('strong',[_vm._v("Next Period:")])]),_vm._v(" "),_c('h1',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_start,'DD/MM/YYYY'))+" - "+_vm._s(_vm._f("formatNextHolPrdDate")(_vm.holAllowance.period_end,'DD/MM/YYYY')))])])],1),_vm._v(" "),(!_vm.dateConfirmed)?_c('AirbnbStyleDatepicker',{attrs:{"trigger-element-id":'datepicker-trigger',"mode":'range',"date-one":_vm.dateOne,"date-two":_vm.dateTwo,"inline":"","showActionButtons":false,"showShortcutsMenuTrigger":false},on:{"date-one-selected":function (val) { _vm.dateOne = val },"date-two-selected":function (val) { _vm.dateTwo = val }}}):_vm._e()],1),_vm._v(" "),(_vm.dateConfirmed && !_vm.detailsConfirmed)?_c('v-layout',{attrs:{"row":""}},[(_vm.workerType == '0' && _vm.company !== 'lfp')?[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-left"},[_c('h5',[_c('strong',[_vm._v("This will be your normal shift start time")])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-select',{attrs:{"items":_vm.allowedHours},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h1',{staticStyle:{"font-size":"44px"}},[_vm._v(":")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-select',{attrs:{"items":_vm.allowedMinutes},model:{value:(_vm.minute),callback:function ($$v) {_vm.minute=$$v},expression:"minute"}})],1)],1)],1)]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && !_vm.detailsConfirmed)?_c('v-layout',{attrs:{"row":""}},[(_vm.showHalfDay === '1')?_c('v-container',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-switch',{attrs:{"ml2":"","inset":"","label":"Half Day"},model:{value:(_vm.halfDay),callback:function ($$v) {_vm.halfDay=$$v},expression:"halfDay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[(_vm.workerType != '0')?_c('v-switch',{attrs:{"ml2":"","disabled":!_vm.halfDay,"inset":"","label":"Afternoon"},model:{value:(_vm.halfDayPM),callback:function ($$v) {_vm.halfDayPM=$$v},expression:"halfDayPM"}}):_vm._e()],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && _vm.detailsConfirmed)?_c('v-layout',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"margin-top":"10px"},attrs:{"id":"enoughDaysForHoliday"}},[_c('h4',[(!_vm.isButtonDisabled && this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1)?_c('strong',{staticStyle:{"color":"#008900"}},[_vm._v("You Have Enough Holiday Allowance For The Holiday Request")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"notEnoughDaysForHoliday"}},[_c('h4',[(_vm.isButtonDisabled && this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1)?_c('strong',{staticStyle:{"color":"#EE0000"}},[_vm._v("Not Enough Holiday Allowance For Holiday Request")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"noDaysSelected"}},[_c('h4',[(this.whitelistedDates.length === 0 && this.selectedDateNextPeriodBeforeRelease !== 1)?_c('strong',{staticStyle:{"color":"#D54200"}},[_vm._v("No Holiday Days Selected")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"noNextPeriodDaysSelected"}},[_c('h4',[(this.selectedDateNextPeriodBeforeRelease === 1)?_c('strong',{staticStyle:{"color":"#D54200"}},[_vm._v("You are not allowed to request an absence for the Next Period before "+_vm._s(this.dateOfThresholdForNextPeriod)+".")]):_vm._e()])]),_vm._v(" "),(this.whitelistedDates.length > 0 && this.selectedDateNextPeriodBeforeRelease !== 1)?_c('div',{style:({ 'border': 'solid 2px', 'border-color': _vm.getBorderColour(), 'border-radius': '4px' })},[(this.subTotalDays > 0)?_c('div',{staticStyle:{"margin-top":"16px"}},[_c('p',[_vm._v("Holiday Type: "),_c('strong',[_vm._v(_vm._s(_vm.holidayTypeText))])]),_vm._v(" "),_c('p',[_vm._v("Total days wanted from current period: "),_c('strong',[_vm._v(_vm._s(this.subTotalDays))])]),_vm._v(" "),_c('p',[_vm._v("Days remaining of current period:\n                "),(this.subTotalDays > 0 && (_vm.enoughDaysForHolidayThisYear === false && this.whitelistedDates.length > 0))?_c('strong',{staticStyle:{"border-color":"#EE0000"}},[_vm._v(_vm._s(this.holAllowance.total_days_left))]):_vm._e(),_vm._v(" "),(this.subTotalDays > 0 && (_vm.enoughDaysForHolidayThisYear === true && this.whitelistedDates.length > 0))?_c('strong',{staticStyle:{"border-color":"#008900"}},[_vm._v(_vm._s(this.holAllowance.total_days_left))]):_vm._e()]),_vm._v(" "),(this.holAllowance.currentLieuAllowance > 0)?_c('div',[_c('p',[_vm._v("Lieu days remaining for current period: "),_c('strong',[_vm._v(_vm._s(this.holAllowance.currentLieuAllowance))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(this.subTotalDaysNextYear > 0)?_c('div',[_c('p',[_vm._v("Total days wanted from next period: "),_c('strong',[_vm._v(_vm._s(this.subTotalDaysNextYear))])]),_vm._v(" "),_c('p',[_vm._v("Days remaining of next period:\n                "),(this.subTotalDaysNextYear > 0 && (_vm.enoughDaysForHolidayNextYear === false && this.whitelistedDates.length > 0))?_c('strong',{staticStyle:{"border-color":"#EE0000"}},[_vm._v(_vm._s(this.holAllowance.total_next_period_days_left))]):_vm._e(),_vm._v(" "),(this.subTotalDaysNextYear > 0 && (_vm.enoughDaysForHolidayNextYear === true && this.whitelistedDates.length > 0))?_c('strong',{staticStyle:{"border-color":"#008900"}},[_vm._v(_vm._s(this.holAllowance.total_next_period_days_left))]):_vm._e()]),_vm._v(" "),(this.holAllowance.nextLieuAllowance > 0)?_c('div',[_c('p',[_vm._v("Lieu days remaining for next period: "),_c('strong',[_vm._v(_vm._s(this.holAllowance.nextLieuAllowance))])])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"0px 0px 10px 0px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin-top":"10px"}},[_c('v-date-picker',{staticStyle:{"margin-top":"10px"},attrs:{"allowed-dates":_vm.allowedWhitelistDate,"multiple":"","show-current":"false"},model:{value:(_vm.whitelistedDates),callback:function ($$v) {_vm.whitelistedDates=$$v},expression:"whitelistedDates"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('h4',[_vm._v("Please check the highlighted dates before submitting request")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('v-text-field',{attrs:{"label":"Add any notes or comments here"},model:{value:(_vm.requestComment),callback:function ($$v) {_vm.requestComment=$$v},expression:"requestComment"}})],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.gettingExistingRequests)?_c('v-layout',[_c('h3',[_c('strong',[_vm._v("Fetching Existing Requests...")])])]):_vm._e(),_vm._v(" "),(_vm.listOfSelectedDatesWithCounts.length > 0 && _vm.bookingThresholdSettingValue > 0)?_c('v-layout',{attrs:{"row":""}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',{staticStyle:{"text-align":"left"}},[_c('strong',[_vm._v("Other Employee Holidays On These Dates:")])]),_vm._v(" "),_c('ul',{staticStyle:{"text-align":"left","padding-left":"0px","list-style-type":"none"}},_vm._l((_vm.listOfSelectedDatesWithCounts),function(item){return _c('li',{key:item.date,staticStyle:{"text-align":"left"},style:({ color: (_vm.bookingThreshold !== -1 && _vm.bookingThreshold !== undefined && item.count >= _vm.bookingThreshold) ? '#EE0000' : '#008900' })},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"flex-start"}},[_c('div',[_c('span',{staticStyle:{"display":"inline-block","width":"75px"}},[_vm._v(_vm._s(item.dayOfWeek))]),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","width":"85px"}},[_vm._v(_vm._s(item.dateFormatted))]),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","width":"85px"}},[_vm._v(" - "+_vm._s(item.count)+" Booking"+_vm._s(item.count === 1 ? '' : 's'))])])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.disableBtnForOtherBookings === true)?_c('h3',{staticStyle:{"text-align":"left","color":"#EE0000"}},[_c('strong',[_vm._v("There are too many existing bookings on some of the selected dates")])]):_vm._e(),_vm._v(" "),(!_vm.dateConfirmed)?_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","block":"","disabled":_vm.dateOne == '' || _vm.dateTwo == '' || _vm.disableBtnForOtherBookings || (_vm.bookingThresholdSettingValue > 0 && _vm.gettingExistingRequests == true)},on:{"click":function($event){_vm.dateConfirmed = true}}},[_vm._v("Confirm Date Range")]):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && !_vm.detailsConfirmed)?_c('v-btn',{staticClass:"mb-4",attrs:{"color":"warning","block":"","disabled":_vm.loading},on:{"click":function($event){_vm.dateConfirmed = false}}},[_vm._v("Edit Date Range")]):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && !_vm.detailsConfirmed)?_c('v-btn',{staticClass:"mb-4",attrs:{"color":"success","block":"","disabled":_vm.loading},on:{"click":function($event){_vm.detailsConfirmed = true}}},[_vm._v("Submit Request Details")]):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && _vm.detailsConfirmed)?_c('v-btn',{staticClass:"mb-4",attrs:{"color":"warning","block":"","disabled":_vm.loading},on:{"click":function($event){_vm.detailsConfirmed = false}}},[_vm._v("Edit Request Details")]):_vm._e(),_vm._v(" "),(_vm.dateConfirmed && _vm.detailsConfirmed)?_c('v-btn',{staticClass:"mb-4",attrs:{"color":"success","block":"","disabled":_vm.isButtonDisabled || _vm.selectedDateNextPeriodBeforeRelease === 1},on:{"click":function($event){return _vm.submitRequest()}}},[_vm._v("Submit Holiday Request")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('Another-Holiday-Request-Dialog',{staticClass:"mb-4",attrs:{"showDialog":_vm.anotherRequest},on:{"anotherRequest":function($event){_vm.anotherRequest = false},"returnToOverview":function($event){_vm.anotherRequest = false; _vm.$emit('closeNewRequestDialog')}}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHolidayRequestDialog_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad7e734_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHolidayRequestDialog_vue__ = __webpack_require__(491);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditHolidayRequestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad7e734_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditHolidayRequestDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.showThisDialog),callback:function ($$v) {_vm.showThisDialog=$$v},expression:"showThisDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Edit Holiday Request")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('closeEditRequestDialog')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"warning","block":"","disabled":_vm.requestObj.actioned !== 0},on:{"click":function($event){return _vm.removeHolRequest(_vm.requestObj.ID)}}},[_vm._v("Cancel Request")]),_vm._v(" "),_c('v-btn',{staticClass:"mb-4",attrs:{"color":"warning","block":"","disabled":_vm.requestObj.actioned !== 1 || _vm.isLessThan48HoursAway(_vm.requestObj.start)},on:{"click":function($event){return _vm.requestHolCancellation(_vm.requestObj.ID)}}},[_vm._v("Request Holiday Cancellation")]),_vm._v(" "),(_vm.isLessThan48HoursAway(_vm.requestObj.start))?_c('p',{staticStyle:{"color":"#B50000"}},[_vm._v("Less than "+_vm._s(_vm.cancelHours)+"hours before Holiday, cannot request cancellation.")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnotherHolidayRequestDialog_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0223959c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnotherHolidayRequestDialog_vue__ = __webpack_require__(493);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnotherHolidayRequestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0223959c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnotherHolidayRequestDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-dialog',{attrs:{"width":"500","value":_vm.showDialog}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Make another request?")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('returnToOverview')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"mb-4",attrs:{"block":""},on:{"click":function($event){return _vm.$emit('anotherRequest')}}},[_vm._v("Make another request")]),_vm._v(" "),_c('v-btn',{staticClass:"mb-4",attrs:{"block":""},on:{"click":function($event){return _vm.$emit('returnToOverview')}}},[_vm._v("Back to overview")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSchengenRequest_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3dbfba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSchengenRequest_vue__ = __webpack_require__(495);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditSchengenRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3dbfba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditSchengenRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","persistent":"","value":_vm.showDialog,"transition":"dialog-bottom-transition"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Edit Schengen Trip")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('closeEditSchengenRequest')}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('div',{staticClass:"datepicker-trigger"},[_c('div',{staticClass:"text-xs-left"},[_c('div',{staticClass:"mt-3 text-xs-left"},[_c('h3',[_c('strong',[_vm._v("Schengen Trip Dates: ")])])]),_vm._v(" "),_c('div',{staticClass:"text-xs-left",attrs:{"id":"edit-datepicker-trigger"}},[_vm._v(_vm._s(_vm.dateOne ? _vm.formatDates(_vm.dateOne, _vm.dateTwo) : 'Please select dates for the Schengen trip'))]),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.schengenCountries,"label":"Select A Country"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.code)?_c('span',{class:'flag flag-' + data.item.code,staticStyle:{"margin-right":"10px"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.item.text)+"\n                      ")]}},{key:"item",fn:function(data){return [(data.item.code)?_c('span',{class:'flag flag-' + data.item.code,staticStyle:{"margin-right":"10px"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.item.text)+"\n                      ")]}}]),model:{value:(_vm.selected_country),callback:function ($$v) {_vm.selected_country=$$v},expression:"selected_country"}})],1)],1)],1),_vm._v(" "),_c('AirbnbStyleDatepicker',{attrs:{"trigger-element-id":'edit-datepicker-trigger',"mode":'range',"date-one":_vm.dateOne,"date-two":_vm.dateTwo,"inline":"","showActionButtons":false,"showShortcutsMenuTrigger":false},on:{"date-one-selected":function (val) { _vm.dateOne = val },"date-two-selected":function (val) { _vm.dateTwo = val }}})],1)]),_vm._v(" "),(!_vm.selected_country)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('h4',[_vm._v("Please select a country")])])],1):_vm._e(),_vm._v(" "),(_vm.dateOne == '' || _vm.dateTwo == '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"margin":"0px 0px 15px 0px"}},[_c('h4',[_vm._v("Please select dates for the Schengen trip")])])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","block":"","disabled":_vm.dateOne == '' || _vm.dateTwo == '' || !_vm.selected_country},on:{"click":_vm.saveTrip}},[_vm._v("Save Changes")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timesheet__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__expenses__ = __webpack_require__(422);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    timesheet: __WEBPACK_IMPORTED_MODULE_3__timesheet__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_4__shared__["a" /* default */],
    expenses: __WEBPACK_IMPORTED_MODULE_5__expenses__["a" /* default */]
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false,
      fixed: false,
      title: 'T & A',
      connected: true,
      disclaimer: false
    };
  },
  created: function created() {},

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    hasDisclaimer: function hasDisclaimer() {
      if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
        return false;
      } else {
        return true;
      }
    },
    appOutdated: function appOutdated() {
      return this.$store.getters.appOutdated;
    },
    applicationMode: function applicationMode() {
      return this.$store.getters.applicationMode;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/SignIn');
    },
    showDisclaimer: function showDisclaimer() {
      this.disclaimer = true;
    },
    resetApp: function resetApp() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('tanda-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GlobalMessage_vue__ = __webpack_require__(369);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000,
      loadDialog: false,
      company: this.$store.getters.company,
      timer: this.$store.getters.signoutInterval * 60,
      timerDefault: this.$store.getters.signoutInterval * 60,
      defaultModules: { timesheets: 1, expenses: 1, viewexpenses: 1, pod: 0, holrequest: 1 },
      jobStarted: false,
      anyJobsInShift: false,
      savedJobData: [],
      url: this.$store.getters.url,
      standardShiftDetails: [],
      taSettings: [],
      timelineFailed: false,
      loadingTimeline: false,
      emp: this.$store.getters.user,
      showExpenses: null,
      dialogVisible: false,
      showGlobalMessage: true,
      penaltyDialog: false,
      penaltyReason: '',
      penaltyName: ''
    };
  },
  created: function created() {
    this.getViewExpensesSetting();
    this.$store.dispatch('fetchTimesheet');
    if (this.$store.getters.company.toLowerCase() === 'freshlinc') {
      this.$store.dispatch('setApplicationMode', 'tanda');
      localStorage.setItem('applicationMode', 'tanda');
      this.defaultModules.pod = 1;
    }
    if (this.$store.getters.company.toLowerCase() === 'lfp') {
      this.$store.dispatch('setApplicationMode', 'tanda');
      localStorage.setItem('applicationMode', 'tanda');
      this.modules.jobEntry = localStorage.getItem('jobRecording') * 1;
    }
    if (this.$store.getters.company.toLowerCase() === 'aquahaulage') {
      this.modules.jobEntry = localStorage.getItem('jobRecording') * 1;
    }
    if (this.$store.getters.company.toLowerCase() === 'aquashow') {
      this.defaultModules.pod2 = 1;
    }
    this.$store.dispatch('setModules', this.defaultModules);
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('checkLoginTime');
    if (this.timer > 0) {
      var interval = setInterval(function () {
        _this.timer--;
        if (_this.timer === 0) {
          _this.$store.dispatch('logout');
          clearInterval(interval);
        }
      }, 1000);
    }

    this.getPenaltyNameSetting();
    this.getTASettings();
  },

  methods: {
    getTASettings: function getTASettings() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getTASettings.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this2.taSettings = response.data;
        _this2.$store.dispatch('setTASettings', response.data);
      }).catch(function (e) {
        console.log(e);
      });
    },
    getPenaltyNameSetting: function getPenaltyNameSetting() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getPenaltyNameSetting.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this3.penaltyName = response.data[0].value;
      }).catch(function (e) {
        console.log(e);
      });
    },
    showPenaltyReason: function showPenaltyReason(reason) {
      this.penaltyReason = reason;
      this.penaltyDialog = true;
    },
    zeroFill: function zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
      }
      return number;
    },
    getViewExpensesSetting: function getViewExpensesSetting() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getShowExpensesSetting.ajax.php', {
        company: this.company
      }).then(function (response) {
        _this4.showExpenses = response.data[0].value;
      }).catch(function (e) {
        console.log(e);
      });
    },
    getCurrentJobDetails: function getCurrentJobDetails(clockedIn, id) {
      var _this5 = this;

      if (!clockedIn && id.length > 0) {
        this.loadingTimeline = true;
        this.timelineFailed = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.url + '/tanda-service/getCurrentJobList.ajax.php', {
          company: this.company,
          type: 'all',
          ta_id: id,
          currentJobID: -1
        }).then(function (response) {
          console.log(response);
          _this5.jobStarted = false;
          _this5.savedJobData = response.data.jobDetails;
          _this5.anyJobsInShift = response.data.jobDetails.length > 0;
          for (var job in response.data.jobDetails) {
            var currentJob = response.data.jobDetails[job];
            currentJob.start_time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format();
            if (currentJob.end_time == null) {
              _this5.jobStarted = true;
              _this5.latestJobId = currentJob.job_id;
            } else {
              currentJob.end_time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().format();
            }
          }

          _this5.savedJobData.sort(function (a, b) {
            return new Date(b.start_time) - new Date(a.start_time);
          });
          _this5.loadingTimeline = false;
          if (_this5.anyJobsInShift) {
            var latestJobTime = _this5.savedJobData[0].end_time;
            sessionStorage.setItem('latestJobEndTime', latestJobTime);
          }
        }).catch(function (e) {
          _this5.timelineFailed = true;
          console.log(e);
        });
      }
    }
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.user.modules;
    },
    fullname: function fullname() {
      return this.$store.getters.user ? this.$store.getters.user.fname + ' ' + this.$store.getters.user.sname : '';
    },
    timesheetData: function timesheetData() {
      var timesheetData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.getters.timesheet));
      return timesheetData.reverse().splice(0, 5);
    },
    taId: function taId() {
      var output = this.timesheetData[0] && this.timesheetData[0]['id'] ? this.timesheetData[0]['id'] : '';
      if ((output !== '' || output !== null) && this.modules.jobEntry === 1) {
        var clockedIn = this.clockedIn;
        this.getCurrentJobDetails(clockedIn, output);
      }
      return output;
    },
    clockedIn: function clockedIn() {
      if (this.timesheetData[0] !== undefined) {
        return this.timesheetData[0].end !== undefined;
      } else {
        return true;
      }
    },
    logoutCountdown: function logoutCountdown() {
      var d = this.timer;
      d = Number(d);
      var h = this.zeroFill(Math.floor(d / 3600), 2);
      var m = this.zeroFill(Math.floor(d % 3600 / 60), 2);
      var s = this.zeroFill(Math.floor(d % 3600 % 60), 2);

      return h + ':' + m + ':' + s;
    }
  },
  filters: {
    formattedJobLength: function formattedJobLength(job) {
      if (job.end_time === null || job.end_time === undefined) {
        return '';
      }
      var hrs = __WEBPACK_IMPORTED_MODULE_2_moment___default()(job.end_time).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(job.start_time), 'hours');
      var mins = __WEBPACK_IMPORTED_MODULE_2_moment___default()(job.end_time).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(job.start_time), 'minutes') % 60;
      return hrs + 'h ' + mins + 'm';
    },
    formatDate: function formatDate(val) {
      return val !== undefined && val !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(val, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
    formatDateTime: function formatDateTime(val) {
      return val !== undefined && val !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(val, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm') : '--';
    },
    filterJobTime: function filterJobTime(val) {
      if (val == null) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format('HH:mm');
    },
    formatTime: function formatTime(val) {
      if (val == null) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().startOf('day').add(val, 'minutes').format('HH:mm');
    }
  },
  components: {
    GlobalMessage: __WEBPACK_IMPORTED_MODULE_3__GlobalMessage_vue__["a" /* default */]
  }

});

/***/ })

},[326]);


// WEBPACK FOOTER //
// static/js/app.73b0ae1d94747debc72b.js